webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(15);




__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
var state = {
  isAppLoaded: false,
  isHomeAnimActive: true,
  isMenuOpen: false,
  lang: localStorage.getItem('lang') || 'en',
  isModalOpen: false,
  animation: null,
  currentAnimation: null,
  isModalVideoOpen: false,
  videoModalSrc: null,
  isBlog: false,
  isCanvasVisible: false,
  isCanvasLoaded: false,
  isScrollTopVisible: false,
  modalQuestionName: '',
  isAccessibilityVisible: false,
  isPageContrasted: false,
  isPageFontBigger: false,
  showPARP: false,
  showPAIH: false,
  modalStaticVideoType: 'presentation'
};
var player = null;
var mutations = {
  LOAD_ANIMATION: function LOAD_ANIMATION(state, options) {
    fetch(options.link).then(function (res) {
      return res.json();
    }).then(function (json) {
      state.animation = json;
      player.setAnimation(json);
      if (options.cb) {
        options.cb();
      }
    });
  },
  SET_SCROLL_TOP_VISIBLE: function SET_SCROLL_TOP_VISIBLE(state, flag) {
    state.isScrollTopVisible = flag;
  },
  CLEAR_GROUND: function CLEAR_GROUND(state) {
    player.clearGround();
  },
  HIDE_CANVAS: function HIDE_CANVAS(state) {
    player.hideScene();
    state.isCanvasVisible = false;
  },
  SHOW_CANVAS: function SHOW_CANVAS(state) {
    player.resetCamera();
    state.isCanvasVisible = true;
  },
  HOME_ANIM_FINISHED: function HOME_ANIM_FINISHED(state) {
    state.isHomeAnimActive = false;
  },
  PLAY_NEXT: function PLAY_NEXT(state) {
    player.animationManager.playAnimation();
  },
  PLAY_FOREST_PRESENTATION: function PLAY_FOREST_PRESENTATION(state, cb) {
    player.setOnPause(cb);
    player.forestClick();
  },
  PLAY_FARM_PRESENTATION: function PLAY_FARM_PRESENTATION(state, cb) {
    player.setOnPause(cb);
    player.farmClick();
  },
  PLAY_AIRPORT_PRESENTATION: function PLAY_AIRPORT_PRESENTATION(state, cb) {
    player.setOnPause(cb);
    player.airportClick();
  },
  ADD_PRODUCTS_MOUSE_EVENTS: function ADD_PRODUCTS_MOUSE_EVENTS(state, options) {},
  FARM_MOUSE_HOVER: function FARM_MOUSE_HOVER(state) {
    player.farmMouseHover();
  },
  FARM_MOUSE_LEAVE: function FARM_MOUSE_LEAVE(state) {
    player.farmMouseLeave();
  },
  AIRPORT_MOUSE_HOVER: function AIRPORT_MOUSE_HOVER(state) {
    player.airportMouseHover();
  },
  AIRPORT_MOUSE_LEAVE: function AIRPORT_MOUSE_LEAVE(state) {
    player.airportMouseLeave();
  },
  FOREST_MOUSE_HOVER: function FOREST_MOUSE_HOVER(state) {
    player.forestMouseHover();
  },
  FOREST_MOUSE_LEAVE: function FOREST_MOUSE_LEAVE(state) {
    player.forestMouseLeave();
  },
  ADD_HOME_MOUSE_EVENTS: function ADD_HOME_MOUSE_EVENTS(state, options) {
    player.initMouseEvents(options);
  },
  CLEAR_HOME_MOUSE_EVENTS: function CLEAR_HOME_MOUSE_EVENTS(state) {},
  SET_MOBILE_ACTIVE: function SET_MOBILE_ACTIVE(state, options) {
    player.setMobileActive(options.ground, options.dir);
  },
  SHOW_GROUNDS: function SHOW_GROUNDS(state) {
    player.showGrounds();
  },
  INIT_CANVAS_PLAYER: function INIT_CANVAS_PLAYER(state, options) {
    player = new Player(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(options, {
      animation: state.animation,
      init: function init() {
        state.isCanvasVisible = true;
        state.isCanvasLoaded = true;
      }
    }));
    window.player = player;
  },
  INIT_GROUNDS: function INIT_GROUNDS(state) {
    state.isAppLoaded = true;
    player.initGrounds();
  },
  SHOW_LOADER_FINISH: function SHOW_LOADER_FINISH(state, cb) {
    player.showLoaderFinish(cb);
  },
  LOAD_ANIMATION_OBJECTS: function LOAD_ANIMATION_OBJECTS(state, cb) {
    player.startDownload(cb);
  },
  TOGGLE_MENU: function TOGGLE_MENU(state) {
    state.isMenuOpen = !state.isMenuOpen;
    if (state.isMenuOpen) {
      state.isModalOpen = false;
      state.modalQuestionName = '';
    }
  },
  CLOSE_MENU: function CLOSE_MENU(state) {
    if (state.isMenuOpen) state.isMenuOpen = false;
  },
  SET_LANG: function SET_LANG(state, lang) {
    localStorage.setItem('lang', lang);
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.lang = lang;
    state.lang = lang;
  },
  SET_MODAL: function SET_MODAL(state, options) {
    state.isModalOpen = options.visible;
    state.isMenuOpen = false;
    state.modalQuestionName = options.questionName;
  },
  OPEN_VIDEO_MODAL: function OPEN_VIDEO_MODAL(state, src) {
    state.isModalVideoOpen = true;
    state.videoModalSrc = src;
  },
  CLOSE_VIDEO_MODAL: function CLOSE_VIDEO_MODAL(state, src) {
    state.isModalVideoOpen = false;
    state.videoModalSrc = src;
  },
  TOGGLE_PAGE_CONTRAST: function TOGGLE_PAGE_CONTRAST(state) {
    state.isPageContrasted = !state.isPageContrasted;
  },
  TOGGLE_PAGE_FONT_SIZE: function TOGGLE_PAGE_FONT_SIZE(state) {
    state.isPageFontBigger = !state.isPageFontBigger;
  },
  SET_ACCESIBILITY: function SET_ACCESIBILITY(state, src) {
    console.log('src', src);
    console.log('state', state);
    state.isAccessibilityVisible = src;
  },
  SET_MODAL_STATIC_VIDEO_TYPE: function SET_MODAL_STATIC_VIDEO_TYPE(state, type) {
    state.modalStaticVideoType = type;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  mutations: mutations
}));

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var scrollTo = function scrollTo(e) {
    var offset = parseInt(e.currentTarget.dataset.scrollOffset) || 0;
    if (e.currentTarget.href) {
        e.preventDefault();
        var el = '#' + e.currentTarget.href.split('#')[1];
        smoothScroll.animateScroll(document.querySelector(el), null, { offset: offset });
    } else {
        smoothScroll.animateScroll(offset);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (scrollTo);

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(210)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(294),
  /* scopeId */
  "data-v-4fcb7c94",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(111),
  /* template */
  __webpack_require__(278),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(205)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(109),
  /* template */
  __webpack_require__(289),
  /* scopeId */
  "data-v-3e6c4baa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(282),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(200)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(112),
  /* template */
  __webpack_require__(281),
  /* scopeId */
  "data-v-1cda3a6b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(195)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(114),
  /* template */
  __webpack_require__(274),
  /* scopeId */
  "data-v-0ae9d7ee",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return en; });
var baseTitle = 'Bioseco - solutions for bird protection';

var en = {
  "go_up": "top",
  page_titles: {
    home: baseTitle,
    products: "Products | " + baseTitle,
    farm: "Solution for Wind Farms | " + baseTitle,
    airport: "Innovative system for preventing bird-aircraft collisions | " + baseTitle,
    area: "Solution for ornithologists | " + baseTitle,
    farmPresentation: "Solution for Wind Farms | " + baseTitle,
    airportPresentation: "Innovative system for preventing bird-aircraft collisions | " + baseTitle,
    areaPresentation: "Solution for ornithologists | " + baseTitle,
    about: "About | " + baseTitle,
    blog: "Blog | " + baseTitle,
    contact: "Contact | " + baseTitle,
    auctions: baseTitle,
    projects: 'Projects co-financed by the EU',
    awards: "Awards | " + baseTitle,
    grants: "Grants | " + baseTitle,
    certificates: "Certificates | " + baseTitle,
    privacy: "Privacy policy | " + baseTitle,
    bps: "Bird Protection System for Wind Farms | " + baseTitle,
    afms: "Airport Fauna Monitoring System | " + baseTitle,
    bridgealfa: "Bridge Alfa | " + baseTitle,
    pmt: "Polish Technology Bridge to USA | " + baseTitle,
    eic: "Support in preparation of application and FS for EIC Accelerator Pilot | " + baseTitle,
    bps2: "Bird Protection System | " + baseTitle,
    pbe: "Project PBE Grant | " + baseTitle,
    pbe2: "Project PBE Grant 2 | " + baseTitle,
    ppbb: "Promotion of the Product Brand BIOSECO | " + baseTitle,
    offshore: "Comprehensive protection of birds around offshore wind farms | " + baseTitle,
    infonews: "News | " + baseTitle
  },
  menu: {
    home: 'Home',
    products: {
      title: 'Products',
      farms: 'For wind farm',
      airports: "For airports",
      ornithologists: "For ornithologists"
    },
    certs: 'Certificates',
    awards: 'Awards',
    grants: {
      title: 'Grants',
      bps: 'Bird Protection System for Wind Farms',
      afms: 'Airport Fauna Monitoring System',
      ba: 'Bridge Alfa',
      pmt: 'Polish Technology Bridge to USA',
      eic: 'Support in preparation of application and FS for EIC Accelerator Pilot',
      bps2: 'Bird Protection System',
      pbe: 'Project PBE Grant',
      pbe2: 'Project PBE Grant 2',
      ppbb: 'Promotion of the Product Brand BIOSECO',
      offshore: 'Comprehensive protection of birds around offshore wind farms'
    },
    news: 'News',
    about: 'About us',
    blog: "Blog",
    contact: "Contact",
    ask: "Ask question",
    english: "English",
    polish: "Polski",
    deutch: "Deutch",
    project: 'Projects co-financed by the EU'
  },
  certs: {
    headingTopText: 'Bioseco Certificates',
    seeCerts: 'See our certificates'
  },
  awards: {
    hedingTopText: 'Bioseco Awards',
    seeAwards: 'See our awards',
    list: {
      1: "Geneva-Brussels, 10.2020.<br/> Bioseco was among the winners of the Tech Tour Photonics program. ",
      2: "Warsaw, September 28, 2020.<br/>2nd place among the 50 Most Creative People in Business for Krzysztof Paszek, co-founder of Bioseco. The award was won at the tenth Jubilee Gala under the patronage of the Polish Ministry of Development, PKN Orlen SA, Google for Startups, Santander Bank Polska, the Polish Chamber of Commerce.",
      3: "Warsaw, 08.2019.<br />Bioseco among twenty companies that will change Poland according to the monthly newspaper \"My Company\".",
      4: "Warsaw, 04.2019.<br/>Bioseco - Positive Impact Startup. In the first edition of the 2019 Positive Impact Startup Report organized by Kozminski Business Hub, Bioseco was among the innovative Polish startups.",
      5: "Brussels, 2019.<br/>2018 IEEE N3XT® STAR. Bioseco is among the companies in the area of ​​innovative technologies selected by the jury of IEEE Entrepreneurship Stars, an organization under the patronage of the European Parliament.",
      6: "Brussels, 29/11/2018.<br />Winner of the prestigious EUtop50 Innovators, contest for young companies from all over the European Union. The tenth edition of the competition organized by the European Parliament.",
      7: "Gdańsk, April 8, 2015.<br/>“Pomorskie Sztormy”, Winner of the competition in the Young Company of the Year 2014 category. 10th edition of the Gazeta Wyborcza and the Marshal of the Pomeranian Voivodeship.",
      8: "Gdynia 12.2014.<br/>Leader of the Pomeranian Science and Technology Park in Gdynia. The award was granted by a community of three hundred innovative companies.",
      9: "Gdańsk, October 24, 2014.<br/>Grand Prix Innovation 2014 award. Technikon, 10th Industrial Technology, Science and Innovation Fairs."
    }
  },
  privacy: {
    title: 'Privacy policy',
    see: 'See more'
  },
  steps: {
    next: "Next step",
    ask: "Ask for more",
    watchVideo: "Watch video",
    learnMore: "Learn more about the product"
  },
  footer: {
    copy: "Copyright <strong>Bioseco</strong>",
    about: "About us",
    contact: "Contact",
    privacy: "Privacy Policy",
    auctions: "Auctions",
    created: "Created in"
  },
  moreAboutUs: "Learn more about us",
  home: {
    headingTopText: "Welcome to Bioseco",
    headingSubText: "We provide solutions for bird protection",
    headingBottomText: "Where would you like to use our products?",
    farms: "Wind farm",
    airports: "Airport",
    area: "Terrain"
  },
  products: {
    headingTopText: 'Our products',
    headingBottomText: 'Choose the place where you need to protect the birds:',
    farms: "Wind farm",
    airports: "Airport",
    area: "Terrain"
  },
  team: [{
    name: "Adam Jaworski",
    role: "Chief Executive Officer",
    img: "adam_jaworski.jpg"
  }, {
    name: "Agnieszka Preś",
    role: "CHIEF FINANCIAL OFFICER",
    img: "agnieszka_pres.jpg"
  }, {
    name: "Dawid Gradolewski",
    role: "Chief Technology Officer",
    img: "dawid_gradolewski.jpg"
  }, {
    name: "Damian Dziak",
    role: "Head of Software",
    img: "damian_dziak.jpg"
  }, {
    name: "Damian Kaniecki",
    role: "Head of Hardware",
    img: "damian_kaniecki.jpg"
  }, {
    name: "Magda Bielawska",
    role: "Commercial Manager",
    img: "magda_bielawska.jpg"
  }, {
    name: "Włodek Kulesza",
    role: "HEAD OF R&D",
    img: "wlodek_kulesza.jpg"
  }, {
    name: "Małgorzata Alboszta",
    role: "HR MANAGER",
    img: "malgorzata_alboszta.jpg"
  }, {
    name: "Ewelina Lachowicz",
    role: "OPERATIONS MANAGER",
    img: "ewelina_lachowicz.jpg"
  }, {
    name: "Izabela Szulc",
    role: "MANAGER FOR ISO AND EU PROJECTS",
    img: "izabela_szulc.jpg"
  }, {
    name: "Maria Giełdon",
    role: "Commercial specialist",
    img: "maria_gieldon.jpg"
  }, {
    name: "Marcel Pańka",
    role: "Junior Business Developer",
    img: "marcel_panka.jpg"
  }, {
    name: "Tomasz Jasiński",
    role: "HEAD OF PRODUCTION",
    img: "tomasz_jasinski.jpg"
  }, {
    name: "Tomasz Spaleniak",
    role: "Logistic Specialist",
    img: "tomasz_spaleniak.jpg"
  }, {
    name: "Dominik Ambroziak",
    role: "ELECTRONICS ENGINEER/ H&S COORDINATOR",
    img: "dominik_ambroziak.jpg"
  }, {
    name: "Krzysztof Zakrzewski",
    role: "Assembly Team Leader / Foreman",
    img: "krzysztof_zakrzewski.jpg"
  }, {
    name: "Bartłomiej Lademan",
    role: "ELECTRONICS SERVICES TECHNICIAN",
    img: "bartlomiej_lademan.jpg"
  }, {
    name: "Maciej Grzesikiewicz",
    role: "ELECTRONICS SERVICES TECHNICIAN",
    img: "maciej_grzesikiewicz.jpg"
  }, {
    name: "Arkadiusz Kowalczyk",
    role: "ELECTRONICS SERVICES TECHNICIAN",
    img: "arkadiusz_kowalczyk.jpg"
  }, {
    name: "Krzysztof Działecki",
    role: "ELECTRONICS SERVICES TECHNICIAN",
    img: "krzysztof_dzialecki.jpg"
  }, {
    name: "Jakub Pawluk",
    role: "ELECTRONICS SERVICES TECHNICIAN",
    img: "jakub_pawluk.jpg"
  }, {
    name: "Adam Okun",
    role: "Production foreman",
    img: "adam_okun.jpg"
  }, {
    name: "Arkadiusz Chojka",
    role: "ELECTRONICS SERVICES TECHNICIAN",
    img: "arkadiusz_chojka.jpg"
  }, {
    name: "Paweł Hrynkiewicz - Moczulski",
    role: "ELECTRONICS ENGINEER",
    img: "pawel_hrynkiewicz-moczulski.jpg"
  }, {
    name: "Krzysztof Domozych",
    role: "Data Analyst",
    img: "krzysztof_domozych.jpg"
  }, {
    name: "Konrad Szwejk",
    role: "Linux Administrator",
    img: "konrad_szwejk.jpg"
  }, {
    name: "Przemysław Sadkowski",
    role: "Technical Customer Service Manager",
    img: "przemyslaw_sadkowski.jpg"
  }, {
    name: "Grzegorz Madejski",
    role: "Innovation Manager",
    img: "grzegorz_madejski.jpg"
  }, {
    name: "Włodzimierz Kaoka",
    role: "Software Development and Implementation Manager",
    img: "wlodzimierz_kaoka.jpg"
  }, {
    name: "Szymon Witkowski",
    role: "Software Maintenance Manager",
    img: "szymon_witkowski.jpg"
  }, {
    name: "Łukasz Wittbrodt",
    role: "Applications and Infrastructure Manager",
    img: "lukasz_wittbrodt.jpg"
  }, {
    name: "Marcin Detlaf",
    role: "FRONT-END DEVELOPER",
    img: "marcin_detlaf.jpg"
  }, {
    name: "Ilona Konop",
    role: "Data Analyst",
    img: "ilona_konop.jpg"
  }, {
    name: "Jakub Swenda",
    role: "JUNIOR DATA ANALYST",
    img: "jakub_swenda.jpg"
  }, {
    name: "Sebastian Zbytniewski",
    role: "Junior R&D Data Analyst",
    img: "sebastian_zbytniewski.jpg"
  }, {
    name: "Aleksy Stocki",
    role: "Junior R&D Data Analyst",
    img: "aleksy_stocki.jpg"
  }],
  about: {
    hedingTopText: '<strong>Innovation</strong><br />for bird monitoring',
    hedingSubText: '',
    headingText: 'Bioseco was established in April <strong>2013</strong> by a team of optical, radar and computer specialists to develop a system that monitors and protects birds',
    headSectionTopText: 'Why our<br /><strong>solutions?</strong><div class="line"></div>',
    headSectionText: 'The company works closely with ornithologists, chiropterologists and wind farm operators.  Over these years Bioseco has refined and optimised an innovative and cost-effective system that protects birds from colliding with wind turbines.',
    ourCertsTitle: 'Our<br /> <strong>certificates</strong>',
    ourTeamTitle: 'Our<br /><strong>team</strong><div class="line"></div>',
    ourTeamText: 'The Bioseco team is a group of IT engineers, ornithologists, chiropterologists and other people focused on avifauna. We are co-operating with institutions like Instytut Morski (Marine Institute) in Gdańsk, Pomorski Park Naukowo-Technologiczny (Pomeranian Science and Technology Park) in Gdynia, Technopark Gliwice and ornithological organisations. Company goal is to create devices and tools for authoritative research of environment, with wide practical application.',
    ourClientsTitle: 'Our clients',
    personOne: 'Adam Jaworski',
    personOneRole: 'CEO',
    personTwo: 'Dawid Gradolewski',
    personTwoRole: 'CTO',
    personThree: 'Małgorzata Alboszta',
    personThreeRole: 'Analyst',
    personFour: 'Damian Kaniecki',
    personFourRole: 'Designer',
    personFive: 'Paweł Hrynkiewicz',
    personFiveRole: 'Constructor',
    personSixRole: 'Electronics',
    personSeven: 'Damian Dziak',
    personSevenRole: 'Programmer',
    personEight: 'Szymon Witkowski',
    personEightRole: 'Programmer',
    personNine: 'Krzysztof Domozych',
    personNineRole: 'Constructor'
  },
  farmsProducts: {
    headerTopText: '<strong>Solution</strong><br />for Wind Farms',
    headerTopSubText: '',
    headerTopTextPresentation: 'Solution for wind farms',
    headerTopSubTextPresentation: 'Check out how the Bioseco BIRD PROTECTION SYSTEM (BPS) works',
    headerText: 'Every year many birds and bats collide with the wind turbines. To significantly reduce the number of accidents, Bioseco has created a bird protection system.',
    whyOurSolutionText: '',
    whyOurSolution: 'Check out why it is worth to use Bioseco system',
    sectionOneTitle: 'Main assumptions:',
    sectionOneText1: 'System comprised of devices and software, installed on turbines',
    sectionOneText2: 'Estimation of number of birds, recognition of their size and direction of flight',
    sectionOneText3: 'The trigger of specific action: to warn the birds and/or stop the turbine',
    sectionOneText4: 'Creation of the „safety shield”',
    sectionOneText5: 'Collectioning and archiving the data for statistics generation',
    sectionTwoTitle: 'Advantages',
    sectionTwoText1: '<strong class="bolded">Birds protection from the wind turbines</strong>',
    sectionTwoText2: 'Additional advantages',
    sectionTwoText3: 'Avoiding relocation of breeding  grounds and conducting additional surveys',
    sectionTwoText4: 'Collecting valuable data for natural science research',
    sectionThreeTitle: 'Technology',
    sectionThreeText1: 'Non-invasive installation (using existing infrastructure) ',
    sectionThreeText2: 'System which covers the whole wind farm',
    sectionThreeText3: 'Action plan: detectors on the turbines send information to the central unit, where it is analyzed and the proper action may be triggered (e. g. alert/slowdown of the turbine/holdup of the turbine). Data is archivized and transmitted online',
    sectionThreeText4: 'Flexibility of use: adjustment to the user\'s needs and wind farm\'s specifics',
    whyIShouldUseThis: 'Why should I use it?',
    whyIShouldUseThisOneTopBefore: '',
    whyIShouldUseThisOneTop: '314,000',
    whyIShouldUseThisOneTopAfter: '',
    whyIShouldUseThisOneText: 'the number of wind turbines spinning around the world',
    whyIShouldUseThisTwoTopBefore: '$',
    whyIShouldUseThisTwoTop: '109',
    whyIShouldUseThisTwoTopAfter: 'bln',
    whyIShouldUseThisTwoText: 'amount invested in wind power globally',
    whyIShouldUseThisThreeTopBefore: '',
    whyIShouldUseThisThreeTop: '5',
    whyIShouldUseThisThreeTopAfter: 'mln',
    whyIShouldUseThisThreeText: 'birds & bats are killed by wind turbines yearly',
    whyIShouldUseThisFourTopBefore: '',
    whyIShouldUseThisFourTop: '300',
    whyIShouldUseThisFourTopAfter: 'km/h',
    whyIShouldUseThisFourText: 'the speed of blades at the tip, surprising the birds'
  },
  farmsPresentation: {
    title: 'Wind farm - bird collisions',
    steps: [{
      title: "Collision problem",
      text: "Collisions with wind turbines kill millions of birds and bats around the world each year."
    }, {
      title: "Bioseco's modules",
      text: "The modules are installed on the turbine's monopole with band in the way they encompass 360 degree view. On the turbine there are 4 to 6 detection modules, on the height from 5 to 10 meters above the ground. Each detection module monitors a seperate quadrant."
    }, {
      title: "Detection",
      text: "The system detects birds from the distance of 500 meters and analyses their size, flight trajectory and the likelihood of collision."
    }, {
      title: "Warning lights",
      text: "At the predetermined distance, the system starts displaying bright stroboscopic lights to alert the birds and deter them from the danger ahead."
    }, {
      title: "Warning sounds",
      text: "Birds that continue their flight on the dangerous trajectory will be subjected to the wailing of warning sounds such as sirens."
    }, {
      title: "Stopping the turbine",
      text: "The system can be programmed to adjust the turbine's behaviour. For example, if rare or endangered species of birds stay on the collision course, the turbine could be stopped."
    }, {
      title: "Safely pass",
      text: "Birds that evade collision will be monitored and after they leave the dangerous zone, the turbines will be turned on again."
    }, {
      title: "Safely pass",
      text: "The system stores detailed records of each incident for later analysis. The full data and statistic tools for the user will be provided.<br/><br/><img src='/static/img/product/desktop.jpg' width='200' style='float: right;'><br/><br/>"
    }]
  },
  airportProducts: {
    headerTopText: '<strong>Innovative system</strong><br />for preventing bird-aircraft collisions',
    headerTopSubText: 'SOLUTION FOR AIRPORTS',
    headerTopTextPresentation: 'Preventing bird-aircraft collisions',
    headerTopSubTextPresentation: 'See how our innovative Bioseco AIRPORT FAUNA MONITORING SYSTEM (AFMS) works',
    headerText: 'With the passenges safety in mind, Bioseco has developed a solution reducing the number of birds colliding with airplanes.',
    whyOurSolutionText: '',
    whyOurSolution: 'Check out why it is worth to use Bioseco system',
    sectionOneTitle: 'Main assumptions',
    sectionOneText1: 'System comprised of devices and software, installed at the airport',
    sectionOneText2: 'Counting the number of birds, recognition of their size and direction of flight',
    sectionOneText3: 'Alerts for airport workers',
    sectionOneText4: 'The trigger of specific action',
    sectionOneText5: 'Collectioning and archiving the data for statistics generation',
    sectionTwoTitle: 'Benefits',
    sectionTwoText1: 'Increased levels of passenger security',
    sectionTwoText2: 'Protection of birds',
    sectionTwoText3: 'Reduction of costs related to the collisions with birds',
    sectionTwoText4: 'Collection of data over the long periods of time and application for various purposes (e.g. planning actions for subsequent migration and breeding seasons)',
    sectionTwoText5: 'Automatization of actions',
    sectionTwoText6: 'Facilitation of tasks for airport workers',
    sectionTwoText7: 'Better relations with airlines',
    sectionTwoText8: 'Argument for reduction of insurance premiums',
    sectionTwoText9: 'Better image of company, that cares about passengers and implements new, innovative technologies',
    sectionTwoText10: '',
    sectionThreeTitle: 'Technology',
    sectionThreeText1: 'Non-invasive installation (using existing infrastructure)',
    sectionThreeText2: 'System which covers important areas at the airport',
    sectionThreeText3: 'Action plan: detectors send information to the central unit, where it is analyzed and the proper action may be triggered. Data is archived and transmitted online',
    sectionThreeText4: 'Solution safe for airport communication, wireless and radio systems',
    sectionThreeText5: 'Flexibility of use: adjustment to the user\'s needs and airport specifics',
    whyIShouldUseThis: 'Why should I use it?',
    whyIShouldUseThisOneTopBefore: '',
    whyIShouldUseThisOneTop: '65,139',
    whyIShouldUseThisOneTopAfter: '',
    whyIShouldUseThisOneText: 'bird strikes have been reported for 2011-14',
    whyIShouldUseThisTwoTopBefore: '',
    whyIShouldUseThisTwoTop: '92',
    whyIShouldUseThisTwoTopAfter: '%',
    whyIShouldUseThisTwoText: 'of strikes occur below 900 m',
    whyIShouldUseThisThreeTopBefore: '',
    whyIShouldUseThisThreeTop: '90',
    whyIShouldUseThisThreeTopAfter: '%',
    whyIShouldUseThisThreeText: 'of bird collisions occur near or on airports',
    whyIShouldUseThisFourTopBefore: '$',
    whyIShouldUseThisFourTop: '1,2',
    whyIShouldUseThisFourTopAfter: 'bln',
    whyIShouldUseThisFourText: 'the cost of birdstrikes to airlines'
  },
  airportPresentation: {
    title: 'Aircraft-bird collisions',
    steps: [{
      title: 'Aircraft-bird collisions',
      text: "Aircraft and birds collisions during take off and landing cause over <strong>1.2 billion</strong> US dollars worldwide every year, forcing many flights to return to the airport, delaying flights and putting officers’ lives at risk."
    }, {
      title: 'Bioseco Airport System',
      text: "The system is installed in all important areas approx. 200 m to the airport runway. Bioseco Airport System detects flocking birds in the radius of 300 meters."
    }, {
      title: 'Monitoring',
      text: "The system monitors bird activity and the information is sent at the real time to the airport safety officers."
    }, {
      title: 'Alerting',
      text: "System sends alerts to the security service who take appropriate preventive actions."
    }, {
      title: 'Software',
      text: "The database system collects information on all events, enabling easy generation of reports and analysis of all events. In addition, information about detected objects in real time is displayed by security service employees on mobile devices."
    }, {
      title: '360° observation',
      text: "Bioseco Airport System enables 360° observation (depending on the number of modules). The detectors are placed in weatherproof housings resistant to adverse weather conditions."
    }, {
      title: 'Safe take offs and landings',
      text: "Used signals transmitters do not interfere with airport wireless and communication systems. The Bioseco Airport System is flexible and easily tailored to the specific needs and conditions of each and every airport. The system is minimally invasive and is integrated into existing airport infrastructure."
    }]
  },
  areaProducts: {
    headerTopText: '<strong>Solution</strong><br />for ornithologists',
    headerTopSubText: '',
    headerTopTextPresentation: 'Solution for ornithologists',
    headerTopSubTextPresentation: 'See how our innovative Bioseco BIRD PROTECTION SYSTEM (BPS) works',
    headerText: 'Technologies made by Bioseco are useful at wind farms, airports, but also they can become a great tool for ornithologists. They receive a device which provides very precise, completely reliable and accepted by experts data. Bioseco BIRD PROTECTION SYSTEM (BPS) allows continuous observation and registration of all the information on passing birds. Automaticlly collected data is understandable, undeniable and irremovable.',
    whyOurSolutionText: '',
    whyOurSolution: '',
    sectionOneTitle: 'Main assumptions',
    sectionOneText1: 'Bioseco software allows for real-time analysis and constant access to recorded information via a website or any mobile device.',
    sectionOneText2: 'The great amount of data provides the possibility of comparing various parameters on birds flying over the area. Using Bioseco BIRD PROTECTION SYSTEM (BPS), you may conduct research or prepare an environmental report in a faster and more reliable manner, thanks to the use of cutting-edge IT systems',
    sectionTwoTitle: 'How does it work?',
    sectionTwoText1: 'detection of passing birds within a 300 m radius',
    sectionTwoText2: 'Main characteristics of Bioseco BIRD PROTECTION SYSTEM (BPS):',
    sectionTwoText3: 'determination of height, the speed of flight and the distance from the device',
    sectionTwoText4: 'registration of environmental and meteorological data at certain date and hour',
    sectionTwoText5: 'compact device capable of operating in any terrain: in forests, mountains or at the sea',
    sectionTwoText6: 'records video in HD quality, 24h',
    sectionTwoText7: '',
    whyIShouldUseThis: 'Why should I use it?',
    whyIShouldUseThisOneTopBefore: '',
    whyIShouldUseThisOneTop: '450',
    whyIShouldUseThisOneTopAfter: '',
    whyIShouldUseThisOneText: 'bird species in Poland',
    whyIShouldUseThisTwoTopBefore: '',
    whyIShouldUseThisTwoTop: '26',
    whyIShouldUseThisTwoTopAfter: '',
    whyIShouldUseThisTwoText: 'species of bats in Poland',
    whyIShouldUseThisThreeTopBefore: '',
    whyIShouldUseThisThreeTop: '10000',
    whyIShouldUseThisThreeTopAfter: 'km',
    whyIShouldUseThisThreeText: 'storks pass during migration',
    whyIShouldUseThisFourTopBefore: '',
    whyIShouldUseThisFourTop: '5000',
    whyIShouldUseThisFourTopAfter: '',
    whyIShouldUseThisFourText: 'birdwatchers in Poland'
  },
  areaPresentation: {
    title: 'Rozwiązanie dla ornitologów',
    steps: [{
      title: "Environmental surveys",
      text: "Bioseco BIRD PROTECTION SYSTEM (BPS) is a perfect tool for bird monitoring. It can detect birds even from distance of 500 meteres, collecting data on height, speed and direction of their flight. Received data is reilable, precise and acceptable by officers."
    }]
  },
  contact: {
    stayInContact: "Contact Us",
    newBuilding: '(PPNT building)',
    haveQuestions: 'Questions? Feel free to ask',
    pl: 'Poland',
    street: '68 Budowlanych Street',
    account: 'bank account number',
    project: 'Projects co-financed by the EU'
  },
  component: {
    moreAboutUs: 'Learn more',
    watchPresentation: 'Watch the presentation',
    watchVideo: 'See the video',
    watchPromoVideo: 'Watch the promotional video',
    watchBooklet: 'Download the booklet',
    watchExampleVideo: 'See real example of BPS in action',
    bookletPolish: 'Polish',
    bookletEnglish: 'English',
    bookletDeutch: 'Deutch',
    bookletFrench: 'French',
    bookletJapanese: 'Japanese',
    watchUs: 'See us<br /><strong>in action</strong>',
    moreInfo: 'Do you need more information?',
    askAboutMore: 'Ask for more'
  },
  questionModal: {
    haveQuestion: 'Do you have a question?',
    completeForm: 'Fill out the form below, we will be happy to answer:',
    name: 'Name',
    email: 'E-mail address',
    queryTopicText: 'Select the subject of the query',
    queryTopic: {
      questionOne: 'Products for Wind Farms',
      questionTwo: 'Products for Airports',
      questionThree: 'Products for ornithologists',
      questionFour: 'Cooperation',
      questionFive: 'General query'
    },
    content: 'message',
    errorMsg: 'Complete the missing fields',
    errorSendMsg: 'Error while sending',
    sendMsg: 'The form has been sent',
    send: 'Send',
    rodo: "The controller of your personal data disclosed in the above contact form is  Bioseco SA, with its registered office in Gda\u0144sk (80-298), at 68 Budowlanych Street.\n           The personal data disclosed in this form will be processed for the purpose of handling your inquiry based on the controller's legitimate interest, i.e., Article 6(1)(f) of the GDPR, consisting in ensuring the quality of its services and communication. You have the right to request access to your personal data, its rectification, erasure, or restriction of processing.\n           You also have the right to object to the processing of your personal data and the right to lodge a complaint with the supervisory authority \u2013 the President of the Personal Data Protection Office. More information on the processing of your personal data can be found in our Privacy Policy available at: ",
    rodoLink: 'Privacy Policy'
  },
  mediaBox: {
    title: "Media about us",
    mediaBoxes: [{
      img: "/static/img/media/img1.jpg",
      title: "GAZETA WYBORCZA",
      text: "the main daily newspaper, article about system for wind farms <span class=arrow></span>",
      link: "http://wyborcza.biz/biznes/1,147584,20695368,bioseco-odstrasza-ptaki-a-przyciaga-inwestorow.html",
      type: "text-type"
    }, {
      img: "/static/img/media/img4.jpg",
      title: "PULS BIZNESU",
      text: "a leading business daily newspaper, article about system in Gdansk airport <span class=arrow></span>",
      link: "http://pulsbiznesu.pb.pl/3867943,56421,bioseco-ochroni-samoloty-przed-ptakami",
      type: "text-type"
    }, {
      img: "/static/img/media/img7.jpg",
      title: "TVN24",
      text: "news television, information about cooperation Bioseco and PGE SA <span class=arrow></span>",
      link: "http://tvn24bis.pl/z-kraju,74/powstaje-system-do-monitorowania-ptakow-w-poblizy-farm-wiatrowych,517386.html",
      type: "video-type"
    }, {
      img: "/static/img/media/img5.jpg",
      title: "PGE SA",
      text: "company website, statement on cooperation with Bioseco <span class=arrow></span>",
      link: "http://www.gkpge.pl/biuro-prasowe/komunikaty-prasowe/inne/multirejestratory-beda-monitorowac-ptaki-na-terenie-farm-wiatrowych-pge",
      type: "text-type"
    }]
  },
  media: {
    description: "See Us in action"
  },
  infoBox: {
    title: "Media About Us",
    newsTitle: "News",
    archiveTitle: "Archive",
    linkDescription: "Read more : ",
    postedDescription: "Posted: ",
    infoBoxes: [{
      img: "/static/img/media/Bioseco_RFQ.png",
      title: "Invitation to submit offers. Request for quotation no PMT/4/2021.",
      text: "Bioseco invites interested parties to submit offers for the RFQ no. PMT/4/2021 carried out under the Polish Tech Bridges program organized by the Polish Investment and Trade Agency, under the Smart Growth Operational Programme 2014-2020, Axis III Support for innovation in enterprises, 3.3 Support for promotion and internationalization of innovating enterprise, 3.3.1 Polish Tech Bridges. A detailed description of the subject of activities and specifications of the services requested can be found in the attachment.  <br/><br /> Attachment: <a download href='/static/RFQ_PMT.4.2021_Bioseco.docx.pdf'>RFQ_PMT.4.2021_Bioseco.pdf</a>",
      type: "text-type",
      date: "02.04.2021"
    }, {
      img: "/static/img/media/Bioseco_RFQ.png",
      title: "Selection of the offer. Request for quotation no PMT/1/2021.",
      text: "Bioseco chose the best offer for the RFQ no. PMT/1/2021 carried out under the Polish Tech Bridges program organized by the Polish Investment and Trade Agency, under the Smart Growth Operational Programme 2014-2020, Axis III Support for innovation in enterprises, 3.3 Support for promotion and internationalization of innovating enterprise, 3.3.1 Polish Tech Bridges. The chosen offer was submitted by the American Wind Wildlife Institute (AWWI), based in Washingotn DC, USA (1990 K Street NW, 20006), with a contract of $8,850.51.<br/><br /><img src='/static/img/RFQ_PMT.1.2021_Bioseco.png' alt='RFQ_PMT'/>",
      type: "text-type",
      date: "03.02.2021"
    }, {
      img: "/static/img/media/Bioseco_RFQ.png",
      title: "Invitation to submit offers. Request for quotation no PMT/1/2021.",
      text: "Bioseco invites interested parties to submit offers for the RFQ no. PMT/1/2021 carried out under the Polish Tech Bridges program organized by the Polish Investment and Trade Agency, under the Smart Growth Operational Programme 2014-2020, Axis III Support for innovation in enterprises, 3.3 Support for promotion and internationalization of innovating enterprise, 3.3.1 Polish Tech Bridges. A detailed description of the subject of activities and specifications of the services requested can be found in the attachment.<br/><br /><img src='/static/img/RFQ_PMT.1.2021_Bioseco.png' alt='RFQ_PMT'/><br/><br /> Attachment: <a download href='/static/RFQ_PMT.1.2021_Bioseco.pdf'>RFQ_PMT.1.2021_Bioseco.pdf</a> ",
      type: "text-type",
      date: "22.01.2021"
    }, {
      img: "/static/img/media/spain_december.jpg",
      title: "Another system in Spain.",
      text: "We have just installed bird protection systems in the Cadiz area. The system operates on a wind farm where monitoring was carried out stationary by observers. In the case of bird migration, they manually sent a signal to stop the turbine.",
      type: "text-type",
      date: "17.12.2020"
    }, {
      img: "/static/img/media/bioseco_france.jpg",
      title: "We have entered a new market – France!",
      text: "This week, we installed 3 Bioseco Bird Protection Systems in France.\n" + "We are glad such a company as WPO decided to protect birds with Bioseco systems. For the first time our devices are working on Gamesa turbines.\n" + "Stereovision enabling distance estimation and bird size classification plus false positive filtering powered by AI shall reduce unnecessary turbine stops and loss of generation to minimum.",
      type: "text-type",
      date: "23.11.2020"
    }, {
      img: "/static/img/media/mosty_technologiczne.jpg",
      title: "Bioseco got a grant from Polish Investment&Trade Agency",
      text: "PMT is a project supporting the expansion of the Polish SME sector implemented by the Polish Investment and Trade Agency. The Agency aims to support the promotion and internationalization of polish innovative enterprises. Bioseco was identified as such a company and a grant of PLN 200 000 to explore the US market. ",
      type: "text-type",
      date: "14.11.2020"
    }, {
      img: "/static/img/media/photonics.jpg",
      title: "Bioseco – winner in the Tech Tour Photonics.",
      text: "Bioseco is among the winners of this year's edition of the Tech Tour Photonics program. In the competition participated innovative companies from all over Europe.",
      type: "text-type",
      date: "02.11.2020"
    }, {
      img: "/static/img/media/bioseco_kreatywni.jpg",
      title: "2nd place for Bioseco at the Jubilee Gala of the 50 Most Creative People in Business!",
      text: "Co-founder of Bioseco, Krzysztof Paszek took second place in the competition held in Warsaw under the patronage of the Ministry of Development and many well-known companies and institutions such as: PKN ORLEN S.A., Millennium Leasing, LOTTE Wedel, Google for Startups, the National Chamber of Commerce.",
      type: "text-type",
      date: "28.09.2020"
    }, {
      img: "/static/img/media/bioseco_ce.jpg",
      title: "CE certificate",
      text: "We are happy to inform that during rigorous testing our Bird Protection System proved to be in line with EU requirements for electrical equipment, hence we issued EU declaration of conformity and can now issue CE marking on our BPS.",
      type: "text-type",
      date: "01.09.2020"
    }, {
      img: "/static/img/media/photo_cooperation.jpg",
      title: "Bioseco enters Austrian market by entering into agreement with Energiewerkstatt",
      text: "Lately Bioseco + Windhunter + Energiewerkstatt agreed for the marketing of Bioseco Bird Protection System in Austria. Last week Florian Lachinger (Energiewerkstatt) and Maciej Łaz (Windhunter Service) visited Bioseco offices. Later we went to see Bioseco system in operation at real wind farm. We cross fingers that this cooperation gives good fruits to all Parties engaged with ultimate benefit to the bird protection.",
      date: "30.07.2020"
    }, {
      img: "/static/img/media/gwo.jpg",
      title: "Bioseco team trained to GWO standards by Windhunter",
      text: "Bioseco installation and technical team was recently trained by our Partner - Windhunter according to GWO standards. <br/>While scaling up activities we need to remember to ensure safety and highest standards of operations. ",
      type: "text-type",
      date: "21.07.2020"
    }, {
      img: "/static/img/media/bps_germany.jpg",
      title: "Cooperation with BayWa r.e., Germany",
      text: "Bioseco installed two of its Bird Protection Systems for a pilot project in Germany with the large wind farm developer and operator BayWa r.e.\n" + "Both parties have high expectations about a high level of bird protection while reducing energy outages due to long-lasting unnecessary stoppages.\n" + "Both Bioseco and BayWa r.e. are looking forward to the results of this test campaign in order to contribute to the current discussion in Germany, about necessary features and parameters required to detect and save flocking birds.",
      type: "text-type",
      date: "15.05.2020"
    }, {
      img: "/static/img/media/wspolpraca-pgeeo.jpg",
      video: "/static/video/bird_tracking.mp4",
      poster: "/static/video/poster_bird_tracking.png",
      title: "Perfect detection registered in Germany.",
      text: "Recently we have successfully installed 2 brand new Bird Protection Systems in Germany with upgraded software.<br/> Not long after the installation our system registered a perfect medium size bird detection. <br/>See the capabilities of our BPS.",
      type: "text-type",
      date: "04.06.2020"
    }, {
      img: "/static/img/media/installation.jpg",
      title: "Test with PGE EO started ",
      video: "/static/video/Bioseco_ENG_small.mp4",
      poster: "/static/video/poster.png",
      text: "Despite the coronavirus, we at Bioseco are continuing our mission of saving birds at wind farms and protecting owners from negative consequences of bird collisions. If you have a minute please see a short movie from our latest installation in Poland at one of largest Polish wind farms, where we installed our newest eight module Bird Protection System. \n" + "<br/>New installations coming up in May 2020, this time in Germany.\n" + "<br/>Wish you all good health.",
      type: "text-type",
      date: "20.03.2020"
    }, {
      img: "/static/img/media/wfo2020.png",
      title: "Bioseco participates in 4th Wind Farm Operators Forum",
      text: "Bioseco participated in 4th Wind Farm Operators Forum in Sopot (www.wfof.eu). Apart from exhibiting the Bird Protection System in mini-fair, our CEO – Adam Jaworski gave a presentation during workshop session on details of Bioseco system. The workshop was co-hosted with Michał Kaczerowski from Ambiens – an experienced environmental consultancy. \n" + "<br/>For interested persons there is a chance to receive the presentation and the video from the workshop. Just write at offers@bioseco.com",
      type: "text-type",
      date: "12.03.2020"
    }, {
      img: "/static/img/media/test2020.jpg",
      title: "Great results of BPS evaluation test in Germany.",
      text: "Another great news regarding Bioseco Bird Protection System. \n" + "We have received an evaluation report from Vogelwarte from test campaign performed in Sept/Oct 2019 in Germany. Our eight module system was tested within NatForWinSent programme organized by ZSW and co-funded by German Government (<a href='https://www.natur-und-erneuerbare.de/projektdatenbank/projekte/natforwinsent-ii/'>https://www.natur-und-erneuerbare.de/projektdatenbank/projekte/natforwinsent-ii/</a>). \n" + "<br/>Red Kite detection efficiency reached 97% within 200 meters distance. The cumulative detection efficiency between 0-300meters was at 83% and 64% up to 400m away from the system. \n" + "<br/>Another great news was very low false positive rate of 7% of which only 1/3 would actually lead to the turbine stop, which is thanks to our stereovision approach to detection and sophisticated detection algorithms.",
      type: "text-type",
      date: "07.02.2020"
    }, {
      img: "/static/img/media/xmas.jpg",
      title: "X-mas gift. 2 systems for Poland signed.",
      text: "Great gift for Christmas. We have signed 2 agreements with a Polish wind farm developer for delivery of 2 Bird Protection Systems to its projects in Poland that will be constructed in 2H2020. According to the requirements two Vestas turbines shall be equipped with a system protecting birds and stopping the turbine in case birds come closer than 150m to a wind turbine. We can’t wait to realization of this new assignment and installing more Bioseco systems in Poland.  \n" + "<br/>Merry Christmas and a Happy New Year.",
      type: "text-type",
      date: "23.12.2019"
    }, {
      img: "/static/img/media/reon.jpg",
      title: "Bioseco and REON AG sign partnership for Germany",
      text: "Bioseco and Reon AG signed a cooperation agreement by which REON AG will become an authorized agent of Bioseco in Germany. Given the long-lasting presence of Reon in wind market in Germany, wide network and professional approach this will pave the wave for Bioseco in entering the most important market in Germany. We are looking forward for first results of this cooperation soon.",
      type: "text-type",
      date: "20.12.2019"
    }, {
      img: "/static/img/media/bird-tests.jpg",
      title: "Another test of BPS – this time using trained falcons",
      text: "3 weeks ago Bioseco system was tested with artificial bird. Last week Bioseco Bird Protection System installed on a wind turbine was tested in Poland using trained Falcons. In all trial passes the system successfully detected the bird and stopped the turbine. Congratulations to the Bioseco team for this major step in project development achieved in 2019.",
      type: "text-type",
      date: "13.12.2019"
    }, {
      img: "/static/img/media/bird.jpg",
      title: "Bioseco Bird Protection System tested in Spain by global player",
      text: "Wondering what it is? Bioseco system was recently tested in Spain on a wind farm of one of global wind energy operators. For the test, Bioseco system had to detect the drones (UAV) resembling birds as on the picture. The tests went very well confirming high detection efficiency and the ability of the system to estimate the distance between the drone and the wind turbine. This feature is essential for the operator to avoid bird collision and minimize turbine shutdown time. Looking forward to more companies willing to test Bioseco systems with real and artificial birds😊 More good news to come soon",
      type: "text-type",
      date: "03.12.2019"
    }, {
      img: "/static/img/media/installation.jpg",
      title: "Another installation of Bird Protection System in Poland",
      text: "Last week Bioseco installed the new Bird Protection System (BPS) on a wind turbine in Poland. Another safe turbine for birds, another investor protected against bird mortality risk and big step for Bioseco in entering the market with the BPS. Looking forward to new bird challenges",
      type: "text-type",
      date: "18.10.2019"
    }, {
      img: "/static/img/media/airports.png",
      title: "PLN 2,6M of EU funds for development of airport system signed",
      text: "We have signed a subsidy agreement with NCBiR (National Center for Research and Development) for the co-financing of a research project named “Carrying out research and development works necessary to develop a new autonomous AIRPORT FAUNA MONITORING SYSTEM (AFMS) reducing the number of collisions between aircraft and birds and mammals”. Within this project Bioseco will develop a fully operational product designed to increase the safety at airports regarding environmental risks management. The Project will be executed between 2020-2022.\n" + "<br/>The value of the project is almost PLN 3,5M while the EU subsidy amounts to PLN 2,6M. \n" + "<Br/>This way Bioseco is continuing to invest in its second business line devoted to airports safety.",
      type: "text-type",
      date: "30.09.2019"
    }, {
      img: "/static/img/media/wspolpraca-pgeeo.jpg",
      title: "Cooperation with PGE EO official",
      text: "It is official. PGE EO (the biggest wind energy operator in Poland) will test Bioseco systems on its wind farms. This is a major step towards reducing the impact of wind energy on large birds and for development of Bioseco Bird Protection System . For whole press release (in PL) please visit page below",
      link: "https://pgeeo.pl/Aktualnosci/kamery-i-radary-beda-monitorowac-ptaki",
      type: "text-type",
      date: "04.09.2019"
    }, {
      img: "/static/img/media/pozytywny.jpg",
      title: "Report of Positive Impact 2019",
      text: "We would like to thank Kozminski Business Hub for presenting our organization in the Startup Report of Positive Impact 2019. This report is a collection of Polish companies that deal with creating value for sustainable development. Bioseco is part of to the group of Startups that are characterized by innovation and great possibilities of growth in their activity.<br /><br />We invite you to read the report.<br/>Information about our company can be found on pages 69-71.",
      link: "http://raportspw.kozminskihub.com/",
      type: "text-type",
      date: "30.04.2019"
    }, {
      img: "/static/img/media/upgrade.jpg",
      title: "System updating",
      text: "Last week our team updated systems on windfarm located in south of Poland.<br />Six of our modules were changed for new genaration of The Bird Protection System.<br /><br />Updated system is equipped with sound modules with different sounds, from sirens to hunting birds, with regulable volume up to 120dB. It’s visual modules can measure distance from birds and with 3 cameras installed, it will provide high resolution pictures.<br /><br />We are sure that the new System will bring great and measurable effects!",
      link: "https://www.linkedin.com/company/bioseco/",
      type: "text-type",
      date: "05.04.2019"
    }, {
      img: "/static/img/media/move.jpg",
      title: "Bioseco on the move!",
      text: "Find us on our new location, few minutes from the Gdansk Airport.<br /> Greater space helps us to develop our system and is suitable for our growing organization.<br /> The new adress is <b>Budowlanych 68, Gdańsk</b>.<br /><br />Bioseco is ready to welcome you in our new offices!",
      link: "https://www.linkedin.com/feed/update/urn:li:activity:6523494951689560064",
      type: "text-type",
      date: "29.04.2019"
    }, {
      img: "/static/img/media/wolves.jpg",
      title: "Wolves summit",
      text: "Wolves Summit was a great succes for Bioseco.<br />Making it to semi finals for Great Pitch Competition was indication of the interest in our organization.<br />Together with wounderful meetings and conversations, the summit helped to develop Bioseco team!",
      link: "https://www.linkedin.com/feed/update/urn:li:activity:6513820388680626176",
      type: "text-type",
      date: "21.04.2019"
    }, {
      img: "/static/img/media/n_img1.jpg",
      title: "IEEE N3XT® STARS",
      text: "We did it! Bioseco has just become a member of the innovation program created by EUtop50.<br />The organization supports young companies that are involved in creating products and technologies that affect Europe's needs.<br />The organization hosts the IEEE N3XT® STARS event. The choice of winners is determined by innovative products beneficial to humanity, based on engineering, compliant with IEEE standards.<br />We are pleased to announce that Bioseco was awarded in 2018 IEEE N3XT® STARS.<br />Being part of such a prestigious group confirms our belief that our actions will positively influence the world around us.<br />Thank you for the award, which encourages our team to constantly improve!",
      link: "https://entrepreneurship.ieee.org/n3xt-stars/",
      type: "text-type",
      date: "28.01.2019"
    }, {
      img: "/static/img/media/top50.jpg",
      title: "EUtop50 contest",
      text: "<span class=strong>We've just won the prestigious EUtop50 contest in the European Parliament in Brussels!</span><br /><span class=strong>The EUtop50</span> was organised on the occasion 10th European Innovation Summit and EU Science & Innovation high-level conference. <br /><span class=strong>Bioseco</span> was the only startup representing Poland and one of two representing CEE.<br />This event combines the best European startups, outstanding scientists, politicians, investors and business representatives.<br />The prize confirms that our solution is heading into a good direction of protecting the environment with our innovative technology.<br /><span class=strong>Bioseco team</span> is proud of its mission and solution that we have developed and we are happy to help wind farm operators to protect birds on their sites. ",
      link: "https://www.facebook.com/pg/Bioseco-497515667013273/posts/?ref=page_internal",
      type: "text-type",
      date: "29.11.2018"
    }, {
      img: "/static/img/media/sonda2.jpg",
      title: "Bioseco innovation presented in the \"Sonda 2\" tv program.",
      text: "The episode of the \"Sonda 2\" program was entirely about birds. It presented a problem of their mortality on wind farms. We were able to tell how we can save the birds from death as a result of a collision with turbine blades. The program was broadcast on TV channel Dwójka.",
      type: "text-type",
      date: "25.05.2018"
    }, {
      img: "/static/img/media/scale_up.jpg",
      title: "Bioseco takes part in the KPT ScaleUP program in Krakow",
      text: "The Bioseco team, thanks to the participation in the KPT ScaleUP program, was able to establish contacts with representatives of the Krakow Airport, test prototypes, as well as participate in a series of meetings and trainings.",
      type: "text-type",
      date: "05.08.2017"
    }, {
      img: "/static/img/media/bird-strike.jpg",
      title: "World Birdstrike Association Congress in Amsterdam",
      text: "Bioseco representatives took part in the most important meeting related to birdstrikes at airports area. This is an extremely important issue because it generates losses of over two billion dollars annually. There are organizations and associations that integrate experts on this subject. For Bioseco, it was a valuable learning experience and a chance to meet the most important people from international airports, which will certainly pay off in the future.",
      type: "text-type",
      date: "06.12.2016"
    }, {
      img: "/static/img/media/kongres.jpg",
      title: "Meetings at Congress 590 in Rzeszów",
      text: "Bioseco was invited to join the group of innovative companies that spoke with government and large companies representatives. Among the people we met was also Bruce Dickinson - the owner of Cardiff Aviation and the vocalist of Iron Maiden.",
      type: "text-type",
      date: "17.11.2016"
    }, {
      img: "/static/img/media/tedx.jpg",
      title: "Bioseco mission presented at TEDx \"Between species\" - Gdynia",
      text: "It was an honor to introduce to an intellectualists’ audience the issue of bird conservation in wind farms and describe the Bioseco solution. ",
      type: "text-type",
      date: "26.11.2015"
    }, {
      img: "/static/img/media/innowacje-tvp.jpg",
      title: "Bioseco in the program \"Innowacje dla Ciebie\" on TVP",
      text: "In the popular program \"Innovations for You\", edited by Roman Młodkowski, together with the president of Technopark, prof. Jan Kosmol, Krzysztof Paszek from Bioseco talked about innovations, business support and, above all, presented the concept of the Bioseco solution.",
      type: "text-type",
      date: "17.08.2015"
    }, {
      img: "/static/img/media/horyzont2020.jpg",
      title: "Bioseco has won the Horizon 2020 grant",
      text: "A consortium of three companies, including Bioseco, won a grant from the Horizon 2020 program, SME Instrument Phase 1. Experts from the European Commission rated the drone detection project so highly that it was among the top ten projects from Poland to which this grant was awarded.",
      type: "text-type",
      date: "10.06.2015"
    }, {
      img: "/static/img/media/mobile-kongres.jpg",
      title: "Participation in the Mobile World Congress in Barcelona",
      text: "For the second time Bioseco attended as an exhibitor at the famous MWC fairs in Barcelona. Among other innovative companies, Bioseco presented its solution for saving birds on wind farms. The great interest and declarations from future customers confirm the right direction of Bioseco technology development.",
      type: "text-type",
      date: "02.03.2015"
    }, {
      img: "/static/img/media/counter.jpg",
      title: "The project of detecting and counting cars in city traffic was completed",
      text: "Bioseco has developed a unique monitoring system for counting cars at intersections. The client will use the system to monitor the effectiveness of outdoor advertising media.",
      type: "text-type",
      date: "02.02.2015"
    }, {
      img: "/static/img/media/sztormy.jpg",
      title: "Our company has won the prestigious “Pomeranian Storm” award",
      text: "Bioseco won in the Young Company of 2014 category in a competition organized by the Marshal of the Pomeranian Region and Gazeta Wyborcza. The high rank of the event was emphasized by the presence of the presidents of Gdynia, Gdańsk and Sopot, and of course the Marshal of the Pomeranian Region. The gala took place at the Shakespeare Theater in Gdańsk.",
      type: "text-type",
      date: "20.12.2014"
    }, {
      img: "/static/img/media/swiss.jpg",
      title: "Presentation of the Bioseco solution in Switzerland",
      text: "At the Swiss-Polish Roundtable on Innovation, Bioseco representatives presented the concept of the device and the possibilities of a bird monitoring and protection. The topic met with great interest.",
      type: "text-type",
      date: "28.10.2014"
    }, {
      img: "/static/img/media/lider-ppnt.jpg",
      title: "The Leader of PPNT Gdynia in the category \"Product, service, brand\"",
      text: "Bioseco received “The PPNT Gdynia Leader” award as the most outstanding brand and company in 2014. The entire PPNT Gdynia community, consisting of almost three hundred innovative companies, participated in the plebiscite.",
      type: "text-type",
      date: "20.12.2014"
    }]
  },
  photos: {
    title: "Zobacz nas w akcji",
    images: [{
      img: "link do zdjęcia",
      alt: "alt"
    }]
  }
};

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pl; });
var baseTitle = 'Bioseco - rozwiązania dla ochrony ptaków';

var pl = {
  "go_up": "do góry",
  page_titles: {
    home: baseTitle,
    products: "Produkty | " + baseTitle,
    farm: "Rozwi\u0105zanie dla farm wiatrowych | " + baseTitle,
    airport: "Rozwi\u0105zanie dla lotnisk | " + baseTitle,
    area: "Rozwi\u0105zanie dla ornitolog\xF3w | " + baseTitle,
    farmPresentation: "Rozwi\u0105zanie dla farm wiatrowych | " + baseTitle,
    airportPresentation: "Rozwi\u0105zanie dla lotnisk | " + baseTitle,
    areaPresentation: "Rozwi\u0105zanie dla ornitolog\xF3w | " + baseTitle,
    about: "O nas | " + baseTitle,
    blog: "Blog | " + baseTitle,
    contact: "Kontakt | " + baseTitle,
    auctions: "" + baseTitle,
    projects: "Projekty dofinansowane z UE",
    awards: "Nagrody | " + baseTitle,
    grants: "Granty | " + baseTitle,
    certificates: "Certyfikaty | " + baseTitle,
    privacy: "Polityka prywatno\u015Bci | " + baseTitle,
    bps: "System ochrony ptak\xF3w na Farmy Wiatrowe | " + baseTitle,
    afms: "System monitorowania fauny dla Port\xF3w Lotniczych | " + baseTitle,
    bridgealfa: "Bridge Alfa | " + baseTitle,
    pmt: "Polskie Mosty Technologiczne USA | " + baseTitle,
    eic: "Wsparcie w przygotowaniu Wniosku i SW do EIC Accelerator Pilot | " + baseTitle,
    bps2: "Bird Protection System | " + baseTitle,
    pbe: "Grant PBE | " + baseTitle,
    pbe2: "Grant PBE 2 | " + baseTitle,
    ppbb: "Promocja marki produktowej BIOSECO | " + baseTitle,
    offshore: "Kompleksowa ochrona ptak\xF3w wok\xF3\u0142 morskich farm wiatrowych | " + baseTitle,
    infonews: "Aktualno\u015Bci | " + baseTitle
  },
  menu: {
    home: 'Home',
    products: {
      title: 'Produkty',
      farms: 'Farmy wiatrowe',
      airports: "Lotniska",
      ornithologists: "Ornitolodzy"
    },
    certs: 'Certyfikaty',
    awards: 'Nagrody',
    grants: {
      title: 'Granty',
      bps: 'System ochrony ptaków na Farmy Wiatrowe',
      afms: 'System monitorowania fauny dla Portów Lotniczych',
      ba: 'Bridge Alfa',
      pmt: 'Polskie Mosty Technologiczne USA',
      eic: 'Wsparcie w przygotowaniu Wniosku i SW do EIC Accelerator Pilot',
      bps2: 'Bird Protection System',
      pbe: 'Grant PBE',
      pbe2: 'Grant PBE 2',
      ppbb: 'Promocja marki produktowej BIOSECO',
      offshore: 'Kompleksowa ochrona ptaków wokół morskich farm wiatrowych'
    },
    news: 'Aktualności',
    about: 'O nas',
    blog: "Blog",
    contact: "Kontakt",
    ask: "Zadaj pytanie",
    english: "English",
    polish: "Polski",
    deutch: "Deutch",
    project: 'Projekty dofinansowane z UE'
  },
  certs: {
    headingTopText: 'Certyfikaty Bioseco',
    seeCerts: 'Zobacz nasze certyfikaty'
  },
  awards: {
    hedingTopText: 'Nagrody Bioseco',
    seeAwards: 'Zobacz nasze nagrody',
    list: {
      1: "Genewa-Bruksela, 10.2020.<br />Bioseco znalazła się w gronie zwycięzców programu Tech Tour Photonics.",
      2: "Warszawa, 28.09.2020.<br />II Miejsce wśród 50 Najbardziej Kreatywnych Ludzi w Biznesie dla Krzysztofa Paszka, współzałożyciela Bioseco. Nagroda zdobyta na dziesiątej Jubileuszowej Gali pod patronatem Ministerstwa Rozwoju, PKN Orlen SA, Google for Startups, Santander Bank Polska, Krajowa Izba Gospodarcza.",
      3: "Warszawa, 08.2019.<br />Bioseco w gronie dwudziestu firm, które zmienią Polskę według miesięcznika „My Company”.",
      4: "Warszawa, 04.2019.<br />Bioseco startupem pozytywnego wpływu. W pierwszej edycji Raportu Startupów Pozytywnego Wpływu 2019 organizowanego przez Kozminski Business Hub wśród innowacyjnych polskich startupów znalazło się Bioseco.",
      5: "Bruksela, 2019.<br />2018 IEEE N3XT® STAR. Bioseco znalazło się w gronie firm z obszaru innowacyjnych technologii wybranych przez jury IEEE Entrepreneurship Stars, organizacji pod patronatem Parlamentu Europejskiego. Parlament Europejski.",
      6: "Bruksela, 29.11.2018.<br />Wygrana w prestiżowym konkursie EUtop50 dla innowatorów z całej Unii Europejskiej. Dziesiąta edycja konkursu organizowanego przez Parlament Europejski.",
      7: "Gdańsk, 08.04.2015.<br />Pomorskie Sztormy, Zwycięzca konkursu w kategorii Młoda Firma Roku 2014. 10 edycja plebiscytu Gazety Wyborczej i Marszałka Województwa Pomorskiego.",
      8: "Gdynia 12.2014.<br />Lider Pomorskiego Parku Naukowo-Technologicznego w Gdyni. Nagroda przyznana przez społeczność prawie trzystu firm z obszaru nowych technologii.",
      9: "Gdańsk, 24.10.2014. <br/>Nagroda Grand Prix Innowacje 2014. Technikon, 10 Targi Techniki Przemysłowej Nauki i Innowacji."
    }
  },
  privacy: {
    title: 'Polityka prywatności',
    see: 'Zobacz'
  },
  steps: {
    next: "Następny krok",
    ask: "Zapytaj o więcej",
    watchVideo: "Zobacz video",
    learnMore: "Dowiedz się więcej o produkcie"
  },
  footer: {
    copy: "Copyright <strong>Bioseco</strong>",
    about: "O nas",
    contact: "Kontakt",
    privacy: "Polityka Prywatności",
    auctions: "Przetargi",
    created: "Created in"
  },
  moreAboutUs: "Dowiedz się więcej o nas",
  home: {
    headingTopText: "Witaj w Bioseco",
    headingSubText: "Wprowadzamy rozwiązania dla ochrony ptaków",
    headingBottomText: "Gdzie chciałbyś użyć naszych produktów?",
    farms: "Farmy wiatrowe",
    airports: "Lotniska",
    area: "Teren"
  },
  products: {
    headingTopText: 'Nasze produkty',
    headingBottomText: 'Wybierz miejsce w którym potrzebujesz chronić ptaki:',
    farms: "Farmy wiatrowe",
    airports: "Lotniska",
    area: "Teren"
  },
  team: [{
    name: "Adam Jaworski",
    role: "CEO/Prezes Zarządu",
    img: "adam_jaworski.jpg"
  }, {
    name: "Agnieszka Preś",
    role: "Dyrektor ds. finansowych i administracyjnych",
    img: "agnieszka_pres.jpg"
  }, {
    name: "Dawid Gradolewski",
    role: "CTO/Członek Zarządu",
    img: "dawid_gradolewski.jpg"
  }, {
    name: "Damian Dziak",
    role: "Szef działu software",
    img: "damian_dziak.jpg"
  }, {
    name: "Damian Kaniecki",
    role: "Szef działu hardware",
    img: "damian_kaniecki.jpg"
  }, {
    name: "Magda Bielawska",
    role: "Commercial Manager",
    img: "magda_bielawska.jpg"
  }, {
    name: "Włodek Kulesza",
    role: "Szef działu R&D",
    img: "wlodek_kulesza.jpg"
  }, {
    name: "Małgorzata Alboszta",
    role: "Menedżer HR",
    img: "malgorzata_alboszta.jpg"
  }, {
    name: "Ewelina Lachowicz",
    role: "Menedżer Operacyjny",
    img: "ewelina_lachowicz.jpg"
  }, {
    name: "Izabela Szulc",
    role: "Menedżer ds. ISO i projektów unijnych",
    img: "izabela_szulc.jpg"
  }, {
    name: "Maria Giełdon",
    role: "Specjalista ds. komercyjnych",
    img: "maria_gieldon.jpg"
  }, {
    name: "Marcel Pańka",
    role: "Junior Business Developer",
    img: "marcel_panka.jpg"
  }, {
    name: "Tomasz Jasiński",
    role: "Kierownik produkcji",
    img: "tomasz_jasinski.jpg"
  }, {
    name: "Tomasz Spaleniak",
    role: "Specjalista ds. Logistyki",
    img: "tomasz_spaleniak.jpg"
  }, {
    name: "Dominik Ambroziak",
    role: "Inżynier Elektroniki / Specjalista BHP",
    img: "dominik_ambroziak.jpg"
  }, {
    name: "Krzysztof Zakrzewski",
    role: "Lider Zespołu Montażowego / Brygadzista",
    img: "krzysztof_zakrzewski.jpg"
  }, {
    name: "Bartłomiej Lademan",
    role: "Monter Elektroniki",
    img: "bartlomiej_lademan.jpg"
  }, {
    name: "Maciej Grzesikiewicz",
    role: "Monter Elektroniki",
    img: "maciej_grzesikiewicz.jpg"
  }, {
    name: "Arkadiusz Kowalczyk",
    role: "Monter Elektroniki",
    img: "arkadiusz_kowalczyk.jpg"
  }, {
    name: "Krzysztof Działecki",
    role: "Monter Elektroniki",
    img: "krzysztof_dzialecki.jpg"
  }, {
    name: "Jakub Pawluk",
    role: "Monter Elektroniki",
    img: "jakub_pawluk.jpg"
  }, {
    name: "Adam Okun",
    role: "Brygadzista produkcji",
    img: "adam_okun.jpg"
  }, {
    name: "Arkadiusz Chojka",
    role: "Monter elektroniki",
    img: "arkadiusz_chojka.jpg"
  }, {
    name: "Paweł Hrynkiewicz - Moczulski",
    role: "Inżynier Elektroniki",
    img: "pawel_hrynkiewicz-moczulski.jpg"
  }, {
    name: "Krzysztof Domozych",
    role: "Analityk danych",
    img: "krzysztof_domozych.jpg"
  }, {
    name: "Konrad Szwejk",
    role: "Linux Administrator",
    img: "konrad_szwejk.jpg"
  }, {
    name: "Przemysław Sadkowski",
    role: "Kierownik ds. technicznej obsługi klienta",
    img: "przemyslaw_sadkowski.jpg"
  }, {
    name: "Grzegorz Madejski",
    role: "Kierownik ds. Innowacji",
    img: "grzegorz_madejski.jpg"
  }, {
    name: "Włodzimierz Kaoka",
    role: "Kierownik ds. rozwoju i wdrożenia oprogramowania",
    img: "wlodzimierz_kaoka.jpg"
  }, {
    name: "Szymon Witkowski",
    role: "Kierownik ds. Utrzymania Oprogramowania",
    img: "szymon_witkowski.jpg"
  }, {
    name: "Łukasz Wittbrodt",
    role: "Kierownik ds. Aplikacji i Infrastruktury",
    img: "lukasz_wittbrodt.jpg"
  }, {
    name: "Marcin Detlaf",
    role: "Front-end Developer",
    img: "marcin_detlaf.jpg"
  }, {
    name: "Ilona Konop",
    role: "analityk danych",
    img: "ilona_konop.jpg"
  }, {
    name: "Jakub Swenda",
    role: "Młodszy analityk danych",
    img: "jakub_swenda.jpg"
  }, {
    name: "Sebastian Zbytniewski",
    role: "Młodszy analityk danych B+R",
    img: "sebastian_zbytniewski.jpg"
  }, {
    name: "Aleksy Stocki",
    role: "Młodszy analityk danych B+R",
    img: "aleksy_stocki.jpg"
  }],
  about: {
    hedingTopText: '<strong>Rozwiązania</strong><br />dla ochrony ptaków',
    hedingSubText: '',
    headingText: 'Spółka Bioseco została utworzona w kwietniu <strong>2013 r.</strong> przez grupę specjalistów w dziedzinie optoelektroniki, radiolokacji i IT w celu opracowania systemu monitorującego i chroniącego ptaki.',
    headSectionTopText: 'Dlaczego nasze<br /><strong>rozwiązanie?</strong><div class="line"></div>',
    headSectionText: 'Firma współpracuje ściśle z ornitologami, chiropterologami i operatorami farm wiatrowych. Przez lata Bioseco udoskonaliło i zoptymalizowało innowacyjny i opłacalny system chroniący ptaki przed kolizjami z turbinami wiatrowymi.',
    ourCertsTitle: 'Nasze<br /> <strong>certyfikaty</strong>',
    ourTeamTitle: 'Nasz<br /><strong>zespół</strong><div class="line"></div>',
    ourTeamText: 'Zespół Bioseco składa się z inżynierów IT, ornitologów, chiropterologów i innych specjalistów skupionych na badaniu awifauny. Współpracujemy z instytucjami takimi jak: Instytut Morski w Gdańsku, Pomorski Park Naukowo-Technologiczny w Gdyni, Technopark Gliwice oraz z organizacjami ornitologicznymi. Celem Bioseco jest tworzenie urządzeń i narzędzi do miarodajnego badania przyrody, które mogą mieć szerokie praktyczne zastosowanie.',
    ourClientsTitle: 'Nasi klienci',
    personOne: 'Adam Jaworski',
    personOneRole: 'CEO',
    personTwo: 'Dawid Gradolewski',
    personTwoRole: 'CTO',
    personThree: 'Małgorzata Alboszta',
    personThreeRole: 'Analityk',
    personFour: 'Damian Kaniecki',
    personFourRole: 'Projektant',
    personFive: 'Paweł Hrynkiewicz',
    personFiveRole: 'Konstruktor',
    personSixRole: 'Elektronik',
    personSeven: 'Damian Dziak',
    personSevenRole: 'Programista',
    personEight: 'Szymon Witkowski',
    personEightRole: 'Programista',
    personNine: 'Krzysztof Domozych',
    personNineRole: 'Konstruktor'
  },
  farmsProducts: {
    headerTopText: '<strong>Rozwiązanie</strong><br />dla farm wiatrowych',
    headerTopSubText: '',
    headerTopTextPresentation: 'Rozwiązanie dla farm wiatrowych',
    headerTopSubTextPresentation: 'Zobacz, jak działa nasz innowacyjny system Bioseco BIRD PROTECTION SYSTEM (BPS)',
    headerText: 'Corocznie dochodzi do wielu kolizji ptaków i nietoperzy z łopatami turbin wiatrowych. Aby znacznie ograniczyć liczbę wypadków, Bioseco stworzyło system ochrony ptaków.',
    whyOurSolutionText: '',
    whyOurSolution: 'Dlaczego nasze rozwiązanie?',
    sectionOneTitle: 'Główne założenie',
    sectionOneText1: 'System urządzeń i oprogramowania zainstalowanego na turbinach',
    sectionOneText2: 'Oszacowanie ilości przelatujących ptaków, rozmiarów i kierunku lotu',
    sectionOneText3: 'Wyzwolenie akcji: ostrzeżenie ptaków i/lub zatrzymanie turbiny',
    sectionOneText4: 'Stworzenie “tarczy bezpieczeństwa”',
    sectionOneText5: 'Zbieranie danych, archiwizowanie w celu generowania statytyk',
    sectionTwoTitle: 'Korzyści',
    sectionTwoText1: '<strong class="bolded">Ochrona ptaków przed zderzeniami z łopatami turbin wiatrowych</strong>',
    sectionTwoText2: 'Korzyści dodatkowe',
    sectionTwoText3: 'Uniknięcie przesiedlenia lęgowisk oraz prowadzenie dodatkowych badań',
    sectionTwoText4: 'Zbieranie cennych danych pod badania przyrodnicze',
    sectionThreeTitle: 'Technologia',
    sectionThreeText1: 'Bezinwazyjny montaż (wykorzystanie istniejącej infrastruktury)',
    sectionThreeText2: 'Objęcie systemem całej farmy',
    sectionThreeText3: 'Schemat działania: detektory na turbinach przekazują dane do jednostki centralnej, gdzie dokonywana jest analiza i wybór odpowiedniej czynności (ostrzeżenie/spowolnienie pracy turbiny/zatrzymanie), achiwizacja danych i przekazanie ich online do użytkownika.',
    sectionThreeText4: 'Elastyczność zastosowania - dopasowanie się do potrzeb użytkownika oraz specyfiki farmy',
    whyIShouldUseThis: 'Dlaczego powinno się tego używać?',
    whyIShouldUseThisOneTopBefore: '',
    whyIShouldUseThisOneTop: '314,000',
    whyIShouldUseThisOneTopAfter: '',
    whyIShouldUseThisOneText: 'liczba aktywnych turbin wiatrowych na całym świecie',
    whyIShouldUseThisTwoTopBefore: '$',
    whyIShouldUseThisTwoTop: '109',
    whyIShouldUseThisTwoTopAfter: 'mld',
    whyIShouldUseThisTwoText: 'kwota zainwestowana w energetykę wiatrową na całym świecie',
    whyIShouldUseThisThreeTopBefore: '',
    whyIShouldUseThisThreeTop: '5',
    whyIShouldUseThisThreeTopAfter: 'mln',
    whyIShouldUseThisThreeText: 'ptaków i nietoperzy ginie rocznie z powodu kolizji z turbinami wiatrowymi',
    whyIShouldUseThisFourTopBefore: '',
    whyIShouldUseThisFourTop: '300',
    whyIShouldUseThisFourTopAfter: 'km/h',
    whyIShouldUseThisFourText: 'prędkość łopaty śmigła'
  },
  farmsPresentation: {
    title: 'Wind farm - bird collisions',
    steps: [{
      title: "Problem kolizji",
      text: "Kolizje z turbinami wiatrowymi zabijają rocznie miliony ptaków i nietoperzy na całym świecie."
    }, {
      title: "Bioseco BIRD PROTECTION SYSTEM (BPS)",
      text: "Stworzony przez Bioseco system zapobiega kolizjom ptak\xF3w z \u0142opatami turbin wiatrowych. System wykrywa i monitoruje ptaki w przestrzeni powietrznej wok\xF3\u0142 turbiny. Urz\u0105dzenia s\u0105 umieszczne w taki spos\xF3b aby chroni\u0107 ptaki na ca\u0142ej farmie wiatrowej."
    }, {
      title: "Wykrywanie",
      text: "System wykrywa ptaki w odległości do 500 m od turbiny i analizuje ich wielkość, trajektorię lotu oraz prawdopodobieństwo kolizji."
    }, {
      title: "Światła ostrzegawcze",
      text: "Jeśli ptaki znajdą się w ustalonej odległości od turbiny, system zaczyna wysyłać jasne stroboskopowe światła w celu ostrzeżenia o zagrożeniu znajdującym się przed nimi."
    }, {
      title: "Dźwięki ostrzegawcze",
      text: "Dodatkowe sygnały dźwiękowe (syreny lub inne dźwięki ostrzegawcze) są uruchamiane, gdy ptaki kontynuują lot w kierunku turbiny."
    }, {
      title: "Zatrzymanie turbiny",
      text: "System może dodatkowo wyłączyć lub spowolnić turbinę, jeśli trajektoria lotu ptaków nadal jest kolizyjna z łopatami turbiny. Dzięki temu ptaki mogą bezpiecznie minąć przeszkodę."
    }, {
      title: "Bezpieczne przejście",
      text: "Ptaki, które ominęły łopaty, są nadal monitorowane. Turbina zaczyna znowu pracować dopiero wtedy, gdy zwierzęta bezpiecznie miną strefę zagrożenia."
    }, {
      title: "Raportowanie",
      text: "System gromadzi szczegółowe rejestry każdego zdarzenia w celu późniejszej analizy. Zapewnia pełne dane i narzędzia statystyczne dla  użytkowników.<br/><br/><img src='/static/img/product/desktop.jpg' width='200' style='float: right;'><br/><br/>"
    }]
  },
  airportProducts: {
    headerTopText: '<strong>Rozwiązanie</strong><br />dla lotnisk',
    headerTopSubText: '',
    headerTopTextPresentation: 'Rozwiązanie dla lotnisk',
    headerTopSubTextPresentation: 'Zobacz, jak działa nasz innowacyjny system Bioseco AIRPORT FAUNA MONITORING SYSTEM (AFMS)',
    headerText: 'W trosce o bezpieczeństwo pasażerów, Bioseco przygotowało rozwiązanie pomagające redukować liczbę kolizji samolotów z ptakami.',
    whyOurSolutionText: '',
    whyOurSolution: 'Dlaczego nasze rozwiązanie?',
    sectionOneTitle: 'Główne założenie',
    sectionOneText1: 'System urządzeń i oprogramowania zainstalowany na lotnisku',
    sectionOneText2: 'Rozpoznawanie gatunków, wysokości i kierunku przelotu ptaków, zliczanie ptaków',
    sectionOneText3: 'Alerty na tabletach u służb ornitologicznych oraz na wieży kontrolnej',
    sectionOneText4: 'Wyzwolenie akcji – odstraszenie w indywidualny sposób każdego z gatunków – akcja automatyczna lub zatwierdzona manualnie',
    sectionOneText5: 'Zbieranie danych, archiwizowanie w celu generowania statystyk',
    sectionTwoTitle: 'Korzyści',
    sectionTwoText1: 'Zwiększenie poziomu bezpieczeństwa pasażerów',
    sectionTwoText2: 'Obniżenie kosztów związanych z kolizjami z ptakami oraz obniżenie kosztów zapobiegania kolizjom',
    sectionTwoText3: 'Zbieranie danych z długich okresów i możliwość ich różnorodnego wykorzystania, np. zaplanowanie działań w kolejnych sezonach migracyjnych i lęgowych',
    sectionTwoText4: 'Ochrona ptaków',
    sectionTwoText5: 'Zautomatyzowanie części działań',
    sectionTwoText6: 'Ułatwienie pracy służbom lotniskowym',
    sectionTwoText7: 'Lepsze relacje z liniami lotniczymi',
    sectionTwoText8: 'Argument do obniżenia składek ubezpieczeniowych',
    sectionTwoText9: 'Wizerunek firmy dbającej o bezpieczeństwo pasażerów oraz wdrażającej najnowsze, innowacyjne technologie',
    sectionTwoText10: '',
    sectionThreeTitle: 'Technologia',
    sectionThreeText1: 'Małoinwazyjny montaż (wykorzystanie istniejącej infrastruktury)',
    sectionThreeText2: 'Objęcie monitoringiem wszystkich newralgicznych miejsc wokół pasa startowego',
    sectionThreeText3: 'Schemat działania: jednostki zespolone przekazują informacje online do tabletów oraz na serwery, gdzie dokonywana jest analiza danych i archiwizacja',
    sectionThreeText4: 'Rozwiązanie bezpieczne dla komunikacji portu lotniczego, systemów bezprzewodowych i radiowych',
    sectionThreeText5: 'Elastyczność zastosowania – dopasowanie się do specyfiki lotniska',
    whyIShouldUseThis: 'Dlaczego powinno się tego używać?',
    whyIShouldUseThisOneTopBefore: '',
    whyIShouldUseThisOneTop: '65,139',
    whyIShouldUseThisOneTopAfter: '',
    whyIShouldUseThisOneText: 'kolizji samolotów z ptakami zostało zanotowanych w latach 2011-14',
    whyIShouldUseThisTwoTopBefore: '',
    whyIShouldUseThisTwoTop: '92',
    whyIShouldUseThisTwoTopAfter: '%',
    whyIShouldUseThisTwoText: 'kolizji występuje na wysokości poniżej 900m',
    whyIShouldUseThisThreeTopBefore: '',
    whyIShouldUseThisThreeTop: '90',
    whyIShouldUseThisThreeTopAfter: '%',
    whyIShouldUseThisThreeText: 'kolizji występuje w pobliżu lotniska',
    whyIShouldUseThisFourTopBefore: '$',
    whyIShouldUseThisFourTop: '1,2',
    whyIShouldUseThisFourTopAfter: 'mld',
    whyIShouldUseThisFourText: 'koszty kolizji samolotów z ptakami, jakie ponoszą linie lotnicze'
  },
  airportPresentation: {
    title: 'Aircraft-bird collisions',
    steps: [{
      title: 'Zderzenie samolot - ptak',
      text: "Zderzenia ptaków z samolotami podczas startów i lądowań powodują rocznie na całym świecie ponad <strong>1,2 miliarda dolarów</strong> strat. Wpływają na konieczność napraw samolotów, opóźnienia w lotach, a przede wszystkim narażają bezpieczeństwo pasażerów i załogi samolotów."
    }, {
      title: 'Bioseco AIRPORT FAUNA MONITORING SYSTEM (AFMS)',
      text: "System jest zainstalowany w odległości ok. 200 m od pasa startowego i wykrywa ptaki lecące w kluczu w promieniu 300 m."
    }, {
      title: 'Monitorowanie',
      text: "System monitoruje aktywność ptaków, a pozyskane  informacje wysyłane są w czasie rzeczywistym do służb odpowiedzialnych za  bezpieczeństwo na lotnisku."
    }, {
      title: 'Ostrzeganie',
      text: "Na podstawie informacji uzyskanych z Systemu Bioseco służby odpowiedzialne za ochronę lotniska podejmują odpowiednie działania zapobiegawcze."
    }, {
      title: 'Oprogramowanie',
      text: "System bazodanowy zbiera informacje o wszystkich zdarzeniach umożliwiając łatwe generowanie raportów i analizę wszystkich zdarzeń. Dodatkowo informacje o wykrytych obiektach w czasie rzeczywistym wyświetlane są u pracowników służby ochrony na urządzeniach mobilnych."
    }, {
      title: 'Obserwacja 360°',
      text: "W zależności od ilości modułów System Bioseco dla lotnisk umożliwia obserwację do 360°. Detektory są umieszczone w szczelnych i odpornych na niekorzystne warunki atmosferyczne obudowach."
    }, {
      title: 'Bezpieczny start i lądowanie',
      text: "Używane podzespoły nie kolidują z infrastrukturą komunikacyjną na lotnisku. Technologia Bioseco dla lotnisk jest elastyczna, łatwo ją dostosować do konkretnych potrzeb oraz warunków każdego lotniska."
    }]
  },
  areaProducts: {
    headerTopText: '<strong>Rozwiązanie</strong><br />dla ornitologów',
    headerTopSubText: '',
    headerTopTextPresentation: 'Rozwiązanie dla ornitologów',
    headerTopSubTextPresentation: 'Zobacz, jak działa nasz innowacyjny system Bioseco BIRD PROTECTION SYSTEM (BPS)',
    headerText: 'Technologie, tworzone przez Bioseco, oprócz zastosowań na farmach wiatrowych, czy lotniskach, mogą stać się przydatnym narzędziem dla ornitologów. Otrzymują oni urządzenie, pozwalające na pozyskanie bardzo precyzyjnych, w pełni wiarygodnych i uznawanych przez ekspertów danych. Dzięki Bioseco BIRD PROTECTION SYSTEM (BPS) można nieprzerwanie rejestrować wszystkie informacje dotyczące przelatujących ptaków. W wyniku automatycznej analizy wykrytych przez Bioseco BIRD PROTECTION SYSTEM (BPS) zdarzeń otrzymuje się niepodważalne, zrozumiałe i nieusuwalne dane.',
    whyOurSolutionText: '',
    whyOurSolution: 'Co możesz uzyskać?',
    sectionOneTitle: 'Główne założenia',
    sectionOneText1: 'Oprogramowanie Bioseco pozwala na analizę w czasie rzeczywistym i stały dostęp do zapisanych informacji za pośrednictwem strony internetowej lub dowolnego urządzenia mobilnego.',
    sectionOneText2: 'Olbrzymia ilość danych daje możliwość porównania różnych parametrów dotyczących przelatujących ptaków. Z wykorzystaniem systemu BIRD PROTECTION SYSTEM (BPS) Twoje badania lub raport środowiskowy mogą być wykonane szybciej i bardziej wiarygodnie, przy użyciu najnowocześniejszych systemów IT.',
    sectionTwoTitle: 'Jak to działa?',
    sectionTwoText1: 'wykrywanie ptaków przelatujących w promieniu 300 m',
    sectionTwoText2: 'Główne cechy systemu BIRD PROTECTION SYSTEM (BPS):',
    sectionTwoText3: 'określanie wysokości przelotu, prędkości, kierunku lotu oraz odległości ptaka od urządzenia',
    sectionTwoText4: 'zapis danych środowiskowych oraz meteorologicznych w odniesieniu do daty i godziny',
    sectionTwoText5: 'kompaktowe urządzenie zdolne do pracy w każdym terenie: lasy, góry lub morze',
    sectionTwoText6: 'nagrywanie 24 h na dobę w jakości HD ',
    sectionTwoText7: '',
    whyIShouldUseThis: 'Dlaczego powinno się tego używać?',
    whyIShouldUseThisOneTopBefore: '',
    whyIShouldUseThisOneTop: '450',
    whyIShouldUseThisOneTopAfter: '',
    whyIShouldUseThisOneText: 'gatunków ptaków w Polsce',
    whyIShouldUseThisTwoTopBefore: '',
    whyIShouldUseThisTwoTop: '26',
    whyIShouldUseThisTwoTopAfter: '',
    whyIShouldUseThisTwoText: 'gatunków nietoperzy w Polsce',
    whyIShouldUseThisThreeTopBefore: '',
    whyIShouldUseThisThreeTop: '10000',
    whyIShouldUseThisThreeTopAfter: 'km',
    whyIShouldUseThisThreeText: 'pokonują bociany w trakcie migracji',
    whyIShouldUseThisFourTopBefore: '',
    whyIShouldUseThisFourTop: '5000',
    whyIShouldUseThisFourTopAfter: '',
    whyIShouldUseThisFourText: 'birdwatcherów w Polsce'
  },
  areaPresentation: {
    title: 'Rozwiązanie dla ornitologów',
    steps: [{
      title: "Badania środowiskowe",
      text: "Bioseco BIRD PROTECTION SYSTEM (BPS) to narzędzie dla ornitologów, idealnie nadające się do  monitoringu ptaków w przestrzeni powietrznej. Wykrywa je z odległości nawet 500 m, rejestrując m.in. wysokość, prędkość, czy kierunek ich przelotu. Otrzymywane dane są w pełni wiarygodne, precyzyjne oraz uznawane przez ekspertów oraz instytucje."
    }]
  },
  contact: {
    stayInContact: 'Pozostańmy w kontakcie',
    newBuilding: '(nowy budynek PPNT)',
    haveQuestions: 'Masz pytania? Kliknij tutaj',
    pl: 'Polska',
    street: 'Ul. Budowlanych 68',
    account: 'nr konta',
    project: 'Projekty dofinansowane z UE'
  },
  component: {
    moreAboutUs: 'Dowiedz się więcej',
    watchPresentation: 'Zobacz prezentację',
    watchPromoVideo: 'Zobacz film promocyjny',
    watchBooklet: 'Pobierz broszurę',
    bookletPolish: 'język polski',
    bookletEnglish: 'język angielski',
    bookletDeutch: 'język niemiecki',
    bookletFrench: 'język francuski',
    bookletJapanese: 'język japoński',
    watchVideo: 'Zobacz video',
    watchExampleVideo: 'Zobacz rzeczywisty przykład działania BPS',
    watchUs: 'Zobacz nas<br /><strong>w akcji</strong>',
    moreInfo: 'Potrzebujesz więcej informacji?',
    askAboutMore: 'Zapytaj o więcej'
  },
  questionModal: {
    haveQuestion: 'Masz pytania?',
    completeForm: 'Wypełnij poniższy formularz, z przyjemnością odpowiemy:',
    name: 'Imię i Nazwisko',
    email: 'Adres e-mail',
    queryTopicText: 'Wybierz temat zapytania',
    queryTopic: {
      questionOne: 'Produkty dla farm wiatrowych',
      questionTwo: 'Produkty dla lotnisk',
      questionThree: 'Produkty dla ornitologów',
      questionFour: 'Współpraca',
      questionFive: 'Zapytanie ogólne'
    },
    content: 'treść',
    errorMsg: 'Uzupełnij brakujące pola',
    errorSendMsg: 'Błąd podczas wysyłania',
    sendMsg: 'Wysłano formularz',
    send: 'Wyślij',
    rodo: "Administratorem Pa\u0144stwa danych osobowych ujawnionych w powy\u017Cszym formularzu kontaktowym jest\n          Bioseco Sp\xF3\u0142ka akcyjna z siedzib\u0105 w Gda\u0144sku (80-298), ul. Budowlanych 68.\n          Dane osobowe ujawnione w niniejszym formularzu b\u0119d\u0105 przetwarzane w celu obs\u0142ugi przes\u0142anego zapytania na\n          podstawie prawnie uzasadnionego interesu administratora tj. art. 6 ust. 1 lit. f RODO, polegaj\u0105cego na dbaniu\n          o jako\u015B\u0107 swoich us\u0142ug i komunikacj\u0119. Przys\u0142uguje Pa\u0144stwu \u017C\u0105danie dost\u0119pu do swoich danych osobowych, ich\n          sprostowania, usuni\u0119cia lub ograniczenia przetwarzania.\n          Ponadto przys\u0142uguje Pa\u0144stwu wniesienie sprzeciwu wobec przetwarzania swoich danych osobowych oraz prawo do\n          wniesienia skargi do organu nadzorczego- Prezesa Urz\u0119du Ochrony Danych Osobowych. Wi\u0119cej informacji na temat\n          przetwarzania Pa\u0144stwa danych osobowych znale\u017A\u0107 mo\u017Cecie w Naszej Polityce prywatno\u015Bci zamieszczonej pod\n          adresem: ",
    rodoLink: 'Polityka prywatności'
  },
  mediaBox: {
    title: "Media o nas",
    mediaBoxes: [{
      img: "/static/img/media/img1.jpg",
      title: "GAZETA WYBORCZA",
      text: "główna gazeta codzienna, artykuł o systemie farm wiatrowych <span class=arrow></span>",
      link: "http://wyborcza.biz/biznes/1,147584,20695368,bioseco-odstrasza-ptaki-a-przyciaga-inwestorow.html",
      type: "text-type"
    }, {
      img: "/static/img/media/img4.jpg",
      title: "PULS BIZNESU",
      text: "czołowy dziennik biznesowy, artykuł o systemie na lotnisku w Gdańsku <span class=arrow></span>",
      link: "http://pulsbiznesu.pb.pl/3867943,56421,bioseco-ochroni-samoloty-przed-ptakami",
      type: "text-type"
    }, {
      img: "/static/img/media/img7.jpg",
      title: "TVN24",
      text: "telewizyja informacyjna, wiadomość o współpracy Bioseco i PGE SA <span class=arrow></span>",
      link: "http://tvn24bis.pl/z-kraju,74/powstaje-system-do-monitorowania-ptakow-w-poblizy-farm-wiatrowych,517386.html",
      type: "text-type"
    }, {
      img: "/static/img/media/img5.jpg",
      title: "PGE SA",
      text: "strona internetowa PGE SA, oświadczenie o współpracy z Bioseco <span class=arrow></span>",
      link: "http://www.gkpge.pl/biuro-prasowe/komunikaty-prasowe/inne/multirejestratory-beda-monitorowac-ptaki-na-terenie-farm-wiatrowych-pge",
      type: "text-type"
    }]
  },
  media: {
    description: "Zobacz nas w akcji"
  },
  infoBox: {
    title: "Media o nas",
    newsTitle: "Aktualności",
    archiveTitle: "Archiwum",
    linkDescription: "Czytaj więcej : ",
    postedDescription: "Aktualizacja: ",
    infoBoxes: [{
      img: "/static/img/media/Bioseco_RFQ.png",
      title: "Zaproszenie do składania ofert. Zapytanie ofertowe PMT/4/2021.",
      text: "W związku z udziałem w programie Polskie Mosty Technologiczne organizowanym przez Polską Agencję Inwestycji i Handlu, w ramach Programu Operacyjnego Inteligentny Rozwój 2014-2020; oś priorytetowa III Wsparcie innowacji w przedsiębiorstwach, działanie 3.3 Wsparcie promocji oraz internacjonalizacji innowacyjnych przedsiębiorstw, poddziałanie 3.3.1 Polskie Mosty Technologiczne, Bioseco sp.z o.o. zaprasza do składania ofert na wykonanie usług zleconych wg podanej w załączniku specyfikacji. <br/><br /> Załącznik: <a download href='/static/RFQ_PMT.4.2021_Bioseco.docx.pdf'>RFQ_PMT.4.2021_Bioseco.pdf</a>",
      type: "text-type",
      date: "02.04.2021"
    }, {
      img: "/static/img/media/Bioseco_RFQ.png",
      title: "Wybór oferty. Zapytanie ofertowe PMT/1/2021.",
      text: "W związku z udziałem w programie Polskie Mosty Technologiczne organizowanym przez Polską Agencję Inwestycji i Handlu, w ramach Programu Operacyjnego Inteligentny Rozwój 2014-2020; oś priorytetowa III Wsparcie innowacji w przedsiębiorstwach, działanie 3.3 Wsparcie promocji oraz internacjonalizacji innowacyjnych przedsiębiorstw, poddziałanie 3.3.1 Polskie Mosty Technologiczne, Bioseco sp.z o.o. wybrało najkorzystniejszą ofertę złożoną w odpowiedzi na zapytanie ofertowe PMT/1/2021. Oferantem jest American Wind Wildlife Institute (AWWI),  siedzibą w Washingotn DC, USA (1990 K Street NW, 20006), z zamówieniem na kwotę 8,850,51 USD.<br/><br /><img src='/static/img/RFQ_PMT.1.2021_Bioseco.png' alt='RFQ_PMT'/>",
      type: "text-type",
      date: "03.02.2021"
    }, {
      img: "/static/img/media/Bioseco_RFQ.png",
      title: "Zaproszenie do składania ofert. Zapytanie ofertowe PMT/1/2021.",
      text: "W związku z udziałem w programie Polskie Mosty Technologiczne organizowanym przez Polską Agencję Inwestycji i Handlu, w ramach Programu Operacyjnego Inteligentny Rozwój 2014-2020; oś priorytetowa III Wsparcie innowacji w przedsiębiorstwach, działanie 3.3 Wsparcie promocji oraz internacjonalizacji innowacyjnych przedsiębiorstw, poddziałanie 3.3.1 Polskie Mosty Technologiczne, Bioseco sp.z o.o. zaprasza do składania ofert na wykonanie usług zleconych wg podanej w załączniku specyfikacji.<br/><br /><img src='/static/img/RFQ_PMT.1.2021_Bioseco.png' alt='RFQ_PMT'/><br/><br /> Załącznik: <a download href='/static/RFQ_PMT.1.2021_Bioseco.pdf'>RFQ_PMT.1.2021_Bioseco.pdf</a> ",
      type: "text-type",
      date: "22.01.2021"
    }, {
      img: "/static/img/media/spain_december.jpg",
      title: "Kolejny system w Hiszpanii. ",
      text: "Zainstalowaliśmy właśnie systemy ochrony ptaków w okolicy Kadyksu. System działa na farmie wiatrowej, na której monitoring był prowadzony stacjonarnie, przez obserwatorów. W przypadku przelotów ptaków manualnie wysyłali sygnał zatrzymania turbiny.",
      type: "text-type",
      date: "17.12.2020"
    }, {
      img: "/static/img/media/bioseco_france.jpg",
      title: "Bioseco wchodzi na nowy rynek – Francja!",
      text: "W tym tygodniu zainstalowaliśmy nasze trzy systemy BPS we Francji. Cieszymy się, że taka firma jak WPO zdecydowała się na ochronę ptaków przy wsparciu Bioseco. Po raz pierwszy nasze urządzenia pracują na turbinach Gamesa. \n" + "Nowa generacja systemu stereowizyjnego umożliwia szacowanie odległości i klasyfikację wielkości ptaków oraz filtrowanie fałszywych zdarzeń. Dodatkowo wspomaganie sztuczną inteligencją ograniczy do minimum niepotrzebne zatrzymania turbin i straty w wytwarzaniu energii.",
      type: "text-type",
      date: "23.11.2020"
    }, {
      img: "/static/img/media/mosty_technologiczne.jpg",
      title: "Bioseco otrzymało dofinansowanie w ramach projektu Polskie Mosty Technologiczne",
      text: "Projekt Polskie Mosty Technologiczne Polskiej Agencji Inwestycji i Handlu ma na celu wsparcie promocji oraz internacjonalizacji innowacyjnych przedsiębiorstw. Za takie przedsiębiorstwo zostało uznane Bioseco. W ramach naboru „V/2019: Chiny, Stany Zjednoczony, ZEA” Bioseco dostało 200tys PLN finansowania na eksplorację rynku Stanów Zjednoczonych. ",
      type: "text-type",
      date: "14.11.2020"
    }, {
      img: "/static/img/media/photonics.jpg",
      title: "Wyróżnienie dla Bioseco w programie Tech Tour Photonics",
      text: "Bioseco znalazło się w gronie zwycięzców tegorocznej edycji programu Tech Tour Photonics. Tech Tour ma swoje korzenie w Brukseli i Genewie, a w konkursie brały udział innowacyjne firmy z całej Europy. ",
      type: "text-type",
      date: "02.11.2020"
    }, {
      img: "/static/img/media/bioseco_kreatywni.jpg",
      title: "Sukces Bioseco na gali 50 Najbardziej Kreatywnych Ludzi w Biznesie",
      text: "Krzysztof Paszek znalazł się szacownym gronie 50 Najbardziej Kreatywnych Ludzi w Biznesie i zajął wśród wyróżnionych zaszczytne drugie miejsce. Jubileuszowa Gala odbyła się pod egidą Ministerstwa Rozwoju i wielu uznanych firm oraz instytucji, takich jak: PKN ORLEN, Millennium Leasing, E. Wedel, Google for Startups, Krajowa Izba Gospodarcza i wielu innych.\n" + "Więcej zobaczyć można <a href='https://www.youtube.com/watch?v=0OX_B1NL10Y' target='_blank'>tutaj</a>.",
      type: "text-type",
      date: "28.09.2020"
    }, {
      img: "/static/img/media/bioseco_ce.jpg",
      title: "Certyfikat CE",
      text: "Z przyjemnością informujemy, że nasz system BPS przeszedł rygorystyczne testy i sprostał wymaganiom UE dotyczącym sprzętu elektrycznego. Mogliśmy wystawić deklarację zgodności UE i od teraz urządzenia Bioseco posiadają oznakowanie CE.",
      type: "text-type",
      date: "01.09.2020"
    }, {
      img: "/static/img/media/photo_cooperation.jpg",
      title: "Bioseco wchodzi do Austrii poprzez pozyskanie Partnera lokalnego – Energiwerkstatt",
      text: "Niedawno Bioseco + Windhunter + Energiewerkstatt uzgodniły warunki współpracy w zakresie sprzedaży systemów ochrony ptaków Bioseco  w Austrii.\n" + "W zeszłym tygodniu Florian Lachinger (Energiewerkstatt) i Maciej Łaz (Windhunter Service) odwiedzili siedzibę Bioseco, a następnie pojechaliśmy wspólnie aby zobaczyć system Bioseco działający na farmie wiatrowej.\n" + "Mamy nadzieję, że ta współpraca przyniesie wymierne rezultaty dla wszystkich zaangażowanych, a także finalnie przyczyni się do wzrostu poziomu ochrony ptaków.",
      date: "30.07.2020"
    }, {
      img: "/static/img/media/gwo.jpg",
      title: "Ekipa Bioseco przeszkolona w standardach GWO przez Windhunter",
      text: "Ekipa instalacyjna i techniczna Bioseco została niedawno przeszkolona przez naszego Partnera – Windhunter zgodnie ze standardami GWO. <br />Podczas zwiększania zasięgu i ilości operacji musimy pamiętać o zapewnieniu bezpieczeństwa i najwyższych standardów działania.",
      type: "text-type",
      date: "21.07.2020"
    }, {
      img: "/static/img/media/bps_germany.jpg",
      title: "Ważna instalacja w Niemczech dla BayWa r.e.",
      text: "Bioseco zainstalowało dwa systemy ochrony ptaków w ramach projektu pilotażowego w Niemczech we współpracy z dużym deweloperem i operatorem farm wiatrowych BayWa r.e.\n" + "Obie strony mają wysokie oczekiwania co do poziomu ochrony ptaków i jednoczesnego ograniczenia niepotrzebnych przestojów, a tym samym zwiększenia efektywności produkcji energii.\n" + "Zarówno zespół Bioseco, jak i BayWa r.e. z niecierpliwością czekają na mierzalne efekty, które wniosą wkład do toczącej się obecnie w Niemczech dyskusji o ochronie ptaków na farmach wiatrowych.",
      type: "text-type",
      date: "15.05.2020"
    }, {
      img: "/static/img/media/wspolpraca-pgeeo.jpg",
      video: "/static/video/bird_tracking.mp4",
      poster: "/static/video/poster_bird_tracking.png",
      title: "Przykładowe wykrycie nagrane w Niemczech",
      text: "Niedawno zainstalowaliśmy 2 nowe systemy Ochrony Ptaków (Bird Protection Systems) w Niemczech z ulepszonym oprogramowaniem. Niedługo po instalacji system zarejestrował przelot średniej wielkości ptaka.",
      type: "text-type",
      date: "04.06.2020"
    }, {
      img: "/static/img/media/installation.jpg",
      video: "/static/video/Bioseco_PL_small.mp4",
      poster: "/static/video/poster.png",
      title: "Rozpoczęliśmy testy system Bioseco na farmie PGE EO",
      text: "Pomimo epidemii koronawirusa. Bioseco kontynuuje swoją misję ratowania ptaków i ochrony inwestorów przed negatywnymi konsekwencjami kolizji ptaków z turbinami wiatrowymi. Przygotowaliśmy dla Was krótki film z naszego ostatniego montażu na jednej z największych farm wiatrowych w Polsce, gdzie zainstalowaliśmy nasz najnowszy ośmio-modułowy system ochrony ptaków.\n" + "<br/>Kolejne instalacje systemu Bioseco planujemy na maj 2020, tym razem w Niemczech.\n" + "<Br/>Pozostańcie w zdrowiu.",
      type: "text-type",
      date: "20.03.2020"
    }, {
      img: "/static/img/media/wfo2020.png",
      title: "Bioseco wzięło udział w 4tym Forum Operatorów Farm Wiatrowych",
      text: "Bioseco wzięło udział w 4 edycji Forum Operatorów Farm Wiatrowych w Sopocie (www.wfof.eu). Oprócz prezentacji systemu Ochrony Ptaków w czasie minitargów, nasz CEO - Adam Jaworski przedstawił  szczegóły działania systemu w czasie warsztatów poprowadzonych razem z Michałem Kaczerowskim z doświadczonej pracowni środowiskowej Ambiens. \n" + "<Br/>Dla zainteresowanych osób jest możliwość uzyskania prezentacji i filmu z warsztatów. \n" + "<br/>Napiszcie na offers@bioseco.com",
      type: "text-type",
      date: "12.03.2020"
    }, {
      img: "/static/img/media/test2020.jpg",
      title: "Świetne wyniki ewaluacji system Ochrony ptaków w Niemczech.",
      text: "Otrzymaliśmy raport z ewaluacji naszego systemu wykonany przez Vogelwarte w ramach kampanii testowej z września/października 2019r. Nasz ośmio modułowy system był testowany w ramach programu NatForWinSent prowadzonego przez ZSW i finansowaniu rządu niemieckiego (<a href='https://www.natur-und-erneuerbare.de/projektdatenbank/projekte/natforwinsent-ii/'>https://www.natur-und-erneuerbare.de/projektdatenbank/projekte/natforwinsent-ii/</a>).\n" + "Skuteczność wykrywania Kanii Rudej osiągnęła 97% w promieniu 200m od systemu. Skumulowana skuteczność w granicach 0-300m wyniosła 83% a w obrębie do 400m od systemu ok. 64%.\n" + "Kolejną dobrą wiadomością była bardzo niska wartość fałszywych wykryć która wyniosła jedynie 7%, z czego tylko 1/3 doprowadziłaby do zatrzymania turbiny, co jest efektem zastosowania stereowizji i zaawansowanych algorytmów detekcji.  ",
      type: "text-type",
      date: "07.02.2020"
    }, {
      img: "/static/img/media/xmas.jpg",
      title: "Prezent na gwiazdkę. 2 systemy z dostawą do Polski sprzedane.",
      text: "Świetny prezent na gwiazdkę. Bioseco podpisało 2 umowy z polskim developerem farm wiatrowych na dostawę 2 Systemów Ochrony Ptaków dla 2 projektów w Polsce, które będą realizowane w 2 połowie 2020. Zgodnie z wymogami dwie turbiny Vestas powinny być wyposażone w system chroniący ptaki i zatrzymujący turbinę, gdy ptaki zbliżą się na odległość mniejszą niż 150 m od turbiny wiatrowej. Już nie możemy się doczekać momentu realizacji tej Umowy. \n" + "Wesołych Świąt i Szczęśliwego Nowego Roku.",
      type: "text-type",
      date: "23.12.2019"
    }, {
      img: "/static/img/media/reon.jpg",
      title: "Bioseco i  REON AG podpisują umowę partnerską na Niemcy",
      text: "Bioseco i Reon AG podpisały umowę o współpracy w ramach której REON AG będzie autoryzowanym agentem Bioseco w Niemczech. Mając na uwadze wieloletnią obecność Reon na rynku energetyki wiatrowej W Niemczech, szeroką sieć kontaktów i profesjonalne podejście, Umowa ta stworzy dobre warunki do wejścia Bioseco na najważniejszy na ten moment rynek w Europie. Oczekujemy na szybkie efekty tej współpracy. ",
      type: "text-type",
      date: "20.12.2019"
    }, {
      img: "/static/img/media/bird-tests.jpg",
      title: "Kolejny test systemu Ochrony Ptaków tym razem z użyciem trenowanych sokołów",
      text: "3 tygodnie temu System Bioseco był testowany z pomocą sztucznego ptaka. W zeszłym tygodniu System Ochrony Ptaków Bioseco zainstalowany na turbinie wiatrowej w Polsce był testowany z pomocą trenowanego sokoła. We wszystkich przelotach system wykrył ptaka i zatrzymał turbinę. Gratulacje dla całego zespołu Bioseco w potwierdzeniu skuteczności działania systemu w tym teście i całego trudu włożonego w rozwój systemu w 2019r. ",
      type: "text-type",
      date: "13.12.2019"
    }, {
      img: "/static/img/media/bird.jpg",
      title: "System Ochrony Ptaków Bioseco testowany w Hiszpanii przez globalnego gracza",
      text: "Zastanawiacie się co to jest? System Ochrony Ptaków Bioseco był niedawno testowany na jednej z farm wiatrowych w Hiszpanii należących do globalnego operatora farm wiatrowych. W czasie testu system wykrywał drona przypominającego ptaka, który właśnie jest na zdjęciu. Testy przebiegły bardzo dobrze potwierdzając wysoką sprawność detekcji i zdolność systemu do szacowania odległości pomiędzy dronem a turbiną wiatrową. Właśnie ta cecha jest niezwykle ważna dla operatorów farm wiatrowych aby skutecznie unikać kolizje jednocześnie minimalizując czas wyłączenia turbin. Czekamy na nowe firmy gotowe przetestować system Bioseco z pomocą żywych czy sztucznych ptaków. Więcej dobrych wiadomości niebawem.",
      type: "text-type",
      date: "03.12.2019"
    }, {
      img: "/static/img/media/installation.jpg",
      title: "Kolejna instalacja system ochrony ptaków Bioseco w Polsce",
      text: "W zeszłym tygodniu ekipa Bioseco zainstalowała najnowszy System Ochrony Ptaków na turbinie wiatrowej w Polsce. Kolejna bezpieczna dla ptaków turbina wiatrowa i kolejny inwestor chroniony przeciwko ryzyku związanemu ze śmiertelnością ptaków, a zarazem krok w kierunku komercjalizacji Systemu Ochrony Ptaków. Oczekujemy na nowe wyzwania w zakresie ochrony ptaków.",
      type: "text-type",
      date: "18.10.2019"
    }, {
      img: "/static/img/media/airports.png",
      title: "Umowa na dofinansowanie w kwocie 2,6 milliona złotych na system lotniskowy podpisana",
      text: "Podpisaliśmy Umowę o dofinansowanie z NCBiR (Narodowe Centrum Badań i Rozwoju) umowy na dofinansowanie projektu badawczego o nazwie „Przeprowadzenie prac badawczo-rozwojowych niezbędnych do opracowania nowego autonomicznego systemu AIRPORT FAUNA MONITORING SYSTEM (AFMS) redukującego liczbę kolizji statków powietrznych z ptakami i ssakami.” W ramach projektu Bioseco ma wytworzyć w pełni funkcjonalny produkt, który ma zwiększyć bezpieczeństwo na lotniskach w zakresie zarządzania ryzykiem środowiskowym. Projekt będzie realizowany w latach 2020-2022. \n" + "<Br/><br/>Wartość projektu to prawie 3,5mln złotych, a wartość dofinansowanie to ponad 2,6mln złotych.\n" + "<br/><br/>W ten sposób Bioseco kontynuuje inwestycję w swoją drugą linię biznesową poświęconą bezpieczeństwu na lotniskach.",
      type: "text-type",
      date: "30.09.2019"
    }, {
      img: "/static/img/media/wspolpraca-pgeeo.jpg",
      title: "Współpraca z PGE EO oficjalna",
      text: "To już oficjalne. PGE EO (największy operator farm wiatrowych w Polsce) będzie testował systemy Bioseco na swoich farmach wiatrowych. To znaczący krok w kierunku redukcji negatywnego wpływu energetyki wiatrowej na duże ptaki oraz w rozwoju Systemu Ochrony Ptaków Bioseco. Aby przeczytać więcej zajrzyj na",
      link: "https://pgeeo.pl/Aktualnosci/kamery-i-radary-beda-monitorowac-ptaki",
      type: "text-type",
      date: "04.09.2019"
    }, {
      img: "/static/img/media/pozytywny.jpg",
      title: "Raport Startupów Pozytywnego Wpływu 2019",
      text: "Chcielibyśmy podziękować Kozminski Business Hub za przedstawienie Nas w Raporcie Startupów Pozytywnego Wpływu 2019. Raport ten jest zbiorem polskich firm, które zajmują się tworzeniem wartości na rzecz zrównoważonego rozwoju. Bioseco trafiło do grona Startupów które cechują się innowacyjnością oraz dużymi możliwościami zwiększenia swojego działania.<br/><br/>Zapraszamy do zapoznania się z raportem.<br/>Informacje o Naszej firmie znajdują się na stronach 69-71.",
      link: "http://raportspw.kozminskihub.com/",
      type: "text-type",
      date: "30.04.2019"
    }, {
      img: "/static/img/media/upgrade.jpg",
      title: "Update Systemu",
      text: "W ubiegłym tygodniu nasz zespół zaktualizował systemy na farmie wiatrowej zlokalizowanej na południu Polski.<br />Sześć naszych modułów zostało wymienionych na nową generację systemu ochrony ptaków.<br /><br />Zaktualizowane systemy są wyposażone w moduły umożliwiające odtwarzanie dowolnych dźwięków - od syren po odgłosy ptaki drapieżnych, z regulowaną głośnością aż do 120dB.<br />Moduł wizualny może mierzyć odległość ptaków od wiatraka a dzięki 3 zainstalowanym kamerom zapewnia obraz o wysokiej rozdzielczości.<br /><br />Jesteśmy przekonani, że nowy system przyniesie wspaniałe efekty!",
      link: "https://www.linkedin.com/company/bioseco/",
      type: "text-type",
      date: "05.04.2019"
    }, {
      img: "/static/img/media/move.jpg",
      title: "Przeprowadzka Bioseco!",
      text: "Można Nas znaleźć w nowej lokalizacji, kilka minut od gdańskiego lotniska.<br /> Wraz z powiększeniem przestrzeni, łatwiej nam rozbudowywać nasz system i rozwijać naszą organizację.<br />Nowy adres to <strong>Budowlanych 68, Gdańsk</strong>.<br /><br />Zapraszamy!",
      link: "https://www.linkedin.com/feed/update/urn:li:activity:6523494951689560064",
      type: "text-type",
      date: "29.04.2019"
    }, {
      img: "/static/img/media/wolves.jpg",
      title: "Wolves summit",
      text: "Wolves Summit był wielkim sukcesem dla Bioseco.<br />Zakwalifikowanie się do półfinału konkursu Great Pitch jest potwierdzeniem zainteresowania naszą organizacją.<br />Przeprowadzone rozmowy i ciekawe spotkania, które odbyły się podczas wydarzenia pomagają rozwijać się zespołowi Bioseco.",
      link: "https://www.linkedin.com/feed/update/urn:li:activity:6513820388680626176",
      type: "text-type",
      date: "21.04.2019"
    }, {
      img: "/static/img/media/n_img1.jpg",
      title: "IEEE N3XT® STARS",
      text: "Zrobiliśmy to! Bioseco właśnie stało się członkiem programu innowacji stworzonego przez EUtop50.<br />Organizacja wspiera młode firmy, które są zaangażowane w tworzenie produktów i technologii, które mają wpływ na potrzeby Europy.   Organizacja jest gospodarzem wydarzenia IEEE N3XT® STARS. O wyborze zwycięzców decydują innowacyjne produkty korzystne dla ludzkości, oparte na inżynierii, zgodne ze standardami IEEE.<br /> Z przyjemnością informujemy, że Bioseco zostało nagrodzone w 2018 roku IEEE N3XT® STARS.<br /> Bycie częścią tak prestiżowej grupy potwierdza nasze przekonanie, że nasze działania wpłyną pozytywnie na otaczający nas świat.<br /> Dziękujemy za nagrodę, która zachęca nasz zespół do ciągłego doskonalenia!",
      link: "https://entrepreneurship.ieee.org/n3xt-stars/",
      type: "text-type",
      date: "28.01.2019"
    }, {
      img: "/static/img/media/top50.jpg",
      title: "Konkurs EUtop50",
      text: "<span class=strong>Właśnie wygraliśmy prestiżowy konkurs EUtop50 w Parlamencie Europejskim w Brukseli!</span><br /><span class=strong>Platforma EUtop50</span> została zorganizowana przy okazji 10. Europejskiego Szczytu Innowacyjności oraz konferencji wysokiego szczebla UE w dziedzinie nauki i innowacji.<br /><span class=strong>Bioseco</span> było jedynym startupem reprezentującym Polskę i jednym z dwóch reprezentujących Europę Środkowo-Wschodnią. <br />Wydarzenie to łączy najlepsze europejskie startupy, wybitnych naukowców, polityków, inwestorów i przedstawicieli biznesu. <br />Nagroda potwierdza, że ​​nasze rozwiązanie zmierza w dobrym kierunku ochrony środowiska dzięki naszej innowacyjnej technologii.",
      link: "https://www.facebook.com/pg/Bioseco-497515667013273/posts/?ref=page_internal",
      type: "text-type",
      date: "29.11.2018"
    }, {
      img: "/static/img/media/sonda2.jpg",
      title: "Innowacja Bioseco zaprezentowana w programie „Sonda 2”",
      text: "W odcinku programu „Sonda 2”, poświęconym w całości ptakom, został przedstawiony problem ich śmiertelności na farmach wiatrowych. Mogliśmy przekazać jak można (i trzeba!) ratować ptaki przed śmiercią w wyniku zderzenia z łopatami turbin. Program został wyemitowany na antenie telewizyjnej Dwójki. Do obejrzenia <a href='https://vod.tvp.pl/video/sonda-2,odc-86-ptaki,37095018' target='_blank'>tutaj</a>",
      type: "text-type",
      date: "25.05.2018"
    }, {
      img: "/static/img/media/scale_up.jpg",
      title: "Bioseco bierze udział w programie KPT ScaleUP w Krakowie",
      text: "Zespół Bioseco, dzięki uczestnictwu w programie KPT ScaleUP, mógł nawiązać kontakty z przedstawicielami Portu Lotniczego Kraków, przetestować prototypy, jak również wziąć udział w całej serii spotkań i szkoleń. ",
      type: "text-type",
      date: "05.08.2017"
    }, {
      img: "/static/img/media/bird-strike.jpg",
      title: "Kongres World Birdstrike Association w Amsterdamie",
      text: "Przedstawiciele Bioseco wzięli udział w najważniejszym spotkaniu branży związanej z kolizjami ptaków z samolotami. Jest to zagadnienie nad wyraz istotne, gdyż rocznie generuje straty ponad dwóch miliardów dolarów. Istnieją organizacje i zrzeszenia, które integrują ekspertów zajmujących się tym tematem. Dla Bioseco to była cenna nauka i szansa na kontakty z najważniejszymi ludźmi z branży, które z pewnością zaprocentują w przyszłości. ",
      type: "text-type",
      date: "06.12.2016"
    }, {
      img: "/static/img/media/kongres.jpg",
      title: "Spotkania na Kongresie 590 w Rzeszowie",
      text: "Bioseco zostało zaproszone do grona innowacyjnych firm, które rozmawiały z przedstawicielami rządu oraz biznesu. Wśród spotkanych osób był również Bruce Dickinson – właściciel firmy Cardiff Aviation i jednocześnie wokalista zespołu Iron Maiden.",
      type: "text-type",
      date: "17.11.2016"
    }, {
      img: "/static/img/media/tedx.jpg",
      title: "Misja Bioseco przedstawiona na TEDx \"Między gatunkami\" – Gdynia ",
      text: "To był zaszczyt móc przedstawić audytorium intelektualistów zagadnienie ochrony ptaków na farmach wiatrowych i opisać sposób rozwiązania, nad którym pracuje zespół Bioseco. ",
      type: "text-type",
      date: "26.11.2015"
    }, {
      img: "/static/img/media/innowacje-tvp.jpg",
      title: "Bioseco w programie „Innowacje dla Ciebie” w TVP",
      text: "W popularnym programie „Innowacje dla Ciebie” red. Romana Młodkowskiego wraz z prezesem Technoparku, prof. Janem Kosmolem, Krzysztof Paszek z Bioseco rozmawiał o innowacjach, wsparciu biznesu i przede wszystkim prezentował koncepcję rozwiązania Bioseco. ",
      type: "text-type",
      date: "17.08.2015"
    }, {
      img: "/static/img/media/horyzont2020.jpg",
      title: "Bioseco zdobyło dotację Horyzont 2020",
      text: "Konsorcjum trzech firm, wśród których znalazło się Bioseco, zdobyło grant z programu Horyzont 2020, SME Instrument Faza 1. Eksperci Komisji Europejskiej na tyle wysoko ocenili projekt detekcji dronów, że znalazł się on w pierwszej dziesiątce projektów z Polski, którym ten grant został przyznany. ",
      type: "text-type",
      date: "10.06.2015"
    }, {
      img: "/static/img/media/mobile-kongres.jpg",
      title: "Udział w Mobile World Congress w Barcelonie",
      text: "Już po raz drugi Bioseco wzięło udział jako wystawca na słynnych targach MWC w Barcelonie. Wśród innych innowacyjnych firm zaprezentowało swoje rozwiązanie do ratowania ptaków na farmach wiatrowych. Duże zainteresowanie i deklaracje od przyszłych klientów potwierdzają kierunek rozwoju technologii Bioseco. ",
      type: "text-type",
      date: "02.03.2015"
    }, {
      img: "/static/img/media/counter.jpg",
      title: "Został zrealizowany projekt detekcji i zliczania samochodów w ruchu miejskim ",
      text: "Bioseco wykonało unikatowy system monitoringu, który polega na zliczaniu samochodów na skrzyżowaniach. Klient będzie używał systemu do monitorowania skuteczności nośników reklam outdoor. \n" + "Więcej w <a href='https://www.portalspozywczy.pl/handel/wiadomosci/nowy-system-do-mierzenia-skutecznosci-reklamy-zewnetrznej,110593.html?fbclid=IwAR0H1iwXtYwS0Yo8uIi9gobgpKVEs6R4d5Qvn-GUzgJ09hA8xAKRScHIK2Y'>artykule</a>",
      type: "text-type",
      date: "02.02.2015"
    }, {
      img: "/static/img/media/sztormy.jpg",
      title: "Nasza firma zdobyła prestiżową nagrodę Pomorskie Sztormy",
      text: "Bioseco zwyciężyło w kategorii Młoda Firma 2014 Roku w konkursie organizowanym przez Marszałka Województwa i Gazetę Wyborczą. Wysoką rangę imprezy podkreśliła obecność prezydentów Gdyni, Gdańska oraz Sopotu, jak również oczywiście Marszałka Województwa. Gala miała miejsce w Teatrze Szekspirowskim w Gdańsku. ",
      type: "text-type",
      date: "20.12.2014"
    }, {
      img: "/static/img/media/swiss.jpg",
      title: "Prezentacja rozwiązania Bioseco w Szwajcarii",
      text: "Na Swiss-Polish Roundtable on Innovation przedstawiciele Bioseco zaprezentowali koncepcję urządzenia i możliwości rozwiązania monitorującego i ratującego ptaki. Temat spotkał się dużym zainteresowaniem. ",
      type: "text-type",
      date: "28.10.2014"
    }, {
      img: "/static/img/media/lider-ppnt.jpg",
      title: "Lider PPNT Gdynia w kategorii „Produkt, usługa, marka”",
      text: "Bioseco otrzymało nagrodę Lider PPNT Gdynia jako najbardziej wyróżniająca się marka i firma w 2014 r. W plebiscycie brała udział cała społeczność PPNT Gdynia licząca niemal trzysta innowacyjnych firm.",
      type: "text-type",
      date: "20.12.2014"
    }]
  }
};

/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii01MzggMjg0IDIwMiAyMzMiPjxwYXRoIGZpbGw9IiNGM0I2NjYiIGQ9Ik0tNTIyLjEgNDAwLjhjLS41LjEtLjYuNi0uNCAxbDE1LjYgMjUuNmMuMy40LjkuNyAxLjMuNmw2OC40LTkuOWMuNS0uMS43LjIuNS43bC0xNi40IDMxLjRjLS4yLjQgMCAuOC41LjdsNy4yLS42Yy41IDAgMS4yLS40IDEuNS0uN2wzNi43LTM4LjNjLjMtLjQgMS0uOCAxLjQtLjlsNDUuMS0xNS4zYy41LS4yIDEuMS0uNiAxLjQtLjlsNi4yLTYuNmMuMy0uNC4yLS44LS4yLS45bC0yMS44LTcuMWMtLjUtLjEtMS4yLS4yLTEuNyAwbC0xMTMuMyAzNC43Yy0uNS4xLTEuMiAwLTEuNi0uMmwtMjIuOC0xNC44Yy0uNC0uMy0xLjEtLjQtMS42LS4ybC02IDEuN3oiLz48cGF0aCBmaWxsPSIjRjNCNjY2IiBkPSJNLTQyNC44IDM4OWMuNS4xLjUuMyAwIC40bC0yMS41IDYuN2MtLjUuMS0xLjIuMS0xLjYtLjFsLTI2LjgtMTEuMmMtLjQtLjItLjQtLjUgMC0uNmw2LjktMi40Yy41LS4yIDEuMi0uMiAxLjctLjFsNDEuMyA3LjN6Ii8+PHBhdGggZmlsbD0iI0YzQjY2NiIgZD0iTS0zMzguMiAzNDEuMWwtOTYuNy01NS44Yy0xLjMtLjctMi45LS43LTQuMiAwbC05Ni43IDU1LjhjLTEuMy43LTIuMSAyLjEtMi4xIDMuNnYxMTEuNmMwIDEuNS44IDIuOSAyLjEgMy42bDk2LjcgNTUuOGMxLjMuNyAyLjkuNyA0LjIgMGw5Ni43LTU1LjhjMS4zLS43IDIuMS0yLjEgMi4xLTMuNlYzNDQuN2MwLTEuNS0uOC0yLjktMi4xLTMuNm0tOTguOCAxNjlsLTk0LjktNTQuOFYzNDUuN2w5NC45LTU0LjggOTQuOSA1NC44djEwOS42bC05NC45IDU0Ljh6Ii8+PC9zdmc+"

/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii01MzggMjg0IDIwMiAyMzMiPjxwYXRoIGZpbGw9IiNGM0I2NjYiIGQ9Ik0tMzM5IDM0MS41bC05Ni01NS40Yy0xLjMtLjctMi44LS43LTQuMSAwbC05NiA1NS40Yy0xLjMuNy0yLjEgMi4xLTIuMSAzLjZ2MTEwLjhjMCAxLjUuOCAyLjggMi4xIDMuNmw5NiA1NS40YzEuMy43IDIuOC43IDQuMSAwbDk2LTU1LjRjMS4zLS43IDIuMS0yLjEgMi4xLTMuNlYzNDUuMWMwLTEuNS0uOC0yLjgtMi4xLTMuNm0tOTggMTY3LjhsLTk0LjItNTQuNFYzNDYuMWw5NC4yLTU0LjQgOTQuMiA1NC40djEwOC44bC05NC4yIDU0LjR6Ii8+PHBhdGggZmlsbD0iI0YzQjY2NiIgZD0iTS0zODguMiA0MDkuMWMuNS0uNCAxLjQtLjcgMi0uNWwxMy4xIDIuNmMuNi4xLjktLjIuNi0uOGwtNS44LTExLjRjLS4zLS42LTEuMS0xLjEtMS43LTEuMWwtMzMuMS0yLjdjLS42LS4xLTEuMy0uNi0xLjQtMS4ybC01LjYtMjMuOGMtLjEtLjYtLjctMS41LTEuMS0xLjlsLTMxLjgtMjguNGMtLjUtLjQtLjgtLjMtLjcuNGwxMi44IDY5LjhjLjEuNi0uMiAxLjUtLjcgMS45bC0yMy41IDE5LjRjLS41LjQtMS40LjYtMiAuNGwtMjIuNS02LjZjLS42LS4yLS45LjEtLjYuN2w5LjMgMTguOWMuMy42IDEgLjkgMS42LjdsNzIuNC0yMC43Yy42LS4yIDEuNS0uNyAyLTEuMWwxNi43LTE0LjZ6Ii8+PHBhdGggZmlsbD0iI0YzQjY2NiIgZD0iTS00ODAuNCAzNTEuOGMtLjYtLjMtLjgtLjEtLjQuNGwzNC42IDU2LjVjLjMuNS41LjUuNC0uMWwtOC00MS4yYy0uMS0uNi0uNy0xLjQtMS4zLTEuN2wtMjUuMy0xMy45eiIvPjwvc3ZnPg=="

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(216)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(123),
  /* template */
  __webpack_require__(303),
  /* scopeId */
  "data-v-7a27e629",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 73 */,
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Home__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Products__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Products___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_Products__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_FarmsProduct__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_FarmsProduct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_FarmsProduct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_AirportProduct__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_AirportProduct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_AirportProduct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_AreaProduct__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_AreaProduct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_AreaProduct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_FarmsPresentation__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_FarmsPresentation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_FarmsPresentation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_AirportPresentation__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_AirportPresentation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_AirportPresentation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_AreaPresentation__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_AreaPresentation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_AreaPresentation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_AboutUs__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_AboutUs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_AboutUs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_Awards__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_Awards___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_Awards__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_Privacy__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_Privacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__pages_Privacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_Blog__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_Blog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__pages_Blog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Auctions__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Auctions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__pages_Auctions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_Infonews__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_Infonews___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__pages_Infonews__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_Contact__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_Contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__pages_Contact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_CofinancedFromEU__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_CofinancedFromEU___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__pages_CofinancedFromEU__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_BPS__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_BPS___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__pages_BPS__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_BPS2__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_BPS2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__pages_BPS2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_PBE__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_PBE___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__pages_PBE__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_PBE2__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_PBE2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__pages_PBE2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_AFMS__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_AFMS___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__pages_AFMS__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_BridgeAlfa__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_BridgeAlfa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__pages_BridgeAlfa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_PMT__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_PMT___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__pages_PMT__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_EIC__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_EIC___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__pages_EIC__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__store_store__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_PPBB__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_PPBB___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__pages_PPBB__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_Certificates__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_Certificates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__pages_Certificates__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_Offshore_vue__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_Offshore_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__pages_Offshore_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__lang_pl__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__lang_en__ = __webpack_require__(41);































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);




var lang = { pl: __WEBPACK_IMPORTED_MODULE_30__lang_pl__["a" /* pl */], en: __WEBPACK_IMPORTED_MODULE_31__lang_en__["a" /* en */] };

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "history",
  routes: [{
    path: "/",
    name: "home",
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Home___default.a,
    meta: {
      title: "home"
    },

    props: {
      canvasVisible: true
    }
  }, {
    path: "/products",
    name: "products",
    component: __WEBPACK_IMPORTED_MODULE_3__pages_Products___default.a,
    meta: {
      title: "products"
    }
  }, {
    path: "/products/farms",
    name: "farms",
    component: __WEBPACK_IMPORTED_MODULE_4__pages_FarmsProduct___default.a,
    meta: {
      title: "farm"
    }
  }, {
    path: "/products/airport",
    name: "airport",
    component: __WEBPACK_IMPORTED_MODULE_5__pages_AirportProduct___default.a,
    meta: {
      title: "airport"
    }
  }, {
    path: "/products/area",
    name: "area",
    component: __WEBPACK_IMPORTED_MODULE_6__pages_AreaProduct___default.a,
    meta: {
      title: "area"
    }
  }, {
    path: "/products/farms/presentation",
    name: "farms presentation",
    component: __WEBPACK_IMPORTED_MODULE_7__pages_FarmsPresentation___default.a,
    props: {
      canvasVisible: true
    },
    meta: {
      title: "farmPresentation"
    }
  }, {
    path: "/products/airport/presentation",
    name: "airport presentation",
    component: __WEBPACK_IMPORTED_MODULE_8__pages_AirportPresentation___default.a,
    props: {
      canvasVisible: true
    },
    meta: {
      title: "airportPresentation"
    }
  }, {
    path: "/products/area/presentation",
    name: "area presentation",
    component: __WEBPACK_IMPORTED_MODULE_9__pages_AreaPresentation___default.a,
    props: {
      canvasVisible: true
    },
    meta: {
      title: "areaPresentation"
    }
  }, {
    path: "/about",
    name: "about-us",
    component: __WEBPACK_IMPORTED_MODULE_10__pages_AboutUs___default.a,
    meta: {
      title: "about"
    }
  }, {
    path: "/certificates",
    name: "certificates",
    component: __WEBPACK_IMPORTED_MODULE_28__pages_Certificates___default.a,
    meta: {
      title: "certificates"
    }
  }, {
    path: "/awards",
    name: "awards",
    component: __WEBPACK_IMPORTED_MODULE_11__pages_Awards___default.a,
    meta: {
      title: "awards"
    }
  }, {
    path: "/privacy-policy",
    name: "privacy",
    component: __WEBPACK_IMPORTED_MODULE_12__pages_Privacy___default.a,
    meta: {
      title: "privacy"
    }
  }, {
    path: '/grants'
  }, {
    path: "/grants/bps",
    name: "bps",
    component: __WEBPACK_IMPORTED_MODULE_18__pages_BPS___default.a,
    meta: {
      title: "bps"
    }
  }, {
    path: "/grants/afms",
    name: "afms",
    component: __WEBPACK_IMPORTED_MODULE_22__pages_AFMS___default.a,
    meta: {
      title: "afms"
    }
  }, {
    path: "/grants/bridgealfa",
    name: "bridgealfa",
    component: __WEBPACK_IMPORTED_MODULE_23__pages_BridgeAlfa___default.a,
    meta: {
      title: "bridgealfa"
    }
  }, {
    path: "/grants/pmt",
    name: "pmt",
    component: __WEBPACK_IMPORTED_MODULE_24__pages_PMT___default.a,
    meta: {
      title: "pmt"
    }
  }, {
    path: "/grants/eic",
    name: "eic",
    component: __WEBPACK_IMPORTED_MODULE_25__pages_EIC___default.a,
    meta: {
      title: "eic"
    }
  }, {
    path: "/grants/bps2",
    name: "bps2",
    component: __WEBPACK_IMPORTED_MODULE_19__pages_BPS2___default.a,
    meta: {
      title: "bps2"
    }
  }, {
    path: "/grants/pbe",
    name: "pbe",
    component: __WEBPACK_IMPORTED_MODULE_20__pages_PBE___default.a,
    meta: {
      title: "pbe"
    }
  }, {
    path: "/grants/pbe2",
    name: "pbe2",
    component: __WEBPACK_IMPORTED_MODULE_21__pages_PBE2___default.a,
    meta: {
      title: "pbe2"
    }
  }, {
    path: "/grants/ppbb",
    name: "ppbb",
    component: __WEBPACK_IMPORTED_MODULE_27__pages_PPBB___default.a,
    meta: {
      title: "ppbb"
    }
  }, {
    path: "/grants/offshore",
    name: "offshore",
    component: __WEBPACK_IMPORTED_MODULE_29__pages_Offshore_vue___default.a,
    meta: {
      title: "offshore"
    }
  }, {
    path: "/blog",
    name: "blog",
    component: __WEBPACK_IMPORTED_MODULE_13__pages_Blog___default.a,
    meta: {
      title: "blog"
    }
  }, {
    path: "/contact",
    name: "contact",
    component: __WEBPACK_IMPORTED_MODULE_16__pages_Contact___default.a,
    meta: {
      title: "contact"
    }
  }, {
    path: "/projects",
    name: "projects",
    component: __WEBPACK_IMPORTED_MODULE_17__pages_CofinancedFromEU___default.a,
    meta: {
      title: "projects"
    }
  }, {
    path: "/auctions",
    name: "auctions",
    component: __WEBPACK_IMPORTED_MODULE_14__pages_Auctions___default.a,
    meta: {
      title: "auctions"
    }
  }, {
    path: "/infonews",
    name: "infonews",
    component: __WEBPACK_IMPORTED_MODULE_15__pages_Infonews___default.a,
    meta: {
      title: "infonews"
    }
  }],
  scrollBehavior: function scrollBehavior() {
    return { x: 0, y: 0 };
  }
});
router.beforeEach(function (to, from, next) {
  var title = lang[__WEBPACK_IMPORTED_MODULE_26__store_store__["a" /* default */].state.lang]["page_titles"][to.meta.title];
  document.title = title ? title : document.title;
  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 75 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 76 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(221)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(105),
  /* template */
  __webpack_require__(309),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Menu__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Modal__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Canvas__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Preloader__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Preloader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Preloader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_aos__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_aos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_aos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_VideoModal__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_VideoModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_VideoModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ScrollTop__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ScrollTop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_ScrollTop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_store__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_VideoStaticModal__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_VideoStaticModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_VideoStaticModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_design_icons_iconfont_dist_material_design_icons_css__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_design_icons_iconfont_dist_material_design_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_design_icons_iconfont_dist_material_design_icons_css__);
var _this = this;













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    MainHeader: __WEBPACK_IMPORTED_MODULE_0__components_Header___default.a,
    MainMenu: __WEBPACK_IMPORTED_MODULE_1__components_Menu___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_2__components_Modal___default.a,
    VideoModal: __WEBPACK_IMPORTED_MODULE_6__components_VideoModal___default.a,
    CanvasAnimation: __WEBPACK_IMPORTED_MODULE_3__components_Canvas___default.a,
    Preloader: __WEBPACK_IMPORTED_MODULE_4__components_Preloader___default.a,
    ScrollTop: __WEBPACK_IMPORTED_MODULE_7__components_ScrollTop___default.a,
    VideoStaticModal: __WEBPACK_IMPORTED_MODULE_9__components_VideoStaticModal___default.a
  },
  mounted: function mounted() {
    var t = _this;
    window.addEventListener('scroll', function (e) {
      var y = window.scrollY;
      if (__WEBPACK_IMPORTED_MODULE_8__store_store__["a" /* default */].state.isScrollTopVisible && y === 0) {
        __WEBPACK_IMPORTED_MODULE_8__store_store__["a" /* default */].commit('SET_SCROLL_TOP_VISIBLE', false);
      } else if (!__WEBPACK_IMPORTED_MODULE_8__store_store__["a" /* default */].state.isScrollTopVisible && y !== 0) {
        __WEBPACK_IMPORTED_MODULE_8__store_store__["a" /* default */].commit('SET_SCROLL_TOP_VISIBLE', true);
      }
    });
    __WEBPACK_IMPORTED_MODULE_5_aos___default.a.init();
    var lang = localStorage['lang'];
    if (lang) {
      __WEBPACK_IMPORTED_MODULE_8__store_store__["a" /* default */].commit('SET_LANG', localStorage.lang);
    }
    var isMenuOpen = __WEBPACK_IMPORTED_MODULE_8__store_store__["a" /* default */].state.isMenuOpen;
    document.body.classList.toggle('no-scroll', isMenuOpen);
    document.documentElement.classList.toggle('no-scroll', isMenuOpen);
  },
  computed: {
    isHomeAnimActive: function isHomeAnimActive() {
      return this.$store.state.isHomeAnimActive;
    },
    isAppLoaded: function isAppLoaded() {
      return this.$store.state.isAppLoaded;
    },
    isMenuOpen: function isMenuOpen() {
      return this.$store.state.isMenuOpen;
    },
    isModalOpen: function isModalOpen() {
      return this.$store.state.isModalOpen;
    },
    isModalVideoOpen: function isModalVideoOpen() {
      return this.$store.state.isModalVideoOpen;
    },
    modalStaticVideoType: function modalStaticVideoType() {
      return this.$store.state.modalStaticVideoType;
    }
  },
  watch: {
    isMenuOpen: function isMenuOpen(isOpen) {
      document.body.classList.toggle('no-scroll', isOpen);
      document.documentElement.classList.toggle('no-scroll', isOpen);
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.classList.remove('no-scroll');
    document.documentElement.classList.remove('no-scroll');
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'canvas-animation',
  computed: {
    isCanvasVisible: function isCanvasVisible() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isCanvasVisible;
    },
    isHome: function isHome() {
      return this.$route.name === 'home';
    }
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    this.$store.commit('INIT_CANVAS_PLAYER', {
      domEl: document.querySelector('.canvas-animation')
    });
    var link = '/static/animation/anim.json';
  },

  methods: {}
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Certs',
  computed: {
    lang: function lang() {
      return this.$store.state.lang;
    },
    certs: function certs() {
      var pdfBase = 'static/certificates/full';
      var imgBase = 'static/certificates/badge';
      var isPl = this.lang === 'pl';

      return [{
        key: 'iso45001',
        alt: 'ISO 45001',
        img: imgBase + '/' + (isPl ? 'ISO-45001-PL.png' : 'ISO-45001-ENG.png'),
        pdf: pdfBase + '/' + (isPl ? 'ISO-45001-PL.pdf' : 'ISO-45001-ENG.pdf')
      }, {
        key: 'iso27001',
        alt: 'ISO 27001',
        img: imgBase + '/' + (isPl ? 'ISO-IEC-27001-PL.png' : 'ISO-IEC-27001-ENG.png'),
        pdf: pdfBase + '/' + (isPl ? 'ISO-IEC-27001-PL.pdf' : 'ISO-IEC-27001-ENG.pdf')
      }, {
        key: 'iso14001',
        alt: 'ISO 14001',
        img: imgBase + '/' + (isPl ? 'ISO_14001-POL.png' : 'ISO_14001-ENG.png'),
        pdf: pdfBase + '/' + (isPl ? 'ISO_14001-POL.pdf' : 'ISO_14001-ENG.pdf')
      }, {
        key: 'iso9001',
        alt: 'ISO 9001',
        img: imgBase + '/' + (isPl ? 'ISO_9001-POL.png' : 'ISO_9001-ENG.png'),
        pdf: pdfBase + '/' + (isPl ? 'ISO_9001-POL.pdf' : 'ISO_9001-ENG.pdf')
      }];
    }
  },
  methods: {
    openCert: function openCert(cert) {
      window.open(cert.pdf, '_blank');
    }
  }
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_SmoothScroll__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'clients',
  data: function data() {
    return {
      clients: [{ src: "/static/img/clients/Acciona.png", alt: "Acciona" }, { src: "/static/img/clients/boralex.png", alt: "Boralex" }, { src: "/static/img/clients/capital_energy.png", alt: "Capital Energy" }, { src: "/static/img/clients/Disa.png", alt: "Disa" }, { src: "/static/img/clients/EDF.png", alt: "EDF" }, { src: "/static/img/clients/EDPR.png", alt: "EDPR" }, { src: "/static/img/clients/Elawan.png", alt: "Elawan" }, { src: "/static/img/clients/enel.png", alt: "enel" }, { src: "/static/img/clients/ENERGITER_VERT.png", alt: "Energiter ver" }, { src: "/static/img/clients/Energix_Renewables.png", alt: "Energix renewables" }, { src: "/static/img/clients/engie.png", alt: "Engie" }, { src: "/static/img/clients/forestalia.png", alt: "Forestalia" }, { src: "/static/img/clients/iberdrola.png", alt: "Iberdrola" }, { src: "/static/img/clients/Iqony.png", alt: "Iqony" }, { src: "/static/img/clients/luminus_luminus.png", alt: "Luminus" }, { src: "/static/img/clients/naturgy.png", alt: "Naturgy" }, { src: "/static/img/clients/PAK_SERWIS.png", alt: "Pak serwis" }, { src: "/static/img/clients/PNE.png", alt: "PNE" }, { src: "/static/img/clients/rr.png", alt: "Red Rocket" }, { src: "/static/img/clients/RWE.png", alt: "RWE" }, { src: "/static/img/clients/soler.png", alt: "Soler" }, { src: "/static/img/clients/TotalEnergies.png", alt: "TotalEnergies" }, { src: "/static/img/clients/WPO.png", alt: "WPO" }]
    };
  },

  watch: {
    lang: function lang() {
      this.team = this.$root.$t("team");
    }
  },
  props: [],
  methods: {},
  computed: {
    lang: function lang() {
      return store.state.lang;
    },
    scrollOffset: function scrollOffset() {
      return window.innerWidth > 980 ? 130 : 90;
    },
    smoothScroll: function smoothScroll() {
      return __WEBPACK_IMPORTED_MODULE_0__helpers_SmoothScroll__["a" /* default */];
    }
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'counter',
    props: ['data'],
    data: function data() {
        return {};
    },

    methods: {},
    computed: {}
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var d = new Date();
var rok = d.getFullYear();
/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'footer-main',
  data: function data() {
    return { year: rok };
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'footer-more-information',
    props: ['modalpage'],
    data: function data() {
        return {
            pageType: this.modalpage
        };
    },

    mounted: function mounted() {},
    methods: {
        showModal: function showModal() {
            __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].commit('SET_MODAL', { visible: true, questionName: this.modalpage });
        }
    },

    computed: {
        lang: function lang() {
            return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.lang;
        }
    }
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'footer-main',
  props: ['isAnim'],
  data: function data() {
    return {
      show: false
    };
  },
  mounted: function mounted() {
    this.show = true;
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_SmoothScroll__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'main-header',
  computed: {
    isMenuOpen: function isMenuOpen() {
      if (__WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isMenuOpen) {
        __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].commit('HIDE_CANVAS');
      } else if (this.isCanvasVisible) {
        __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].commit('SHOW_CANVAS');
      }
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isMenuOpen;
    },
    isBlogPage: function isBlogPage() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isBlog;
    },
    canShowPARP: function canShowPARP() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.showPARP;
    },
    canShowPAIH: function canShowPAIH() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.showPAIH;
    },
    lang: function lang() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.lang;
    },
    isHomePage: function isHomePage() {
      return this.route === 'home';
    },
    route: function route() {
      return this.$route.name;
    },
    isAccessibilityVisible: function isAccessibilityVisible() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isAccessibilityVisible;
    },
    isPageContrasted: function isPageContrasted() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isPageContrasted;
    },
    isCanvasVisible: function isCanvasVisible() {
      return this.route === 'home' || this.route === 'farms presentation' || this.route === 'airport presentation' || this.route === 'area presentation' || this.route === 'products';
    },

    smoothScroll: function smoothScroll() {
      return __WEBPACK_IMPORTED_MODULE_1__helpers_SmoothScroll__["a" /* default */];
    },
    isDecember: function isDecember() {
      return new Date().getMonth() === 11;
    },
    logoSrc: function logoSrc() {
      return this.isDecember ? '/static/img/logo-xmas.png' : '/static/img/logo.png';
    }
  },
  methods: {
    menuToggle: function menuToggle() {
      __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].commit('TOGGLE_MENU');
    },
    contrastToggle: function contrastToggle() {
      __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].commit('TOGGLE_PAGE_CONTRAST');
    },
    sizeToggle: function sizeToggle() {
      __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].commit('TOGGLE_PAGE_FONT_SIZE');
    },
    closeModal: function closeModal() {
      __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].commit('SET_MODAL', { visible: false, questionName: '' });
    }

  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      photos: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()({ length: 18 }, function (_, i) {
        return {
          source_url: 'static/img/gallery/photo' + (i + 1) + '.jpg'
        };
      }),
      activeIndex: 0,
      isModalOpen: false
    };
  },
  mounted: function mounted() {
    window.addEventListener('keydown', this.handleKeydown);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeydown);
  },

  methods: {
    handleKeydown: function handleKeydown(event) {
      if (this.isModalOpen) {
        switch (event.key) {
          case 'ArrowLeft':
            this.changePhoto(this.activeIndex - 1);
            break;
          case 'ArrowRight':
            this.changePhoto(this.activeIndex + 1);
            break;
          case 'Escape':
            this.closeModal();
            break;
        }
      }
    },
    openModal: function openModal(index) {
      this.changePhoto(index);
      this.isModalOpen = true;
    },
    changePhoto: function changePhoto(index) {
      if (index >= 0 && index < this.photos.length) {
        this.activeIndex = index;
      }
    },
    closeModal: function closeModal() {
      this.isModalOpen = false;
    },
    getClass: function getClass(index) {
      return {
        'gallery-item': true,
        active: index === this.activeIndex,
        prevItem: index < this.activeIndex,
        nextItem: index > this.activeIndex
      };
    }
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'main-menu',
  data: function data() {
    return {};
  },

  methods: {
    menuClicked: function menuClicked() {
      this.$store.commit('SET_MODAL', { visible: false, questionName: '' });
      this.$store.commit('CLOSE_MENU');
    },
    setLang: function setLang(lang) {
      var title = this.$route.meta.title;


      __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].commit('SET_LANG', lang);
      __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].commit('TOGGLE_MENU');
      if (this.$route.meta.title) {
        document.title = this.$t('page_titles.' + title);
      }
    },
    showModal: function showModal() {
      __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].commit('SET_MODAL', { visible: true, questionName: '' });
    }
  },
  computed: {
    lang: function lang() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.lang;
    }
  }
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modal',
  data: function data() {
    return {
      name: '',
      email: '',
      question: '',
      content: '',
      error: false,
      sendError: false,
      sendComplete: false,
      nameError: false,
      emailError: false,
      questionError: false,
      contentError: false
    };
  },

  mounted: function mounted() {
    this.question = __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.modalQuestionName;
  },
  computed: {
    isMenuOpen: function isMenuOpen() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isMenuOpen;
    },

    lang: function lang() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.lang;
    }
  },
  watch: {
    $route: function $route() {
      this.hideModal();
    }
  },
  methods: {
    menuToggle: function menuToggle() {
      __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].commit('TOGGLE_MENU');
    },
    hideModal: function hideModal() {
      __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].commit('SET_MODAL', { visible: false, questionName: '' });
    },
    validateEmail: function validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validateFrom: function validateFrom() {
      if (this.name === '' || !this.validateEmail(this.email) || this.question === '' || this.content === '') {
        this.error = true;
      } else {
        this.error = false;
      }
      if (this.name === '') {
        this.nameError = true;
      } else {
        this.nameError = false;
      }
      if (!this.validateEmail(this.email)) {
        this.emailError = true;
      } else {
        this.emailError = false;
      }
      if (this.question === '') {
        this.questionError = true;
      } else {
        this.questionError = false;
      }
      if (this.content === '') {
        this.contentError = true;
      } else {
        this.contentError = false;
      }
      return this.error;
    },
    sendForm: function sendForm() {
      this.validateFrom();
      if (this.validateFrom()) {
        this.sendComplete = false;
        this.sendError = false;
      } else {
        var data = new FormData();
        data.append('name', this.name);
        data.append('email', this.email);
        data.append('question', this.question);
        data.append('content', this.content);
        var t = this;
        fetch('/mail.php', {
          method: 'POST',
          body: data
        }).then(function (response) {
          if (response.status != 200) {
            t.sendError = true;
          } else {
            t.sendError = false;
            t.sendComplete = true;
            t.name = '';
            t.email = '';
            t.question = '';
            t.content = '';
          }
        });
      }
    }
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_helpers__ = __webpack_require__(149);


var ASSETS = ['/img/favicon.png', '/textures/brown.jpg', '/textures/brown2.jpg', '/textures/grass.jpg', '/textures/grass2.jpg', '/textures/grass3.jpg', '/textures/grass4.jpg', '/textures/grass5.jpg', '/textures/grass6.jpg', '/textures/sand.jpg', '/textures/street.jpg', '/textures/water.jpg', '/img/about-us/header.jpg', '/img/about-us/team1.jpg', '/img/about-us/team2.jpg', '/img/about-us/team3.jpg', '/img/about-us/team4.jpg', '/img/about-us/team5.jpg', '/img/about-us/team6.jpg', '/img/about-us/team7.jpg', '/img/about-us/team8.jpg', '/img/about-us/team9.jpg', '/img/about-us/why-us.jpg', '/img/blog/post.jpg', '/img/menu.jpg', '/img/orange-bg.jpg', '/img/product/bottom-last-airport.jpg', '/img/product/bottom-last.jpg', '/img/product/header-airport.jpg', '/img/product/header.jpg', '/img/product/image-box-1.jpg', '/img/product/image-box-2-airport.jpg', '/img/product/image-box-2.jpg', '/img/product/image-box-3.jpg', '/img/product/image-box-4-airport.jpg', '/img/product/image-box-4.jpg', '/img/product/image-box-5.jpg', '/img/product/image1-airport.jpg', '/img/product/image1.jpg', '/img/product/image2-airport.jpg', '/img/product/image2.jpg', '/img/product/image3-airport.jpg', '/img/product/image3.jpg', '/img/product/tablet.jpg', '/img/video.jpg', '/img/about-us/our-team-bg.png', '/img/blog/bg.png', '/img/favicon.png', '/img/fb-blue.png', '/img/linked-blue.png', '/img/fb.png', '/img/linked.png', '/img/logo.png', '/img/product/bottom-first.png', '/img/question-modal-bg.png', '/img/contact/adress.svg', '/img/contact/mail.svg', '/img/contact/marker.svg', '/img/contact/phone.svg', '/img/hexagon.svg', '/img/home/airport.svg', '/img/home/area.svg', '/img/home/wind-farm.svg', '/img/soppo-logo.svg'];



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'preloader',
  data: function data() {
    return {
      PxLoader: null,
      animationLoaded: false,
      imagesElements: { loaded: 0, all: 0 },
      threejsElements: { loaded: 0, all: 0 },
      loadedItems: 0,
      allItems: ASSETS.length + 1,
      animJsonLoaded: false
    };
  },

  computed: {
    isCanvasLoaded: function isCanvasLoaded() {
      if (this.$store.state.isCanvasLoaded && !this.animationLoaded) {
        this.animationLoaded = true;

        store.commit('LOAD_ANIMATION_OBJECTS', this.animCallback);
        this.loaad;
      }
      return this.$store.state.isCanvasLoaded;
    },
    prc: function prc() {
      var _this = this;

      var prc = Math.ceil((this.imagesElements.loaded + this.threejsElements.loaded + (this.animJsonLoaded ? 1 : 0)) / (this.allItems + this.threejsElements.all) * 100);
      if (prc === 100) {
        store.commit('SHOW_LOADER_FINISH', function () {
          if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers__["a" /* isCanvasVisible */])(_this.$route.name)) {
            store.commit('HIDE_CANVAS');
          }
        });
        store.commit('INIT_GROUNDS');
      }
      return prc;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.PxLoader = new PxLoader();
    var PATH = "/static";
    ASSETS.map(function (a) {
      _this2.PxLoader.addImage(PATH + a);
    });
    this.PxLoader.addProgressListener(this.loderProgress);
    this.PxLoader.addCompletionListener(this.imagesLoaded);
  },
  methods: {
    imagesLoaded: function imagesLoaded(e) {
      this.animatinLoad();
    },
    loderProgress: function loderProgress(e) {
      this.imagesElements.loaded = e.completedCount;
      this.imagesElements.all = e.totalCount;
    },
    animCallback: function animCallback(current, all) {
      this.threejsElements.loaded = current;
      this.threejsElements.all = all;
      if (current === all) {
        this.PxLoader.start();
      }
    },
    animJSONCallback: function animJSONCallback() {
      this.animJsonLoaded = true;
    },
    animatinLoad: function animatinLoad() {
      var _this3 = this;

      var link = '/static/animation/anim.json';
      this.$store.commit('LOAD_ANIMATION', {
        link: link,
        cb: function cb() {
          _this3.animJsonLoaded = true;
        }
      });
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_SmoothScroll__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'scrollTop',
    computed: {
        visible: function visible() {
            return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isScrollTopVisible;
        },
        smoothScroll: function smoothScroll() {
            return __WEBPACK_IMPORTED_MODULE_1__helpers_SmoothScroll__["a" /* default */];
        }

    }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'video-box',
    props: ['bgsrc', 'videosrc'],
    data: function data() {
        return {};
    },

    methods: {
        showVideoModal: function showVideoModal(src) {
            __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].commit('OPEN_VIDEO_MODAL', src);
        }
    },
    computed: {
        lang: function lang() {
            return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.lang;
        }
    }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'video-modal',
    data: function data() {
        return {};
    },

    methods: {
        hideModal: function hideModal() {
            __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].commit('CLOSE_VIDEO_MODAL', null);
        }
    }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VideoStaticModal',
  props: {
    videoType: {
      type: String,
      required: true,
      validator: function validator(value) {
        return ['presentation', 'realExample'].includes(value);
      }
    }
  },
  data: function data() {
    return {
      windowWidth: window.innerWidth
    };
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  methods: {
    onResize: function onResize() {
      this.windowWidth = window.innerWidth;
    }
  },
  computed: {
    lang: function lang() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.lang;
    },
    modalWidth: function modalWidth() {
      return this.windowWidth < 768 ? this.windowWidth - 40 : 980;
    },
    modalHeight: function modalHeight() {
      return this.windowWidth < 768 ? (this.windowWidth - 40) * 9 / 16 : 570;
    },
    modalSrc: function modalSrc() {
      if (this.videoType === 'presentation') {
        return this.lang === 'pl' ? 'https://www.youtube.com/embed/9x3c1CYNR6U?si=s5ENZHSqKZc5gPmM' : 'https://www.youtube.com/embed/NSiyhMJlKdU?si=e5QS5pAt9McaWk7e';
      }
      if (this.videoType === 'realExample') {
        return 'https://www.youtube.com/embed/ur2bDF2aYSs?si=iwWV_tXOgOhdBXf-';
      }
    }
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMain__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_FooterMain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VideoBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VideoBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_VideoBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Counter__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Counter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Counter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_SmoothScroll__ = __webpack_require__(2);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'farms-product',
  components: {
    FooterMain: __WEBPACK_IMPORTED_MODULE_1__components_FooterMain___default.a,
    FooterMoreInformation: __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation___default.a,
    VideoBox: __WEBPACK_IMPORTED_MODULE_3__components_VideoBox___default.a,
    Counter: __WEBPACK_IMPORTED_MODULE_4__components_Counter___default.a
  },
  data: function data() {
    return {
      circleValues: [{
        before: this.$t('farmsProducts.whyIShouldUseThisOneTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisOneTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisOneTopAfter')
      }, {
        before: this.$t('farmsProducts.whyIShouldUseThisTwoTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisTwoTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisTwoTopAfter')
      }, {
        before: this.$t('farmsProducts.whyIShouldUseThisThreeTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisThreeTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisThreeTopAfter')
      }, {
        before: this.$t('farmsProducts.whyIShouldUseThisFourTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisFourTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisFourTopAfter')
      }]

    };
  },
  computed: {
    lang: function lang() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.lang;
    },
    isPageContrasted: function isPageContrasted() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isPageContrasted;
    },
    isFontBigger: function isFontBigger() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isPageFontBigger;
    },

    smoothScroll: function smoothScroll() {
      return __WEBPACK_IMPORTED_MODULE_5__helpers_SmoothScroll__["a" /* default */];
    }
  },
  methods: {},
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isAccessibilityVisible = true;
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isAccessibilityVisible = false;
  }
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FooterMain__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FooterMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_FooterMain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMoreInformation__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMoreInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_FooterMoreInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MediaBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MediaBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_MediaBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Clients__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Clients___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Clients__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_SmoothScroll__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Certs_vue__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Certs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Certs_vue__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'about-us',
  data: function data() {
    return {
      popupActivo: false,
      popupActivo2: false,
      team: this.$root.$t("team")
    };
  },

  watch: {
    lang: function lang() {
      this.team = this.$root.$t("team");
    }
  },
  props: ['isHome'],
  methods: {
    openVideoModal: function openVideoModal(type) {
      this.$store.commit('SET_MODAL_STATIC_VIDEO_TYPE', type);
      this.$modal.show('video-static');
    }
  },
  components: {
    FooterMain: __WEBPACK_IMPORTED_MODULE_0__components_FooterMain___default.a,
    Clients: __WEBPACK_IMPORTED_MODULE_3__components_Clients___default.a,
    FooterMoreInformation: __WEBPACK_IMPORTED_MODULE_1__components_FooterMoreInformation___default.a,
    MediaBox: __WEBPACK_IMPORTED_MODULE_2__components_MediaBox___default.a,
    Certs: __WEBPACK_IMPORTED_MODULE_5__components_Certs_vue___default.a
  },
  computed: {
    lang: function lang() {
      return store.state.lang;
    },
    scrollOffset: function scrollOffset() {
      return window.innerWidth > 980 ? 130 : 90;
    },
    smoothScroll: function smoothScroll() {
      return __WEBPACK_IMPORTED_MODULE_4__helpers_SmoothScroll__["a" /* default */];
    }
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FooterOrange__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FooterOrange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_FooterOrange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_store__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'farms-presentation',
  data: function data() {
    return {
      nextBtn: null,
      showText: false,
      currentStep: 0,
      isNextBtn: false,
      textContent: null
    };
  },

  computed: {
    steps: function steps() {
      return this.$t('airportPresentation.steps');
    }
  },
  methods: {
    showModal: function showModal() {
      __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].commit('SET_MODAL', { visible: true, questionName: 'airport' });
    },
    showNextBtn: function showNextBtn() {
      this.showText = true;
      this.currentStep++;
      this.textContent.scrollTop = 0;
    },
    nextStep: function nextStep() {
      this.showText = false;

      __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].commit('PLAY_NEXT');
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].commit('SHOW_CANVAS');
    this.textContent = document.querySelector('.text-content');
    this.nextBtn = document.querySelector('#playButton');
    __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].commit('PLAY_AIRPORT_PRESENTATION', this.showNextBtn);
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].commit('CLEAR_GROUND');
    __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].commit('HIDE_CANVAS');
    __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].commit('HOME_ANIM_FINISHED');
  },

  components: {
    FooterOrange: __WEBPACK_IMPORTED_MODULE_0__components_FooterOrange___default.a
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMain__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_FooterMain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VideoBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VideoBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_VideoBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Counter__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Counter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Counter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_SmoothScroll__ = __webpack_require__(2);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'airport-product',
  components: {
    FooterMain: __WEBPACK_IMPORTED_MODULE_1__components_FooterMain___default.a,
    FooterMoreInformation: __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation___default.a,
    VideoBox: __WEBPACK_IMPORTED_MODULE_3__components_VideoBox___default.a,
    Counter: __WEBPACK_IMPORTED_MODULE_4__components_Counter___default.a
  },
  data: function data() {
    return {
      circleValues: [{
        before: this.$t('airportProducts.whyIShouldUseThisOneTopBefore'),
        val: this.$t('airportProducts.whyIShouldUseThisOneTop'),
        after: this.$t('airportProducts.whyIShouldUseThisOneTopAfter')
      }, {
        before: this.$t('airportProducts.whyIShouldUseThisTwoTopBefore'),
        val: this.$t('airportProducts.whyIShouldUseThisTwoTop'),
        after: this.$t('airportProducts.whyIShouldUseThisTwoTopAfter')
      }, {
        before: this.$t('airportProducts.whyIShouldUseThisThreeTopBefore'),
        val: this.$t('airportProducts.whyIShouldUseThisThreeTop'),
        after: this.$t('airportProducts.whyIShouldUseThisThreeTopAfter')
      }, {
        before: this.$t('airportProducts.whyIShouldUseThisFourTopBefore'),
        val: this.$t('airportProducts.whyIShouldUseThisFourTop'),
        after: this.$t('airportProducts.whyIShouldUseThisFourTopAfter')
      }]

    };
  },
  computed: {
    lang: function lang() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.lang;
    },
    smoothScroll: function smoothScroll() {
      return __WEBPACK_IMPORTED_MODULE_5__helpers_SmoothScroll__["a" /* default */];
    }
  },
  methods: {}
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FooterOrange__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FooterOrange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_FooterOrange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_store__ = __webpack_require__(1);





window.store = __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */];
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'area-presentation',
  data: function data() {
    window.t = this;
    return {
      nextBtn: null,
      showText: false,
      currentStep: 0,
      isNextBtn: false
    };
  },

  computed: {
    steps: function steps() {
      return this.$t('areaPresentation.steps');
    }
  },
  methods: {
    showModal: function showModal() {
      __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].commit('SET_MODAL', { visible: true, questionName: 'area' });
    },
    showNextBtn: function showNextBtn() {
      this.showText = true;
      this.currentStep++;
    },
    nextStep: function nextStep() {
      alert('awd');
      this.showText = false;

      __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].commit('PLAY_NEXT');
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].commit('SHOW_CANVAS');

    this.nextBtn = document.querySelector('#playButton');
    __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].commit('PLAY_FOREST_PRESENTATION', this.showNextBtn);
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].commit('CLEAR_GROUND');
    __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].commit('HIDE_CANVAS');
    __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].commit('HOME_ANIM_FINISHED');
  },

  components: {
    FooterOrange: __WEBPACK_IMPORTED_MODULE_0__components_FooterOrange___default.a
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMain__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_FooterMain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VideoBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VideoBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_VideoBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Counter__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Counter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Counter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_SmoothScroll__ = __webpack_require__(2);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'area-product',
  components: {
    FooterMain: __WEBPACK_IMPORTED_MODULE_1__components_FooterMain___default.a,
    FooterMoreInformation: __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation___default.a,
    VideoBox: __WEBPACK_IMPORTED_MODULE_3__components_VideoBox___default.a,
    Counter: __WEBPACK_IMPORTED_MODULE_4__components_Counter___default.a
  },
  data: function data() {
    return {
      circleValues: [{
        before: this.$t('areaProducts.whyIShouldUseThisOneTopBefore'),
        val: this.$t('areaProducts.whyIShouldUseThisOneTop'),
        after: this.$t('areaProducts.whyIShouldUseThisOneTopAfter')
      }, {
        before: this.$t('areaProducts.whyIShouldUseThisTwoTopBefore'),
        val: this.$t('areaProducts.whyIShouldUseThisTwoTop'),
        after: this.$t('areaProducts.whyIShouldUseThisTwoTopAfter')
      }, {
        before: this.$t('areaProducts.whyIShouldUseThisThreeTopBefore'),
        val: this.$t('areaProducts.whyIShouldUseThisThreeTop'),
        after: this.$t('areaProducts.whyIShouldUseThisThreeTopAfter')
      }, {
        before: this.$t('areaProducts.whyIShouldUseThisFourTopBefore'),
        val: this.$t('areaProducts.whyIShouldUseThisFourTop'),
        after: this.$t('areaProducts.whyIShouldUseThisFourTopAfter')
      }]

    };
  },
  computed: {
    lang: function lang() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.lang;
    },
    smoothScroll: function smoothScroll() {
      return __WEBPACK_IMPORTED_MODULE_5__helpers_SmoothScroll__["a" /* default */];
    }
  },
  methods: {}
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMain__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_FooterMain__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'auctions',
  components: {
    FooterMain: __WEBPACK_IMPORTED_MODULE_1__components_FooterMain___default.a
  },
  methods: {}
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FooterMain__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FooterMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_FooterMain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMoreInformation__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMoreInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_FooterMoreInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MediaBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MediaBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_MediaBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_SmoothScroll__ = __webpack_require__(2);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'awards',
  data: function data() {
    return {
      popupActivo: false,
      popupActivo2: false
    };
  },

  props: [],
  methods: {},
  components: {
    FooterMain: __WEBPACK_IMPORTED_MODULE_0__components_FooterMain___default.a,
    FooterMoreInformation: __WEBPACK_IMPORTED_MODULE_1__components_FooterMoreInformation___default.a,
    MediaBox: __WEBPACK_IMPORTED_MODULE_2__components_MediaBox___default.a
  },
  computed: {
    lang: function lang() {
      return store.state.lang;
    },
    scrollOffset: function scrollOffset() {
      return window.innerWidth > 980 ? 130 : 90;
    },
    smoothScroll: function smoothScroll() {
      return __WEBPACK_IMPORTED_MODULE_3__helpers_SmoothScroll__["a" /* default */];
    }
  }
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMain__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_FooterMain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VideoBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VideoBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_VideoBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Counter__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Counter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Counter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_SmoothScroll__ = __webpack_require__(2);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'farms-product',
  components: {
    FooterMain: __WEBPACK_IMPORTED_MODULE_1__components_FooterMain___default.a,
    FooterMoreInformation: __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation___default.a,
    VideoBox: __WEBPACK_IMPORTED_MODULE_3__components_VideoBox___default.a,
    Counter: __WEBPACK_IMPORTED_MODULE_4__components_Counter___default.a
  },
  data: function data() {
    return {
      circleValues: [{
        before: this.$t('farmsProducts.whyIShouldUseThisOneTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisOneTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisOneTopAfter')
      }, {
        before: this.$t('farmsProducts.whyIShouldUseThisTwoTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisTwoTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisTwoTopAfter')
      }, {
        before: this.$t('farmsProducts.whyIShouldUseThisThreeTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisThreeTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisThreeTopAfter')
      }, {
        before: this.$t('farmsProducts.whyIShouldUseThisFourTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisFourTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisFourTopAfter')
      }]

    };
  },
  computed: {
    lang: function lang() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.lang;
    },
    isPageContrasted: function isPageContrasted() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isPageContrasted;
    },
    isFontBigger: function isFontBigger() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isPageFontBigger;
    },

    smoothScroll: function smoothScroll() {
      return __WEBPACK_IMPORTED_MODULE_5__helpers_SmoothScroll__["a" /* default */];
    }
  },

  methods: {},
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isAccessibilityVisible = true;
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isAccessibilityVisible = false;
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMain__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_FooterMain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VideoBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VideoBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_VideoBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Counter__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Counter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Counter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_SmoothScroll__ = __webpack_require__(2);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'farms-product',
  components: {
    FooterMain: __WEBPACK_IMPORTED_MODULE_1__components_FooterMain___default.a,
    FooterMoreInformation: __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation___default.a,
    VideoBox: __WEBPACK_IMPORTED_MODULE_3__components_VideoBox___default.a,
    Counter: __WEBPACK_IMPORTED_MODULE_4__components_Counter___default.a
  },
  data: function data() {
    return {
      circleValues: [{
        before: this.$t('farmsProducts.whyIShouldUseThisOneTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisOneTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisOneTopAfter')
      }, {
        before: this.$t('farmsProducts.whyIShouldUseThisTwoTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisTwoTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisTwoTopAfter')
      }, {
        before: this.$t('farmsProducts.whyIShouldUseThisThreeTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisThreeTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisThreeTopAfter')
      }, {
        before: this.$t('farmsProducts.whyIShouldUseThisFourTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisFourTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisFourTopAfter')
      }]

    };
  },
  computed: {
    lang: function lang() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.lang;
    },
    isPageContrasted: function isPageContrasted() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isPageContrasted;
    },
    isFontBigger: function isFontBigger() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isPageFontBigger;
    },

    smoothScroll: function smoothScroll() {
      return __WEBPACK_IMPORTED_MODULE_5__helpers_SmoothScroll__["a" /* default */];
    }
  },

  methods: {},
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isAccessibilityVisible = true;
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isAccessibilityVisible = false;
  }
});

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMain__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_FooterMain__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'blog',
  data: function data() {
    return {};
  },

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isBlog = true;
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isBlog = false;
  },
  components: {
    FooterMain: __WEBPACK_IMPORTED_MODULE_1__components_FooterMain___default.a
  },
  methods: {}
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMain__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_FooterMain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VideoBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VideoBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_VideoBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Counter__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Counter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Counter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_SmoothScroll__ = __webpack_require__(2);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'farms-product',
  components: {
    FooterMain: __WEBPACK_IMPORTED_MODULE_1__components_FooterMain___default.a,
    FooterMoreInformation: __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation___default.a,
    VideoBox: __WEBPACK_IMPORTED_MODULE_3__components_VideoBox___default.a,
    Counter: __WEBPACK_IMPORTED_MODULE_4__components_Counter___default.a
  },
  data: function data() {
    return {
      circleValues: [{
        before: this.$t('farmsProducts.whyIShouldUseThisOneTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisOneTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisOneTopAfter')
      }, {
        before: this.$t('farmsProducts.whyIShouldUseThisTwoTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisTwoTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisTwoTopAfter')
      }, {
        before: this.$t('farmsProducts.whyIShouldUseThisThreeTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisThreeTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisThreeTopAfter')
      }, {
        before: this.$t('farmsProducts.whyIShouldUseThisFourTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisFourTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisFourTopAfter')
      }]

    };
  },
  computed: {
    lang: function lang() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.lang;
    },
    isPageContrasted: function isPageContrasted() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isPageContrasted;
    },
    isFontBigger: function isFontBigger() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isPageFontBigger;
    },

    smoothScroll: function smoothScroll() {
      return __WEBPACK_IMPORTED_MODULE_5__helpers_SmoothScroll__["a" /* default */];
    }
  },
  methods: {},
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isAccessibilityVisible = true;
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isAccessibilityVisible = false;
  }
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FooterMain__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FooterMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_FooterMain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMoreInformation__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMoreInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_FooterMoreInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MediaBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MediaBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_MediaBox__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'certificates',
  data: function data() {
    return {
      popupActivo: false,
      popupActivo2: false
    };
  },

  props: [],
  methods: {
    openCert: function openCert(cert) {
      window.open(cert.pdf, '_blank');
    }
  },
  components: {
    FooterMain: __WEBPACK_IMPORTED_MODULE_0__components_FooterMain___default.a,
    FooterMoreInformation: __WEBPACK_IMPORTED_MODULE_1__components_FooterMoreInformation___default.a,
    MediaBox: __WEBPACK_IMPORTED_MODULE_2__components_MediaBox___default.a
  },
  computed: {
    lang: function lang() {
      return store.state.lang;
    },
    certs: function certs() {
      var base = 'static/certificates/full';
      var isPl = this.lang === 'pl';

      return [{
        key: 'iso45001',
        alt: 'ISO 45001',
        img: base + '/' + (isPl ? 'ISO-45001-PL.png' : 'ISO-45001-ENG.png'),
        pdf: base + '/' + (isPl ? 'ISO-45001-PL.pdf' : 'ISO-45001-ENG.pdf')
      }, {
        key: 'iso27001',
        alt: 'ISO 27001',
        img: base + '/' + (isPl ? 'ISO-IEC-27001-PL.png' : 'ISO-IEC-27001-ENG.png'),
        pdf: base + '/' + (isPl ? 'ISO-IEC-27001-PL.pdf' : 'ISO-IEC-27001-ENG.pdf')
      }, {
        key: 'iso14001',
        alt: 'ISO 14001',
        img: base + '/' + (isPl ? 'ISO_14001-POL.png' : 'ISO_14001-ENG.png'),
        pdf: base + '/' + (isPl ? 'ISO_14001-POL.pdf' : 'ISO_14001-ENG.pdf')
      }, {
        key: 'iso9001',
        alt: 'ISO 9001',
        img: base + '/' + (isPl ? 'ISO_9001-POL.png' : 'ISO_9001-ENG.png'),
        pdf: base + '/' + (isPl ? 'ISO_9001-POL.pdf' : 'ISO_9001-ENG.pdf')
      }];
    }
  }
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'projects',
  data: function data() {
    return {};
  },

  mounted: function mounted() {},
  methods: {
    menuToggle: function menuToggle() {
      __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].commit('TOGGLE_MENU');
    },
    showModal: function showModal() {
      __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].commit('SET_MODAL', { visible: true, questionName: '' });
    }
  },
  computed: {
    lang: function lang() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.lang;
    }
  }
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'contact',
  data: function data() {
    return {};
  },

  mounted: function mounted() {
    var uluru = {
      lat: 54.371663,
      lng: 18.505612
    };
    var map = new google.maps.Map(document.getElementById('map'), {
      zoom: 16,
      center: uluru
    });
    var marker = new google.maps.Marker({
      position: uluru,
      map: map,
      icon: {
        url: "./static/img/contact/marker.svg"
      }
    });
  },
  methods: {
    menuToggle: function menuToggle() {
      __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].commit('TOGGLE_MENU');
    },
    showModal: function showModal() {
      __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].commit('SET_MODAL', { visible: true, questionName: '' });
    }
  },
  computed: {
    lang: function lang() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.lang;
    }
  }
});

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMain__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_FooterMain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VideoBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VideoBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_VideoBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Counter__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Counter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Counter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_SmoothScroll__ = __webpack_require__(2);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'farms-product',
  components: {
    FooterMain: __WEBPACK_IMPORTED_MODULE_1__components_FooterMain___default.a,
    FooterMoreInformation: __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation___default.a,
    VideoBox: __WEBPACK_IMPORTED_MODULE_3__components_VideoBox___default.a,
    Counter: __WEBPACK_IMPORTED_MODULE_4__components_Counter___default.a
  },
  data: function data() {
    return {
      circleValues: [{
        before: this.$t('farmsProducts.whyIShouldUseThisOneTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisOneTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisOneTopAfter')
      }, {
        before: this.$t('farmsProducts.whyIShouldUseThisTwoTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisTwoTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisTwoTopAfter')
      }, {
        before: this.$t('farmsProducts.whyIShouldUseThisThreeTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisThreeTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisThreeTopAfter')
      }, {
        before: this.$t('farmsProducts.whyIShouldUseThisFourTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisFourTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisFourTopAfter')
      }]

    };
  },
  computed: {
    lang: function lang() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.lang;
    },
    isPageContrasted: function isPageContrasted() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isPageContrasted;
    },
    isFontBigger: function isFontBigger() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isPageFontBigger;
    },

    smoothScroll: function smoothScroll() {
      return __WEBPACK_IMPORTED_MODULE_5__helpers_SmoothScroll__["a" /* default */];
    }
  },

  methods: {},
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isAccessibilityVisible = true;
    __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.showPARP = true;
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isAccessibilityVisible = false;
    __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.showPARP = false;
  }
});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FooterOrange__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FooterOrange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_FooterOrange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_store__ = __webpack_require__(1);





window.store = __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */];
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'farms-presentation',
  data: function data() {
    return {
      nextBtn: null,
      showText: false,
      currentStep: 0,
      isNextBtn: false
    };
  },

  computed: {
    steps: function steps() {
      return this.$t('farmsPresentation.steps');
    }
  },
  methods: {
    showModal: function showModal() {
      __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].commit('SET_MODAL', { visible: true, questionName: 'farms' });
    },
    showNextBtn: function showNextBtn() {
      this.showText = true;
      this.currentStep++;
    },
    nextStep: function nextStep() {
      this.showText = false;
      __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].commit('PLAY_NEXT');
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].commit('SHOW_CANVAS');

    this.nextBtn = document.querySelector('#playButton');
    __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].commit('PLAY_FARM_PRESENTATION', this.showNextBtn);
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].commit('CLEAR_GROUND');
    __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].commit('HIDE_CANVAS');
    __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].commit('HOME_ANIM_FINISHED');
  },

  components: {
    FooterOrange: __WEBPACK_IMPORTED_MODULE_0__components_FooterOrange___default.a
  }
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMain__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_FooterMain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VideoBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VideoBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_VideoBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Counter__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Counter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Counter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_SmoothScroll__ = __webpack_require__(2);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'farms-product',
  components: {
    FooterMain: __WEBPACK_IMPORTED_MODULE_1__components_FooterMain___default.a,
    FooterMoreInformation: __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation___default.a,
    VideoBox: __WEBPACK_IMPORTED_MODULE_3__components_VideoBox___default.a,
    Counter: __WEBPACK_IMPORTED_MODULE_4__components_Counter___default.a
  },
  data: function data() {
    return {
      isDropdownVisible: false,
      booklets: [{ language: 'EN', translationKey: 'component.bookletEnglish' }, { language: 'DT', translationKey: 'component.bookletDeutch' }, { language: 'FR', translationKey: 'component.bookletFrench' }, { language: 'JP', translationKey: 'component.bookletJapanese' }, { language: 'PL', translationKey: 'component.bookletPolish' }],
      circleValues: [{
        before: this.$t('farmsProducts.whyIShouldUseThisOneTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisOneTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisOneTopAfter')
      }, {
        before: this.$t('farmsProducts.whyIShouldUseThisTwoTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisTwoTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisTwoTopAfter')
      }, {
        before: this.$t('farmsProducts.whyIShouldUseThisThreeTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisThreeTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisThreeTopAfter')
      }, {
        before: this.$t('farmsProducts.whyIShouldUseThisFourTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisFourTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisFourTopAfter')
      }]

    };
  },
  computed: {
    lang: function lang() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.lang;
    },
    smoothScroll: function smoothScroll() {
      return __WEBPACK_IMPORTED_MODULE_5__helpers_SmoothScroll__["a" /* default */];
    }
  },
  methods: {
    showDropdown: function showDropdown() {
      this.isDropdownVisible = true;
    },
    hideDropdown: function hideDropdown() {
      this.isDropdownVisible = false;
    },
    downloadBooklet: function downloadBooklet(language) {
      var link = document.createElement('a');
      link.href = '/static/booklet/Bioseco_booklet_' + language + '.pdf';
      link.download = 'Bioseco_Booklet_' + language + '.pdf';
      link.click();
    },
    openVideoModal: function openVideoModal(type) {
      this.$store.commit('SET_MODAL_STATIC_VIDEO_TYPE', type);
      this.$modal.show('video-static');
    }
  }
});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FooterOrange__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FooterOrange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_FooterOrange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_AboutUs__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_AboutUs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_AboutUs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_store__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_SmoothScroll__ = __webpack_require__(2);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "home",
  data: function data() {
    return {
      animFinished: false,
      mounted: false,
      farmDOM: null,
      airportDOM: null,
      forestDOM: null,
      grounds: ["farm", "airport", "area"],
      mobileOption: 1
    };
  },

  mounted: function mounted() {
    var _this = this;

    this.mounted = true;
    __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].commit("SHOW_CANVAS");

    if (this.isHomeAnimActive) {
      setTimeout(function () {
        _this.animFinished = true;
        __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].commit("SHOW_GROUNDS");
      }, 5500);
    } else {

      __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].commit("SET_MOBILE_ACTIVE", {
        ground: "airport",
        dir: 1
      });
    }
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].commit("CLEAR_HOME_MOUSE_EVENTS");
    __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].commit("HIDE_CANVAS");
    __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].commit("HOME_ANIM_FINISHED");
  },

  methods: {
    farmHover: function farmHover() {
      __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].commit("FARM_MOUSE_HOVER");
    },
    farmLeave: function farmLeave() {
      __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].commit("FARM_MOUSE_LEAVE");
    },
    airportHover: function airportHover() {
      __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].commit("AIRPORT_MOUSE_HOVER");
    },
    airportLeave: function airportLeave() {
      __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].commit("AIRPORT_MOUSE_LEAVE");
    },
    forestHover: function forestHover() {
      __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].commit("FOREST_MOUSE_HOVER");
    },
    forestLeave: function forestLeave() {
      __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].commit("FOREST_MOUSE_LEAVE");
    },
    nextGround: function nextGround() {
      if (window.innerWidth > 780 || !this.animFinished) return;
      this.mobileOption = this.mobileOption + 1 >= this.grounds.length ? this.mobileOption : this.mobileOption + 1;
      __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].commit("SET_MOBILE_ACTIVE", {
        ground: this.grounds[this.mobileOption],
        dir: 1
      });
    },
    prevGround: function prevGround() {
      if (window.innerWidth > 780 || !this.animFinished) return;
      this.mobileOption = this.mobileOption - 1 <= 0 ? 0 : this.mobileOption - 1;
      __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].commit("SET_MOBILE_ACTIVE", {
        ground: this.grounds[this.mobileOption],
        dir: -1
      });
    }
  },
  computed: {
    isHomeAnimActive: function isHomeAnimActive() {
      return __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].state.isHomeAnimActive;
    },
    loaded: function loaded() {
      return __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].state.isAppLoaded;
    },

    smoothScroll: function smoothScroll() {
      return __WEBPACK_IMPORTED_MODULE_3__helpers_SmoothScroll__["a" /* default */];
    }
  },
  components: {
    FooterOrange: __WEBPACK_IMPORTED_MODULE_0__components_FooterOrange___default.a,
    AboutUs: __WEBPACK_IMPORTED_MODULE_1__pages_AboutUs___default.a
  }
});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_store__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FooterMain__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FooterMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_FooterMain__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'news',
  components: {
    FooterMain: __WEBPACK_IMPORTED_MODULE_3__components_FooterMain___default.a
  },
  data: function data() {
    return {
      news: [],
      news_en: []
    };
  },

  methods: {
    getData: function getData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response, _response;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$http.get("/data/posts.json");

              case 3:
                response = _context.sent;


                _this.news = response.data.map(function (el) {
                  var img = null;

                  try {
                    img = el._embedded['wp:featuredmedia']['0'].source_url;
                  } catch (e) {}
                  return {
                    t: new Date(el.data_newsa).getTime(),
                    date: el.data_newsa,
                    body: el.content.rendered,
                    title: el.title.rendered,
                    img: img
                  };
                }).sort(function (a, b) {
                  return b.t - a.t;
                });
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                console.log(_context.t0);

              case 10:
                _context.prev = 10;
                _context.next = 13;
                return _this.$http.get("/data/posts_en.json");

              case 13:
                _response = _context.sent;


                _this.news_en = _response.data.map(function (el) {
                  var img = null;

                  try {
                    img = el._embedded['wp:featuredmedia']['0'].source_url;
                  } catch (e) {}
                  return {
                    t: new Date(el.data_newsa).getTime(),
                    date: el.data_newsa,
                    body: el.content.rendered,
                    title: el.title.rendered,
                    img: img
                  };
                }).sort(function (a, b) {
                  return b.t - a.t;
                });
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t1 = _context['catch'](10);

                console.log(_context.t1);

              case 20:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7], [10, 17]]);
      }))();
    }
  },
  computed: {
    lang: function lang() {
      return __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].state.lang;
    }
  },
  mounted: function mounted() {
    this.getData();
  }
});

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMain__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_FooterMain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VideoBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VideoBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_VideoBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Counter__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Counter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Counter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_SmoothScroll__ = __webpack_require__(2);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'farms-product',
  components: {
    FooterMain: __WEBPACK_IMPORTED_MODULE_1__components_FooterMain___default.a,
    FooterMoreInformation: __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation___default.a,
    VideoBox: __WEBPACK_IMPORTED_MODULE_3__components_VideoBox___default.a,
    Counter: __WEBPACK_IMPORTED_MODULE_4__components_Counter___default.a
  },
  data: function data() {
    return {
      circleValues: [{
        before: this.$t('farmsProducts.whyIShouldUseThisOneTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisOneTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisOneTopAfter')
      }, {
        before: this.$t('farmsProducts.whyIShouldUseThisTwoTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisTwoTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisTwoTopAfter')
      }, {
        before: this.$t('farmsProducts.whyIShouldUseThisThreeTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisThreeTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisThreeTopAfter')
      }, {
        before: this.$t('farmsProducts.whyIShouldUseThisFourTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisFourTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisFourTopAfter')
      }]

    };
  },
  computed: {
    lang: function lang() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.lang;
    },
    isPageContrasted: function isPageContrasted() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isPageContrasted;
    },
    isFontBigger: function isFontBigger() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isPageFontBigger;
    },

    smoothScroll: function smoothScroll() {
      return __WEBPACK_IMPORTED_MODULE_5__helpers_SmoothScroll__["a" /* default */];
    }
  },

  methods: {},
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isAccessibilityVisible = true;
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isAccessibilityVisible = false;
  }
});

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMain__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_FooterMain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VideoBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VideoBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_VideoBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Counter__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Counter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Counter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_SmoothScroll__ = __webpack_require__(2);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'farms-product',
  components: {
    FooterMain: __WEBPACK_IMPORTED_MODULE_1__components_FooterMain___default.a,
    FooterMoreInformation: __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation___default.a,
    VideoBox: __WEBPACK_IMPORTED_MODULE_3__components_VideoBox___default.a,
    Counter: __WEBPACK_IMPORTED_MODULE_4__components_Counter___default.a
  },
  data: function data() {
    return {
      circleValues: [{
        before: this.$t('farmsProducts.whyIShouldUseThisOneTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisOneTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisOneTopAfter')
      }, {
        before: this.$t('farmsProducts.whyIShouldUseThisTwoTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisTwoTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisTwoTopAfter')
      }, {
        before: this.$t('farmsProducts.whyIShouldUseThisThreeTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisThreeTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisThreeTopAfter')
      }, {
        before: this.$t('farmsProducts.whyIShouldUseThisFourTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisFourTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisFourTopAfter')
      }]

    };
  },
  computed: {
    lang: function lang() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.lang;
    },
    isPageContrasted: function isPageContrasted() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isPageContrasted;
    },
    isFontBigger: function isFontBigger() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isPageFontBigger;
    },

    smoothScroll: function smoothScroll() {
      return __WEBPACK_IMPORTED_MODULE_5__helpers_SmoothScroll__["a" /* default */];
    }
  },

  methods: {},
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isAccessibilityVisible = true;
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isAccessibilityVisible = false;
  }
});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMain__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_FooterMain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VideoBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VideoBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_VideoBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Counter__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Counter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Counter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_SmoothScroll__ = __webpack_require__(2);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'farms-product',
  components: {
    FooterMain: __WEBPACK_IMPORTED_MODULE_1__components_FooterMain___default.a,
    FooterMoreInformation: __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation___default.a,
    VideoBox: __WEBPACK_IMPORTED_MODULE_3__components_VideoBox___default.a,
    Counter: __WEBPACK_IMPORTED_MODULE_4__components_Counter___default.a
  },
  data: function data() {
    return {
      circleValues: [{
        before: this.$t('farmsProducts.whyIShouldUseThisOneTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisOneTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisOneTopAfter')
      }, {
        before: this.$t('farmsProducts.whyIShouldUseThisTwoTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisTwoTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisTwoTopAfter')
      }, {
        before: this.$t('farmsProducts.whyIShouldUseThisThreeTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisThreeTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisThreeTopAfter')
      }, {
        before: this.$t('farmsProducts.whyIShouldUseThisFourTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisFourTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisFourTopAfter')
      }]

    };
  },
  computed: {
    lang: function lang() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.lang;
    },
    isPageContrasted: function isPageContrasted() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isPageContrasted;
    },
    isFontBigger: function isFontBigger() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isPageFontBigger;
    },

    smoothScroll: function smoothScroll() {
      return __WEBPACK_IMPORTED_MODULE_5__helpers_SmoothScroll__["a" /* default */];
    }
  },

  methods: {},
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isAccessibilityVisible = true;
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isAccessibilityVisible = false;
  }
});

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMain__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_FooterMain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VideoBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VideoBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_VideoBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Counter__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Counter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Counter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_SmoothScroll__ = __webpack_require__(2);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'farms-product',
  components: {
    FooterMain: __WEBPACK_IMPORTED_MODULE_1__components_FooterMain___default.a,
    FooterMoreInformation: __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation___default.a,
    VideoBox: __WEBPACK_IMPORTED_MODULE_3__components_VideoBox___default.a,
    Counter: __WEBPACK_IMPORTED_MODULE_4__components_Counter___default.a
  },
  data: function data() {
    return {
      circleValues: [{
        before: this.$t('farmsProducts.whyIShouldUseThisOneTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisOneTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisOneTopAfter')
      }, {
        before: this.$t('farmsProducts.whyIShouldUseThisTwoTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisTwoTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisTwoTopAfter')
      }, {
        before: this.$t('farmsProducts.whyIShouldUseThisThreeTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisThreeTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisThreeTopAfter')
      }, {
        before: this.$t('farmsProducts.whyIShouldUseThisFourTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisFourTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisFourTopAfter')
      }]

    };
  },
  computed: {
    lang: function lang() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.lang;
    },
    isPageContrasted: function isPageContrasted() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isPageContrasted;
    },
    isFontBigger: function isFontBigger() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isPageFontBigger;
    },

    smoothScroll: function smoothScroll() {
      return __WEBPACK_IMPORTED_MODULE_5__helpers_SmoothScroll__["a" /* default */];
    }
  },

  methods: {},
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isAccessibilityVisible = true;
    __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.showPAIH = true;
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isAccessibilityVisible = false;
    __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.showPAIH = false;
  }
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMain__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_FooterMain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VideoBox__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VideoBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_VideoBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Counter__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Counter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Counter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_SmoothScroll__ = __webpack_require__(2);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'farms-product',
  components: {
    FooterMain: __WEBPACK_IMPORTED_MODULE_1__components_FooterMain___default.a,
    FooterMoreInformation: __WEBPACK_IMPORTED_MODULE_2__components_FooterMoreInformation___default.a,
    VideoBox: __WEBPACK_IMPORTED_MODULE_3__components_VideoBox___default.a,
    Counter: __WEBPACK_IMPORTED_MODULE_4__components_Counter___default.a
  },
  data: function data() {
    return {
      circleValues: [{
        before: this.$t('farmsProducts.whyIShouldUseThisOneTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisOneTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisOneTopAfter')
      }, {
        before: this.$t('farmsProducts.whyIShouldUseThisTwoTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisTwoTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisTwoTopAfter')
      }, {
        before: this.$t('farmsProducts.whyIShouldUseThisThreeTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisThreeTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisThreeTopAfter')
      }, {
        before: this.$t('farmsProducts.whyIShouldUseThisFourTopBefore'),
        val: this.$t('farmsProducts.whyIShouldUseThisFourTop'),
        after: this.$t('farmsProducts.whyIShouldUseThisFourTopAfter')
      }]

    };
  },
  computed: {
    lang: function lang() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.lang;
    },
    isPageContrasted: function isPageContrasted() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isPageContrasted;
    },
    isFontBigger: function isFontBigger() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isPageFontBigger;
    },

    smoothScroll: function smoothScroll() {
      return __WEBPACK_IMPORTED_MODULE_5__helpers_SmoothScroll__["a" /* default */];
    }
  },

  methods: {},
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isAccessibilityVisible = true;
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.isAccessibilityVisible = false;
  }
});

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FooterMain__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FooterMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_FooterMain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMoreInformation__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMoreInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_FooterMoreInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MediaBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MediaBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_MediaBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_SmoothScroll__ = __webpack_require__(2);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'awards',
  data: function data() {
    return {
      popupActivo: false,
      popupActivo2: false
    };
  },

  props: [],
  methods: {},
  components: {
    FooterMain: __WEBPACK_IMPORTED_MODULE_0__components_FooterMain___default.a,
    FooterMoreInformation: __WEBPACK_IMPORTED_MODULE_1__components_FooterMoreInformation___default.a,
    MediaBox: __WEBPACK_IMPORTED_MODULE_2__components_MediaBox___default.a
  },
  computed: {
    lang: function lang() {
      return store.state.lang;
    },
    scrollOffset: function scrollOffset() {
      return window.innerWidth > 980 ? 130 : 90;
    },
    smoothScroll: function smoothScroll() {
      return __WEBPACK_IMPORTED_MODULE_3__helpers_SmoothScroll__["a" /* default */];
    }
  }
});

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FooterOrange__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FooterOrange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_FooterOrange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_store__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "prducts",
  data: function data() {
    return {
      grounds: ["farm", "airport", "area"],
      mobileOption: 1
    };
  },

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].commit("SHOW_CANVAS");
    __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].commit("SHOW_GROUNDS");
    __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].commit("SET_MOBILE_ACTIVE", {
      ground: "airport",
      dir: 1
    });
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].commit("HIDE_CANVAS");
  },

  methods: {
    farmHover: function farmHover() {
      __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].commit("FARM_MOUSE_HOVER");
    },
    farmLeave: function farmLeave() {
      __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].commit("FARM_MOUSE_LEAVE");
    },
    airportHover: function airportHover() {
      __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].commit("AIRPORT_MOUSE_HOVER");
    },
    airportLeave: function airportLeave() {
      __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].commit("AIRPORT_MOUSE_LEAVE");
    },
    forestHover: function forestHover() {
      __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].commit("FOREST_MOUSE_HOVER");
    },
    forestLeave: function forestLeave() {
      __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].commit("FOREST_MOUSE_LEAVE");
    },
    nextGround: function nextGround() {
      if (window.innerWidth > 780) return;
      this.mobileOption = this.mobileOption + 1 >= this.grounds.length ? this.mobileOption : this.mobileOption + 1;
      __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].commit("SET_MOBILE_ACTIVE", {
        ground: this.grounds[this.mobileOption],
        dir: 1
      });
    },
    prevGround: function prevGround() {
      if (window.innerWidth > 780) return;
      this.mobileOption = this.mobileOption - 1 <= 0 ? 0 : this.mobileOption - 1;
      __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].commit("SET_MOBILE_ACTIVE", {
        ground: this.grounds[this.mobileOption],
        dir: -1
      });
    }
  },
  components: {
    FooterOrange: __WEBPACK_IMPORTED_MODULE_0__components_FooterOrange___default.a
  }
});

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isCanvasVisible; });
var isCanvasVisible = function isCanvasVisible(routerName) {
    return routerName === 'home' || routerName === 'farms presentation' || routerName === 'airport presentation' || routerName === 'area presentation' || routerName === 'products';
};

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_js_modal__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_store__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lang_pl__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lang_en__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_whatwg_fetch__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__css_main_css__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__css_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__css_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_touch__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuesax__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuesax___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuesax__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_pure_lightbox__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_pure_lightbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_pure_lightbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuesax_dist_vuesax_css__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuesax_dist_vuesax_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vuesax_dist_vuesax_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_gtag__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_axios__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_axios__);























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_15_axios___default.a;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue_gtag__["a" /* default */], {
  config: { id: "UA-159071720-1" }
}, __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */]);

__webpack_require__(77).polyfill();

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_pure_lightbox___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vuesax___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_js_modal___default.a, {
  dialog: true,
  dynamic: true
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_touch___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.lang = 'en';
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].locale('pl', __WEBPACK_IMPORTED_MODULE_6__lang_pl__["a" /* pl */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].locale('en', __WEBPACK_IMPORTED_MODULE_7__lang_en__["a" /* en */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

var v = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  store: __WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* default */],
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App___default.a }
});

/***/ }),
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 219 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 235 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE4LjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA2ODcuMSA4MDAiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDY4Ny4xIDgwMCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxwYXRoIGZpbGw9IiNGM0I2NjYiIGQ9Ik02NzkuOCwxOTcuNUwzNTAuNiw3LjNjLTQuNS0yLjQtOS42LTIuNC0xNC4xLDBMNy4yLDE5Ny41Yy00LjUsMi40LTcuMiw3LjItNy4yLDEyLjRWNTkwCgljMCw1LjIsMi43LDkuNiw3LjIsMTIuNGwzMjkuMywxOTAuMmM0LjUsMi40LDkuNiwyLjQsMTQuMSwwbDMyOS4zLTE5MC4yYzQuNS0yLjQsNy4yLTcuMiw3LjItMTIuNFYyMDkuNQoJQzY4NywyMDQuNyw2ODQuMywxOTkuOSw2NzkuOCwxOTcuNSBNNjY2LjgsNTg2LjJMMzgxLjUsNzUxbC0yNi40LTM0OS45YzAtMi4xLTIuMS00LjEtNC4xLTQuMWgtMTQuNWMtMi40LDAtNC4xLDEuNy00LjUsNC4xCglMMzA1LjYsNzUxTDIwLjMsNTg2LjJWMjEyLjlMMzQzLjQsMjYuNWwzMjMuMSwxODYuNHYzNzMuMkg2NjYuOHoiLz4KPHBhdGggZmlsbD0iI0YzQjY2NiIgZD0iTTMxOC42LDI4Mi42bDE2LjEsNDVjMS40LDMuOCwxLjcsNi45LDAuNyw3LjJsLTAuNywwLjNjLTcuOSw0LjUtOC45LDE0LjQtOC45LDE0LjQKCWMtMC4zLDMuOC0zLjgsNy42LTcuOSw4LjJsLTQ4LDhjLTMuOCwwLjctOS4zLDMuMS0xMi40LDUuNUwxMTMsNDgzLjhjLTMuMSwyLjQtMi43LDMuMSwxLDEuN2wxNzAuNi02Ni42YzMuNC0xLjQsOC42LTQuOCwxMS03LjkKCWwzMS42LTM3LjRjMi40LTMuMSw3LjYtNC4xLDExLTIuN2MwLDAsOC45LDMuNCwxNi41LTAuN2wxLTAuN2MxLTAuNywzLjgsMSw2LjIsNC4xbDMwLjksMzcuOGMyLjQsMy4xLDcuNiw2LjUsMTEsNy45bDE3MCw2OC43CgljMy40LDEuNCw0LjEsMC43LDEtMS43TDQzMS42LDM3MS45Yy0zLjEtMi40LTguNi00LjgtMTIuNC01LjVsLTQ3LjctOC42Yy0zLjgtMC43LTYuOS00LjUtNi41LTguMmMwLDAsMC0yLjctMi40LTcuMgoJYy0yLjQtNC41LTQuNS01LjUtNC41LTUuNWMtMy40LTEuNy00LjgtNi41LTMuOC0xMGwxNi44LTQ0LjZjMS40LTMuOCwyLjEtOS42LDEuNC0xMy40TDM0Ny4xLDg3LjZjLTAuNy0zLjgtMS40LTMuOC0yLjEsMAoJbC0yNy40LDE4MC45QzMxNi42LDI3MywzMTcuMywyNzkuMiwzMTguNiwyODIuNiIvPgo8L3N2Zz4K"

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(106),
  /* template */
  __webpack_require__(286),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(222)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(310),
  /* scopeId */
  "data-v-d9774706",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(220)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(108),
  /* template */
  __webpack_require__(308),
  /* scopeId */
  "data-v-b89cd494",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(211)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(295),
  /* scopeId */
  "data-v-52186acf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(208)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(115),
  /* template */
  __webpack_require__(292),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(213)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(298),
  /* scopeId */
  "data-v-67567d5b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(206)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(117),
  /* template */
  __webpack_require__(290),
  /* scopeId */
  "data-v-457657a4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(118),
  /* template */
  __webpack_require__(314),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(120),
  /* template */
  __webpack_require__(301),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(194)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(121),
  /* template */
  __webpack_require__(273),
  /* scopeId */
  "data-v-07ef31a6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(196)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(275),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(202)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(124),
  /* template */
  __webpack_require__(284),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(218)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(305),
  /* scopeId */
  "data-v-8e000d14",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(126),
  /* template */
  __webpack_require__(297),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(201)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(127),
  /* template */
  __webpack_require__(283),
  /* scopeId */
  "data-v-2271c780",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(306),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(224)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(129),
  /* template */
  __webpack_require__(312),
  /* scopeId */
  "data-v-e611a2f0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(225)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(130),
  /* template */
  __webpack_require__(313),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(217)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(304),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(132),
  /* template */
  __webpack_require__(302),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(215)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(133),
  /* template */
  __webpack_require__(300),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(198)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(277),
  /* scopeId */
  "data-v-1081880e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(219)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(135),
  /* template */
  __webpack_require__(307),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(204)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(136),
  /* template */
  __webpack_require__(287),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(199)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(280),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(138),
  /* template */
  __webpack_require__(279),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(139),
  /* template */
  __webpack_require__(288),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(226)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(315),
  /* scopeId */
  "data-v-fd60c89e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(207)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(141),
  /* template */
  __webpack_require__(291),
  /* scopeId */
  "data-v-46f2fd5a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(209)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(142),
  /* template */
  __webpack_require__(293),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(212)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(296),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(203)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(144),
  /* template */
  __webpack_require__(285),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(214)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(145),
  /* template */
  __webpack_require__(299),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(197)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(276),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(223)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(147),
  /* template */
  __webpack_require__(311),
  /* scopeId */
  "data-v-dce3f7b4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(148),
  /* template */
  __webpack_require__(272),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home"
    }
  }, [_c('div', {
    staticClass: "page-shadow"
  }, [_c('v-touch', {
    ref: "tapper",
    on: {
      "swiperight": _vm.prevGround,
      "swipeleft": _vm.nextGround
    }
  }, [_c('div', {
    staticClass: "home"
  }, [_c('div', {
    staticClass: "inside products"
  }, [_c('div', {
    staticClass: "container clearfix"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('products.headingTopText')))]), _vm._v(" "), _c('span', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('products.headingBottomText'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "boxes"
  }, [_c('div', {
    staticClass: "arrows"
  }, [_c('div', {
    staticClass: "arrow arrow-prev",
    on: {
      "click": _vm.prevGround
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arrow arrow-next",
    on: {
      "click": _vm.nextGround
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "box farm-box",
    class: {
      current: _vm.grounds[_vm.mobileOption] === 'farm', next: _vm.mobileOption < 0, prev: _vm.mobileOption > 0
    },
    attrs: {
      "to": "/products/farms",
      "id": "farmGround"
    }
  }, [_c('div', {
    on: {
      "mouseover": _vm.farmHover,
      "mouseleave": _vm.farmLeave
    }
  }, [_c('div', {
    staticClass: "area"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(234),
      "alt": "wind-farm"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "big",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('products.farms'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_c('p', [_vm._v("\n                        Bioseco BIRD PROTECTION SYSTEM (BPS)\n                      ")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "box big airport-box",
    class: {
      current: _vm.grounds[_vm.mobileOption] === 'airport', next: _vm.mobileOption < 1, prev: _vm.mobileOption > 1
    },
    attrs: {
      "to": "/products/airport",
      "id": "airportGround"
    }
  }, [_c('div', {
    on: {
      "mouseover": _vm.airportHover,
      "mouseleave": _vm.airportLeave
    }
  }, [_c('div', {
    staticClass: "area"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(70),
      "alt": "airport"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "big",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('products.airports'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_c('p', [_vm._v("\n                        Bioseco AIRPORT FAUNA MONITORING SYSTEM (AFMS)\n                      ")])])])]), _vm._v(" "), _c('router-link', {
    staticClass: "box area-box",
    class: {
      current: _vm.grounds[_vm.mobileOption] === 'area', next: _vm.mobileOption < 2, prev: _vm.mobileOption > 2
    },
    attrs: {
      "to": "/products/area",
      "id": "forestGround"
    }
  }, [_c('div', {
    on: {
      "mouseover": _vm.forestHover,
      "mouseleave": _vm.forestLeave
    }
  }, [_c('div', {
    staticClass: "area"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(71),
      "alt": "area"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "big",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('products.area'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_c('p', [_vm._v("\n                        Bioseco BIRD PROTECTION SYSTEM (BPS)\n                      ")])])])])], 1)])]), _vm._v(" "), _c('router-link', {
    staticClass: "more-about-us",
    attrs: {
      "active-class": "active",
      "to": "/about"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('moreAboutUs')))])])], 1)]), _vm._v(" "), _c('FooterOrange')], 1)])
},staticRenderFns: []}

/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "name": "video-static",
      "classes": ['v--modal', 'responsive-modal'],
      "width": _vm.modalWidth,
      "height": _vm.modalHeight,
      "adaptive": true
    }
  }, [_c('div', {
    staticClass: "video-static-container"
  }, [_c('div', {
    staticClass: "video-frame"
  }, [_c('iframe', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "src": _vm.modalSrc,
      "title": "YouTube video player",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
      "referrerpolicy": "strict-origin-when-cross-origin",
      "allowfullscreen": ""
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 274 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "news"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('media.description')))]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "gallery"
  }, [_vm._l((this.photos), function(photo, index) {
    return _c('div', {
      key: index,
      attrs: {
        "data-aos": "fade-up",
        "data-aos-delay": 100
      }
    }, [_c('img', {
      staticClass: "image",
      attrs: {
        "src": photo.source_url
      },
      on: {
        "click": function($event) {
          _vm.openModal(index)
        }
      }
    })])
  }), _vm._v(" "), _c('vs-popup', {
    attrs: {
      "title": ((_vm.activeIndex + 1) + " / " + (_vm.photos.length)),
      "active": _vm.isModalOpen
    },
    on: {
      "update:active": function($event) {
        _vm.isModalOpen = $event
      }
    }
  }, [_c('div', {
    staticClass: "popup-inner"
  }, [_c('div', {
    staticClass: "gallery-popup"
  }, [_c('div', {
    staticClass: "popup-btn left",
    class: {
      disable: _vm.activeIndex === 0
    },
    on: {
      "click": function($event) {
        _vm.changePhoto(_vm.activeIndex - 1)
      }
    }
  }, [_c('i', {
    staticClass: "chevron left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "gallery-inner"
  }, _vm._l((_vm.photos), function(photo, index) {
    return _c('div', {
      key: index,
      class: _vm.getClass(index)
    }, [_c('img', {
      attrs: {
        "src": photo.source_url
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "popup-btn right",
    class: {
      disable: _vm.activeIndex === _vm.photos.length - 1
    },
    on: {
      "click": function($event) {
        _vm.changePhoto(_vm.activeIndex + 1)
      }
    }
  }, [_c('i', {
    staticClass: "chevron right"
  })])])])])], 2)])])
},staticRenderFns: []}

/***/ }),
/* 275 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product afms",
    class: {
      contrasted: _vm.isPageContrasted, fontBigger: _vm.isFontBigger
    }
  }, [_c('header', {
    staticClass: "page-header",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.lang === 'pl') ? _c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("System monitorowania fauny dla Portów\n          Lotniczych\n        ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Airport Fauna Monitoring System")]) : _vm._e(), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-left",
      "data-aos-delay": "150"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-hover"
  }, [_c('router-link', {
    staticClass: "btn orange",
    attrs: {
      "to": "/products/airport/presentation",
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('component.watchPresentation'))), _c('span')])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "why-us-solution",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "elements"
  }, [_c('div', {
    staticClass: "element bps clearfix"
  }, [_c('div', {
    staticClass: "text-box"
  }, [(_vm.lang === 'pl') ? _c('ul', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('ul', [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n               Zaczynając od roku 2020, przez trzy lata będziemy tworzyć zintegrowany system detekcji ptaków dedykowany dla portów lotniczych. Dzięki naszym wcześniejszym działaniom, kontaktom w branży i poznaniem oczekiwań przedstawicieli lotnisk z całego świata, wiemy dokładnie jak rozwiązanie ma działać. Będzie to system, który z przestrzeni portów lotniczych będzie zbierał informacje o przelatujących ptakach i przekazywał je do mobilnych służb lotniskowych oraz do wieży kontroli lotów. Ponadto, będzie monitorował pas drogi startowej pod kątem obecności zwierząt, które mogą zagrozić operacjom lotniczym. Dzięki naszemu systemowi pracownicy portu będą mogli zredukować ryzyko kolizji samolotów ze zwierzętami. Partnerem strategicznym w tym projekcie jest Port Lotniczy w Gdańsku.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Tytuł projektu:"), _c('br'), _vm._v("\nPrzeprowadzenie prac badawczo-rozwojowych niezbędnych do opracowania nowego autonomicznego systemu AIRPORT FAUNA MONITORING SYSTEM (AFMS) redukującego liczbę kolizji statków powietrznych z ptakami i ssakami.\n               ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                  Cel projektu:"), _c('br'), _vm._v("\nCelem projektu jest przeprowadzenie prac B+R pozwalających na opracowanie prototypu nowego systemu AIRPORT FAUNA MONITORING SYSTEM (AFMS - system monitoringu okolic portu lotniczego do detekcji awifauny ssaków lądowych).\n                "), _c('br'), _c('br'), _c('br'), _vm._v("\n                Wartosć projektu:"), _c('br'), _vm._v("\n                3 493 437,50PLN\n                  "), _c('br'), _c('br'), _vm._v("\n                  Dofinansowanie projektu z UE:"), _c('br'), _vm._v("\n                2 632 075.00PLN\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n               In the years 2020-23, we will develop an integrated bird detection system dedicated to airports. Thanks to our previous actions, contacts and learning about the expectations of representatives of airport from around the world, we know exactly how the solution shall work. It will be a system that will collect information about flocking birds and transmit data to airport services and to the air traffic control tower. In addition, it will monitor the runway for the presence of animals that may endanger air operations. Thanks to our system, airport personnel will be able to reduce the risk of aircraft collisions with animals. The strategic partner in this project is the Gdańsk Airport.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Project title:"), _c('br'), _vm._v("\nCarrying out research and development works necessary to develop a new autonomous AIRPORT FAUNA MONITORING SYSTEM (AFMS) reducing the number of collisions between aircraft and birds and mammals\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n               The aim of the project is to carry out R&D works enabling the development of a prototype of the new AIRPORT FAUNA MONITORING SYSTEM (AFMS - monitoring system around the airport for the detection of land mammal avifauna).\n                "), _c('br'), _c('br'), _c('br'), _vm._v("\n                Project value:"), _c('br'), _vm._v("\n                3 493 437,50PLN\n                  "), _c('br'), _c('br'), _vm._v("\n                 Amount of founding from UE:"), _c('br'), _vm._v("\n                2 632 075.00PLN\n                ")])])
}]}

/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product bps",
    class: {
      contrasted: _vm.isPageContrasted, fontBigger: _vm.isFontBigger
    }
  }, [_c('header', {
    staticClass: "page-header",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.lang === 'pl') ? _c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Promocja marki produktowej BIOSECO")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Promotion of the Product Brand BIOSECO")]) : _vm._e(), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-left",
      "data-aos-delay": "150"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "why-us-solution",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "elements"
  }, [_c('div', {
    staticClass: "element bps clearfix"
  }, [_c('div', {
    staticClass: "text-box"
  }, [(_vm.lang === 'pl') ? _c('ul', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('ul', [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7)]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                Bioseco Spółka Akcyjna realizuje projekt pod tytułem:\n                „Promocja marki produktowej o znaczącym potencjale eksportowym - BPS- na zagranicznych targach i misjach gospodarczych szansą na wzmacnianie trwałego wzrostu i konkurencyjności Bioseco”\n                "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                  Celem projektu jest promocja marki produktowej o znaczącym potencjale eksportowym – Bioseco Bird Protection System (BPS) – na zagranicznych targach i misjach gospodarczych w okresie 01.02.2024-31.12.2026.\n                  Realizacja zadań zaplanowanych w projekcie umożliwi wzmocnienie konkurencyjności Bioseco na istniejących rynkach i wejście na nowe rynki Europy, Ameryki i świata.\n                  "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                  Projekt współfinansowany jest z Europejskiego Funduszu Rozwoju Regionalnego w ramach programu: Fundusze Europejskie dla Nowoczesnej Gospodarki, "), _c('br'), _vm._v("\n                  Priorytet: Środowisko sprzyjające innowacjom"), _c('br'), _vm._v("\n                  Działanie: Promocja marki innowacyjnych MŚP"), _c('br'), _vm._v("\n                  Umowa o dofinansowanie nr FENG.02.25-IP.02-0187/23\n                  "), _c('br'), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "text"
  }, [_c('br'), _vm._v("\n                Wartość projektu:"), _c('br'), _vm._v("\n                252 056.95 zł\n                "), _c('br'), _c('br'), _vm._v("\n                Dofinansowanie projektu z UE:"), _c('br'), _vm._v("\n                126 028,48 zł\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                Bioseco Spółka Akcyjna is implementing a project titled:\n                “Promotion of a Product Brand with Significant Export Potential - BPS - at International Trade Fairs and Economic Missions as an Opportunity to Strengthen Sustainable Growth and Competitiveness of Bioseco.”\n                "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                The aim of the project is to promote the product brand with significant export potential – Bioseco Bird Protection System (BPS) – at international trade fairs and economic missions during the period from February 1, 2024, to December 31, 2026.\n                The implementation of the tasks planned within the project will enhance Bioseco’s competitiveness in existing markets and facilitate entry into new markets in Europe, the Americas, and globally.\n                  "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                The project is co-financed by the European Regional Development Fund under the program: European Funds for a Modern Economy,"), _c('br'), _vm._v("\n                Priority: Innovation-Friendly Environment"), _c('br'), _vm._v("\n                Action: Promotion of Innovative SME Brands"), _c('br'), _vm._v("\n                Grant Agreement No. FENG.02.25-IP.02-0187/23\n                  "), _c('br'), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "text"
  }, [_c('br'), _vm._v("\n                Project value:"), _c('br'), _vm._v("\n                252 056.95 PLN\n                "), _c('br'), _c('br'), _vm._v("\n                EU funding contribution:"), _c('br'), _vm._v("\n                126,028.48 PLN\n              ")])])
}]}

/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-us awards",
    attrs: {
      "id": "awards"
    }
  }, [_c('header', {
    staticClass: "page-header",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('certs.headingTopText'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "certs"
  }, _vm._l((_vm.certs), function(cert) {
    return _c('div', {
      key: cert.key,
      staticClass: "elements",
      on: {
        "click": function($event) {
          _vm.openCert(cert)
        }
      }
    }, [_c('img', {
      staticClass: "isoDetails",
      attrs: {
        "src": cert.img,
        "alt": cert.alt
      }
    })])
  }), 0), _vm._v(" "), _c('footer-main')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-container"
  }, [_c('video', {
    staticClass: "header-video",
    attrs: {
      "src": "static/img/about-us/falcon.mp4",
      "autoplay": "",
      "loop": ""
    }
  })])
}]}

/***/ }),
/* 278 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "more-information"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_vm._v(_vm._s(_vm.$t('component.moreInfo')))]), _vm._v(" "), _c('div', {
    staticClass: "btn-hover"
  }, [_c('a', {
    staticClass: "btn red-border",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    },
    on: {
      "click": function($event) {
        _vm.showModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('component.askAboutMore')) + " "), _c('span')])])])])
},staticRenderFns: []}

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slides clearfix"
  }, [_c('div', {
    staticClass: "page-shadow"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('farmsProducts.headerTopTextPresentation')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('farmsProducts.headerTopSubTextPresentation')))])]), _vm._v(" "), _c('div', {
    staticClass: "right-box",
    class: {
      'show': _vm.showText
    }
  }, [_c('div', {
    staticClass: "vertical-middle"
  }, [_c('div', {
    staticClass: "right-box-content"
  }, [_c('div', {
    staticClass: "number",
    class: 'current-' + _vm.currentStep,
    attrs: {
      "id": "bigNumber"
    }
  }, [_c('div', {
    staticClass: "numbers"
  }, _vm._l((_vm.steps.length), function(i) {
    return _c('span', [_vm._v(_vm._s(i))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "text-content"
  }, [_c('h3', [_vm._v(_vm._s(_vm.steps[_vm.currentStep !== 0 ? _vm.currentStep - 1 : _vm.currentStep].title))]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "content"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.steps[_vm.currentStep !== 0 ? _vm.currentStep - 1 : _vm.currentStep].text)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-hover"
  }, [_c('a', {
    staticClass: "btn orange next-step",
    class: {
      'visible': _vm.currentStep !== _vm.steps.length
    },
    attrs: {
      "id": "playButton"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v(_vm._s(_vm.$t('steps.next'))), _c('span')])]), _vm._v(" "), _c('div', {
    staticClass: "last-step",
    class: {
      'visible': _vm.currentStep === _vm.steps.length
    }
  }, [_c('div', {
    staticClass: "btn-hover"
  }, [_c('div', {
    staticClass: "btn orange",
    on: {
      "click": _vm.showModal
    }
  }, [_vm._v(_vm._s(_vm.$t('steps.ask')))])]), _vm._v(" "), _c('div', {
    staticClass: "btn-hover"
  }, [_c('router-link', {
    staticClass: "btn red-border",
    attrs: {
      "to": "/products/farms"
    }
  }, [_vm._v(_vm._s(_vm.$t('steps.learnMore'))), _c('span')])], 1)])])])])]), _vm._v(" "), _c('FooterOrange')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 280 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product pmt",
    class: {
      contrasted: _vm.isPageContrasted, fontBigger: _vm.isFontBigger
    }
  }, [_c('header', {
    staticClass: "page-header",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.lang === 'pl') ? _c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Wsparcie w przygotowaniu Wniosku i SW do EIC\n          Accelerator Pilot\n        ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Support in preparation of application and FS\n          for EIC Accelerator Pilot\n        ")]) : _vm._e(), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-left",
      "data-aos-delay": "150"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "why-us-solution",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "elements"
  }, [_c('div', {
    staticClass: "element bps clearfix"
  }, [_c('div', {
    staticClass: "text-box"
  }, [(_vm.lang === 'pl') ? _c('ul', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('ul', [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7)]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n         „Wsparcie Bioseco S.A. w przygotowaniu wniosku oraz studium wykonalności w konkursie EIC Accelerator Pilot”\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\nCelem projektu jest zwiększenie innowacyjności i umiędzynarodowienia Spółki poprzez udział w europejskim programie Horyzont 2020 – konkurs EIC Accelerator Pilot.\n ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\nRealizacja projektu pozwoliła na przygotowanie wniosku w ramach programu EIC Accelerator Pilot, opracowanie studium wykonalności, poszukiwania partnerów do projektu, a także udział w panelu eksperckim.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\nProgram Operacyjny Inteligentny Rozwój 2014-2020 Działanie: 2.3 Proinnowacyjne usługi dla przedsiębiorstw\nPoddziałanie: 2.3.6 Granty na Eurogranty\n                  "), _c('br'), _c('br'), _vm._v("\n                  Wartość projektu:"), _c('br'), _vm._v("280 060,00 PLN"), _c('br'), _c('br'), _vm._v("\n                  Wartość dofinansowania:"), _c('br'), _vm._v("280 060,00 PLN"), _c('br'), _c('br'), _vm._v("\n                  Okres realizacji projektu:"), _c('br'), _vm._v("02.03.2020 – 31.03.2021"), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n         Support of Bioseco S.A. in the preparation of the application and the feasibility study in the EIC Accelerator Pilot competition\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\nThe aim of the project is to increase the company's innovation and internationalization by participating in the European program Horizon 2020 - the EIC Accelerator Pilot competition.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\nThe implementation of the project allowed for the preparation of the application under the EIC Accelerator Pilot program, development of the feasibility study, search for partners for the project, as well as participation in the expert panel.\n               ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\nOperational Programme Smart Growth 2014-2020; Measure: 2.3; Pro-innovative services for enterprises; Sub-measure: 2.3.6 Grants for Eurogrants\n                  "), _c('br'), _c('br'), _vm._v("\n                  Project value:"), _c('br'), _vm._v("280 060,00 PLN"), _c('br'), _c('br'), _vm._v("\n                  Co-financing value:"), _c('br'), _vm._v("280 060,00 PLN"), _c('br'), _c('br'), _vm._v("\n                  Project implementation period:"), _c('br'), _vm._v("02.03.2020 – 31.03.2021"), _c('br')])])
}]}

/***/ }),
/* 281 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isAnim) ? _c('transition', {
    attrs: {
      "name": "show-footer"
    }
  }, [(_vm.show) ? _c('footer', {
    staticClass: "orange-footer"
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isAnim) ? _c('footer', {
    staticClass: "orange-footer"
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 282 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video",
    style: ({
      backgroundImage: 'url(' + _vm.bgsrc + ')'
    }),
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inside"
  }, [_c('p', [_vm._v(" aaaaaaaaa ")])])
}]}

/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product"
  }, [_c('header', {
    staticClass: "page-header",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('areaProducts.headerTopText'))
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_vm._v(_vm._s(_vm.$t('areaProducts.headerTopSubText')))]), _vm._v(" "), _c('span', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-left",
      "data-aos-delay": "150"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('areaProducts.headerText'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-hover"
  }, [_c('router-link', {
    staticClass: "btn orange",
    attrs: {
      "to": "/products/area/presentation",
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('component.watchPresentation'))), _c('span')])], 1)]), _vm._v(" "), _c('a', {
    staticClass: "more-about-us white",
    attrs: {
      "data-scroll-offset": "120",
      "href": "#top",
      "data-aos": "fade-up",
      "data-aos-delay": "300"
    },
    on: {
      "click": _vm.smoothScroll
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('component.moreAboutUs')))])])]), _vm._v(" "), _c('div', {
    staticClass: "why-us-solution",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "top-text"
  }, [_c('p', {
    attrs: {
      "data-aos": "fade-up"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('areaProducts.whyOurSolutionText'))
    }
  }), _vm._v(" "), _c('h2', {
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(_vm._s(_vm.$t('areaProducts.whyOurSolution')))])]), _vm._v(" "), _c('div', {
    staticClass: "elements"
  }, [_c('div', {
    staticClass: "element right clearfix"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(_vm._s(_vm.$t('areaProducts.sectionOneTitle')))])]), _vm._v(" "), _c('ul', [_c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('areaProducts.sectionOneText1')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('areaProducts.sectionOneText2')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "element left clearfix"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._m(3), _vm._v(" "), _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(_vm._s(_vm.$t('areaProducts.sectionTwoTitle')))])]), _vm._v(" "), _c('ul', [_c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('areaProducts.sectionTwoText1')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('areaProducts.sectionTwoText2')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "300"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('areaProducts.sectionTwoText3')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "350"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('areaProducts.sectionTwoText4')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "400"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('areaProducts.sectionTwoText5')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "450"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('areaProducts.sectionTwoText6')))])])])])])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "bottom-last"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('areaProducts.whyIShouldUseThis')))]), _vm._v(" "), _c('div', {
    staticClass: "elements"
  }, [_c('div', {
    staticClass: "element"
  }, [_c('Counter', {
    attrs: {
      "data": _vm.circleValues[0]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "150"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('areaProducts.whyIShouldUseThisOneText')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "element"
  }, [_c('Counter', {
    attrs: {
      "data": _vm.circleValues[1]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('areaProducts.whyIShouldUseThisTwoText')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "element"
  }, [_c('Counter', {
    attrs: {
      "data": _vm.circleValues[2]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "350"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('areaProducts.whyIShouldUseThisThreeText')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "element"
  }, [_c('Counter', {
    attrs: {
      "data": _vm.circleValues[3]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "450"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('areaProducts.whyIShouldUseThisFourText')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "btn-hover"
  }, [_c('router-link', {
    staticClass: "btn orange",
    attrs: {
      "to": "/products/area/presentation",
      "data-aos": "fade-up"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('component.watchPresentation'))), _c('span')])], 1)])]), _vm._v(" "), _c('footer-more-information', {
    attrs: {
      "modalpage": 'area'
    }
  }), _vm._v(" "), _c('footer-main')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image",
    attrs: {
      "data-aos": "flip-left"
    }
  }, [_c('figure', {
    staticClass: "hexagon-image resizable",
    staticStyle: {
      "background-image": "url('/static/img/product/image4.jpg')"
    }
  }, [_c('div', {
    staticClass: "hexTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "hexBottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-right"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }, [_c('span', [_vm._v("1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image",
    attrs: {
      "data-aos": "flip-right"
    }
  }, [_c('figure', {
    staticClass: "hexagon-image resizable",
    staticStyle: {
      "background-image": "url('/static/img/product/image2.jpg')"
    }
  }, [_c('div', {
    staticClass: "hexTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "hexBottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-left"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-left",
      "data-aos-delay": "100"
    }
  }, [_c('span', [_vm._v("2")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom-first orange-bg"
  }, [_c('div', {
    staticClass: "image-boxes inline-boxes"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "box",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/product/image-box-1.jpg",
      "alt": "team1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "150"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/product/image-box-2.jpg",
      "alt": "team2"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/product/image-box-3.jpg",
      "alt": "team3"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/product/image-box-4.jpg",
      "alt": "team4"
    }
  })])])])])
}]}

/***/ }),
/* 284 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slides clearfix"
  }, [_c('div', {
    staticClass: "page-shadow"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('airportProducts.headerTopTextPresentation')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('airportProducts.headerTopSubTextPresentation')))])]), _vm._v(" "), _c('div', {
    staticClass: "right-box",
    class: {
      'show': _vm.showText
    }
  }, [_c('div', {
    staticClass: "vertical-middle"
  }, [_c('div', {
    staticClass: "right-box-content"
  }, [_c('div', {
    staticClass: "number",
    class: 'current-' + _vm.currentStep,
    attrs: {
      "id": "bigNumber"
    }
  }, [_c('div', {
    staticClass: "numbers"
  }, _vm._l((_vm.steps.length), function(i) {
    return _c('span', [_vm._v(_vm._s(i))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "text-content"
  }, [_c('h3', [_vm._v(_vm._s(_vm.steps[_vm.currentStep !== 0 ? _vm.currentStep - 1 : _vm.currentStep].title))]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "content"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.steps[_vm.currentStep !== 0 ? _vm.currentStep - 1 : _vm.currentStep].text)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-hover"
  }, [_c('a', {
    staticClass: "btn orange next-step",
    class: {
      'visible': _vm.currentStep !== _vm.steps.length
    },
    attrs: {
      "id": "playButton"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v(_vm._s(_vm.$t('steps.next'))), _c('span')])]), _vm._v(" "), _c('div', {
    staticClass: "last-step",
    class: {
      'visible': _vm.currentStep === _vm.steps.length
    }
  }, [_c('div', {
    staticClass: "btn-hover"
  }, [_c('div', {
    staticClass: "btn orange",
    on: {
      "click": _vm.showModal
    }
  }, [_vm._v(_vm._s(_vm.$t('steps.ask')))])]), _vm._v(" "), _c('div', {
    staticClass: "btn-hover"
  }, [_c('router-link', {
    staticClass: "btn red-border",
    attrs: {
      "to": "/products/airport"
    }
  }, [_vm._v(_vm._s(_vm.$t('steps.learnMore'))), _c('span')])], 1)])])])])])]), _vm._v(" "), _c('FooterOrange')], 1)])
},staticRenderFns: []}

/***/ }),
/* 285 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product bps",
    class: {
      contrasted: _vm.isPageContrasted, fontBigger: _vm.isFontBigger
    }
  }, [_c('header', {
    staticClass: "page-header",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.lang === 'pl') ? _c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Grant PBE - Pomorski Broker Eksportowy")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Project PBE Grant - Pomorski Broker\n          Eksportowy\n        ")]) : _vm._e(), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-left",
      "data-aos-delay": "150"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "why-us-solution",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "elements"
  }, [_c('div', {
    staticClass: "element bps clearfix"
  }, [_c('div', {
    staticClass: "text-box"
  }, [(_vm.lang === 'pl') ? _c('ul', [_c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n         Grant PBE (\"Pomorski Broker Eksportowy\") ma na celu promocję Bioseco, jako wystawcy, w 4 międzynarodowych targach i wystawach do 31.10.2023 r. Udział w renomowanych międzynarodowych imprezach wystawienniczych przyczyni się do zmiany modelu biznesowego Bioseco SA, a w konsekwencji przełoży się na wzrost eksportu innowacyjnych systemów detekcji wizyjnej.\n                  "), _c('br'), _c('Br'), _vm._v("\nCelem zrealizowanego projektu była promocja firmy Bioseco, jako wystawcy, w 4 międzynarodowych targach i wystawach w terminie do 31.10.2023 roku. Przedstawiciele spółki wzięli udział w 6 wydarzeniach wystawienniczych. Realizacja projektu pozwoliła na zaprezentowanie oferty produktowej Bioseco w ważnych z punktu widzenia ekspansji wydarzeniach. Przedstawiciele spółki zaprezentowali nie tylko marketingowe aspekty rozwiązania, ale także podjęli wysiłek eksperckiego potwierdzenia skuteczności oferowanych rozwiązań. Zrealizowane działania były zgodne z polityką internacjonalizacji Bioseco, poprzez efektywne połączenie działalności promocyjnej z elementem budowania pozycji eksperta branżowego, wspieranym przez udział przedstawicieli firmy w panelach dyskusyjnych i prezentacjach.\n                  "), _c('br'), _c('br'), _vm._v("\nProjekt Grant PBE (\"Pomorski Broker Eksportowy\") jest współfinansowany z Unii Europejskiej."), _c('br'), _vm._v("Numer umowy: UDG-PBE.07.2023/026\n                ")], 1)]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('ul', [_vm._m(1), _vm._v(" "), _vm._m(2)]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("\n                  Kwota dofinansowania z UE:"), _c('br'), _vm._v("\n                  79 593.29 PLN; 49,20%\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n              Project PBE Grant („Pomorski Broker Eksportowy”) aims to promote Bioseco, as an exhibitor, in 4 international fairs and exhibitions until 31.10.2023. Participation in renowned international exhibition events will contribute to a change in the business model of Bioseco SA and, as a result, will translate into increased exports of innovative vision detection systems\n\n                  "), _c('br'), _c('br'), _vm._v("\nThe aim of the project was to promote Bioseco, as an exhibitor, in 4 international fairs and exhibitions by 31.10.2023. Delegates of the company participated in 6 exhibition events. The implementation of the project enabled the Bioseco’s portfolio to be presented at key wind industry events. Representatives of the company presented not only the marketing aspects of the solution, but also made an effort to expertly confirm the effectiveness of the BPS. The realized activities were in line with Bioseco's internationalization policy, by effectively combining promotional activities with the element of building the position of an industry expert, supported by the participation of company representatives in discussions and presentations.\n                  "), _c('br'), _c('br'), _c('br'), _vm._v("Project PBE Grant („Pomorski Broker Eksportowy”) is co-financed from the European Union.\n                  "), _c('br'), _vm._v("Agreement number: UDG-PBE.07.2023/026\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("\n                  Amount of founding from UE:"), _c('br'), _vm._v("\n                  79 593.29 PLN; 49,20%\n                ")])])
}]}

/***/ }),
/* 286 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "canvas-animation",
    class: {
      hide: !_vm.isCanvasVisible, home: _vm.isHome
    }
  })
},staticRenderFns: []}

/***/ }),
/* 287 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "elements clearfix"
  }, [_c('div', {
    staticClass: "element"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "top-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('contact.stayInContact')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_vm._v("\n                Bioseco S.A.\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "adress",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "150"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('contact.street'))), _c('br'), _vm._v(" 80-298 Gdańsk"), _c('br'), _vm._v(" " + _vm._s(_vm.$t('contact.pl')))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "btn-hover"
  }, [_c('a', {
    staticClass: "btn orange",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "350"
    },
    on: {
      "click": function($event) {
        _vm.showModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('contact.haveQuestions')))])])])]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('router-link', {
    staticClass: "more-about-us",
    attrs: {
      "active-class": "active",
      "to": "/about"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('component.moreAboutUs')))])])], 1)])]), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "phone",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('p', [_vm._v("+48 603 422 633")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mail",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_c('p', [_vm._v("offers@bioseco.com")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "300"
    }
  }, [_vm._v("\n                NIP 586-22-82-513"), _c('br'), _vm._v(" NIP EU PL5862282513"), _c('br'), _vm._v(" REGON 221871650"), _c('br'), _vm._v("KRS 0000906735"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "element"
  }, [_c('div', {
    staticClass: "map",
    attrs: {
      "data-aos": "flip-left",
      "data-aos-delay": "250"
    }
  }, [_c('div', {
    attrs: {
      "id": "map"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-hexagons"
  }, [_c('div', {
    staticClass: "bg-hexagon"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-hexagon"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-hexagon"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-hexagon"
  })])
}]}

/***/ }),
/* 288 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product"
  }, [_c('header', {
    staticClass: "page-header",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('farmsProducts.headerTopText'))
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_vm._v(_vm._s(_vm.$t('farmsProducts.headerTopSubText')))]), _vm._v(" "), _c('span', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-left",
      "data-aos-delay": "150"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('farmsProducts.headerText'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-hover"
  }, [_c('router-link', {
    staticClass: "btn orange",
    attrs: {
      "to": "/products/farms/presentation",
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('component.watchPresentation'))), _c('span')])], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-hover",
    on: {
      "click": function($event) {
        _vm.openVideoModal('presentation')
      }
    }
  }, [_c('div', {
    staticClass: "btn orange",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_vm._v(_vm._s(_vm.$t('component.watchVideo'))), _c('span')])]), _vm._v(" "), _c('div', {
    staticClass: "btn-hover",
    on: {
      "click": function($event) {
        _vm.openVideoModal('realExample')
      }
    }
  }, [_c('div', {
    staticClass: "btn orange",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_vm._v(_vm._s(_vm.$t('component.watchExampleVideo'))), _c('span')])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    },
    on: {
      "mouseover": _vm.showDropdown,
      "mouseleave": _vm.hideDropdown
    }
  }, [_c('div', {
    staticClass: "dropdown-btn orange"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('component.watchBooklet'))), _c('span'), _vm._v(" "), (_vm.isDropdownVisible) ? _c('div', {
    staticClass: "dropdown-menu"
  }, [_c('ul', _vm._l((_vm.booklets), function(booklet) {
    return _c('li', {
      key: booklet.language,
      on: {
        "click": function($event) {
          _vm.downloadBooklet(booklet.language)
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.$t(booklet.translationKey)) + "\n              "), _c('i', {
      staticClass: "material-icons"
    }, [_vm._v("download")])])
  }), 0)]) : _vm._e()])])]), _vm._v(" "), _c('a', {
    staticClass: "more-about-us white",
    attrs: {
      "data-scroll-offset": "120",
      "href": "#top",
      "data-aos": "fade-up",
      "data-aos-delay": "300"
    },
    on: {
      "click": _vm.smoothScroll
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('component.moreAboutUs')))])])]), _vm._v(" "), _c('div', {
    staticClass: "why-us-solution",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "top-text"
  }, [_c('p', {
    attrs: {
      "data-aos": "fade-up"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('farmsProducts.whyOurSolutionText'))
    }
  }), _vm._v(" "), _c('h2', {
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(_vm._s(_vm.$t('farmsProducts.whyOurSolution')))])]), _vm._v(" "), _c('div', {
    staticClass: "elements"
  }, [_c('div', {
    staticClass: "element right clearfix"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(_vm._s(_vm.$t('farmsProducts.sectionOneTitle')))])]), _vm._v(" "), _c('ul', [_c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('farmsProducts.sectionOneText1')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('farmsProducts.sectionOneText2')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "300"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('farmsProducts.sectionOneText3')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "350"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('farmsProducts.sectionOneText4')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "400"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('farmsProducts.sectionOneText5')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "element left clearfix"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._m(3), _vm._v(" "), _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(_vm._s(_vm.$t('farmsProducts.sectionTwoTitle')))])]), _vm._v(" "), _c('ul', [_c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('farmsProducts.sectionTwoText1'))
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('farmsProducts.sectionTwoText2')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "300"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('farmsProducts.sectionTwoText3')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "350"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('farmsProducts.sectionTwoText4')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "element right clearfix"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._m(5), _vm._v(" "), _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(_vm._s(_vm.$t('farmsProducts.sectionThreeTitle')))])]), _vm._v(" "), _c('ul', [_c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('farmsProducts.sectionThreeText1')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('farmsProducts.sectionThreeText2')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "300"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('farmsProducts.sectionThreeText3')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "350"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('farmsProducts.sectionThreeText4')))])])])])])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "bottom-last"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h2', {
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(_vm._s(_vm.$t('farmsProducts.whyIShouldUseThis')))]), _vm._v(" "), _c('div', {
    staticClass: "elements"
  }, [_c('div', {
    staticClass: "element"
  }, [_c('Counter', {
    attrs: {
      "data": _vm.circleValues[0]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "150"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('farmsProducts.whyIShouldUseThisOneText')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "element"
  }, [_c('Counter', {
    attrs: {
      "data": _vm.circleValues[1]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('farmsProducts.whyIShouldUseThisTwoText')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "element"
  }, [_c('Counter', {
    attrs: {
      "data": _vm.circleValues[2]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "350"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('farmsProducts.whyIShouldUseThisThreeText')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "element"
  }, [_c('Counter', {
    attrs: {
      "data": _vm.circleValues[3]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "450"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('farmsProducts.whyIShouldUseThisFourText')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "btn-hover"
  }, [_c('router-link', {
    staticClass: "btn orange",
    attrs: {
      "to": "/products/farms/presentation",
      "data-aos": "fade-up"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('component.watchPresentation'))), _c('span')])], 1)])]), _vm._v(" "), _c('footer-more-information', {
    attrs: {
      "modalpage": 'farms'
    }
  }), _vm._v(" "), _c('footer-main')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image"
  }, [_c('figure', {
    staticClass: "hexagon-image resizable",
    staticStyle: {
      "background-image": "url('/static/img/product/image1.jpg')"
    },
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "hexTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "hexBottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-right",
      "data-aos-delay": "150"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }, [_c('span', [_vm._v("1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image"
  }, [_c('figure', {
    staticClass: "hexagon-image resizable",
    staticStyle: {
      "background-image": "url('/static/img/product/image2.jpg')"
    },
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "hexTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "hexBottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-left",
      "data-aos-delay": "150"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-left",
      "data-aos-delay": "100"
    }
  }, [_c('span', [_vm._v("2")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image"
  }, [_c('figure', {
    staticClass: "hexagon-image resizable",
    staticStyle: {
      "background-image": "url('/static/img/product/image3.jpg')"
    },
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "hexTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "hexBottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }, [_c('span', [_vm._v("3")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom-first orange-bg"
  }, [_c('div', {
    staticClass: "image-boxes inline-boxes"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "box",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/product/image-box-1.jpg",
      "alt": "team1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "150"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/product/image-box-2.jpg",
      "alt": "team2"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/product/image-box-3.jpg",
      "alt": "team3"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/product/image-box-4.jpg",
      "alt": "team4"
    }
  })])])])])
}]}

/***/ }),
/* 289 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.data.before))]), _vm._v(" "), (_vm.data.val.split(',').length === 1) ? _c('div', {
    staticClass: "numbers"
  }, _vm._l((_vm.data.val.length), function(number, index) {
    return _c('span', {
      staticClass: "number"
    }, _vm._l((parseInt(_vm.data.val[index]) + 1), function(i, ii) {
      return _c('em', {
        class: ("show-" + (_vm.data.val[index]))
      }, [_vm._v(_vm._s(ii))])
    }), 0)
  }), 0) : _c('div', {
    staticClass: "numbers"
  }, [_vm._l((_vm.data.val.split(',')[0].length), function(number, index) {
    return _c('span', {
      staticClass: "number"
    }, _vm._l((parseInt(_vm.data.val.split(',')[0][index]) + 1), function(i, ii) {
      return _c('em', {
        class: ("show-" + (_vm.data.val.split(',')[0][index]))
      }, [_vm._v(_vm._s(ii))])
    }), 0)
  }), _vm._v(" "), _c('span', {
    staticClass: "comma"
  }, [_vm._v(",")]), _vm._v(" "), _vm._l((_vm.data.val.split(',')[1].length), function(number, index) {
    return _c('span', {
      staticClass: "number"
    }, _vm._l((parseInt(_vm.data.val.split(',')[1][index]) + 1), function(i, ii) {
      return _c('em', {
        class: ("show-" + (_vm.data.val.split(',')[1][index]))
      }, [_vm._v(_vm._s(ii))])
    }), 0)
  })], 2), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.data.after))])])
},staticRenderFns: []}

/***/ }),
/* 290 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isCanvasLoaded) ? _c('div', {
    staticClass: "preloader"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "leaf",
    class: {
      'hide': _vm.prc === 100
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "20.989",
      "height": "16.011",
      "viewBox": "0 0 20.989365 16.010891"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "id": "a",
      "d": "M0 0h1280v800H0z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "b"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#a",
      "overflow": "visible",
      "width": "100%",
      "height": "100%"
    }
  })]), _c('g', {
    attrs: {
      "clip-path": "url(#b)",
      "transform": "translate(-621.03 -386.895)"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "id": "c",
      "d": "M-9.083-5.833h1280v800h-1280z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "d"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#c",
      "overflow": "visible",
      "width": "100%",
      "height": "100%"
    }
  })]), _c('path', {
    attrs: {
      "clip-path": "url(#d)",
      "d": "M635.913 399.384c-4.19 2.96-7.787 2.88-9.978.955-.342-.547.248-.983.82-1.418l14.08-9.95c-.157 1.947-.996 7.634-4.922 10.41m-11.23-.735c-1.184-2.636-.137-5.996 4.055-8.958 3.925-2.775 9.718-1.773 11.663-1.308l-14.08 9.95c-.603.395-1.21.805-1.636.315m17.335-10.896c-.03-.042-8.548-2.56-13.93 1.245-5.078 3.586-6.06 7.705-4.224 10.777l-.38-.38s-1.015.232-2.456 1.343c.665.034.84.91 1.292 1.108.808-.474 1.802-1.174 2.072-1.313 2.353 2.938 6.795 3.475 12.055-.243 5.383-3.805 5.6-12.492 5.567-12.535",
      "clip-rule": "evenodd",
      "fill": "#ef4e23",
      "fill-rule": "evenodd"
    }
  })]), _c('g', {
    attrs: {
      "clip-path": "url(#b)",
      "transform": "translate(-621.03 -386.895)"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "id": "e",
      "d": "M628.677 389.725c-4.236 3.006-5.296 6.417-4.097 9.095.428.497 1.04.08 1.65-.32l14.232-10.105c-.93-.223-2.75-.57-4.818-.57-2.285 0-4.887.42-6.967 1.9"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "f"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#e",
      "overflow": "visible",
      "width": "100%",
      "height": "100%"
    }
  })]), _c('g', {
    attrs: {
      "clip-path": "url(#f)"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "id": "g",
      "d": "M622.987 387.538h18.052v12.36h-18.054z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "h"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#g",
      "overflow": "visible",
      "width": "100%",
      "height": "100%"
    }
  })]), _c('g', {
    attrs: {
      "clip-path": "url(#h)"
    }
  }, [_c('image', {
    attrs: {
      "overflow": "visible",
      "width": "63",
      "height": "43",
      "xlink:href": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAxCAYAAABnCd/9AAAACXBIWXMAACaZAAAmmQHgIlaIAAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAoxJREFUeNrsWU1KXEEQrp8ecQai m1kEvIBHCLmEhJwn18gu+5wi5ABuA7MIBBQMIUTciKLzutI/r33qvGdXNll0vYIe7Zne1MdX9X3V DTDHHHPMMcd/D3y8udt8fX375dO77urXW3B77Wff3QMfrs/d0fFZ2J2uTj6clp/ck4N31wfd5eWb 7s/Fe1xQ87jI1gNsZUOv1puw/R3BGQcGEZC3C3R+icztM0YEgP0CaJcEO8CEbySxxbUPDKIPRAgf zF2E6UVghPICwvYZ0+cqI6m6ERiH1T5lJnPdLSWEYVnQ5Ik8R4ChQC8Kf8hAKdGwaqX00F+M9Ji0 UMEYTIfHUWyTMblKXgQmARcPxXJCMsGYlKeq+UYE2UaPEVH2GIHew/R+pn1kMlukpkqSGBMcbxwH yMJI4FN1qFTJnsHTAFMYQy6cdwZ6jM+g1FSJolz3ko1sQJUgg4I1Vco9JlNLLPgY6dW3KtcJxL7x WvAxyNqRoDCGAy7tq5KA70mgmq7JzkjQ+5hq802M6UcCG6VUcq0xhoZSEgsGr5SSqscg2+kx0ul8 TAIm+hc2ItegVaVHPgasGDyVj0F46DFghjFcL6V07YD58gbRQPNFn3KVGmPijERheBR2Ni6qgFOe qFGlctDEE22Q65wv1oGBgqABxqCwUq4RbI0EWlWKd58+0MobeXCTAAypp2tLzyfaWWlovHYYk2/v KsB4kTQKiBGDF4GRNDBrRgI0dLUJ5YlWIddSQDECjEyQYOJdyZBco8rHxGtzTx624d/2YREJeYJf iHTL51g8VSXev6XV+pzZfQN0BpDpgPYOvtP+4Y+wu5pmDLmf4JYfyd9/BrTxdo1udRMIcfMcmDnm +Lf4K8AAmMmIPH3MiS4AAAAASUVORK5CYII=",
      "transform": "matrix(.2865 0 0 -.2875 622.987 399.898)"
    }
  })])])]), _c('g', {
    attrs: {
      "clip-path": "url(#b)",
      "transform": "translate(-621.03 -386.895)"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "id": "i",
      "d": "M626.555 399.15c-.58.443-1.175.882-.828 1.437 2.215 1.953 5.85 2.036 10.084-.972 3.97-2.82 4.816-8.592 4.976-10.57l-14.23 10.104z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "j"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#i",
      "overflow": "visible",
      "width": "100%",
      "height": "100%"
    }
  })]), _c('g', {
    attrs: {
      "clip-path": "url(#j)"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "id": "k",
      "d": "M624.964 388.714h16.48v14.323h-16.48z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "l"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#k",
      "overflow": "visible",
      "width": "100%",
      "height": "100%"
    }
  })]), _c('g', {
    attrs: {
      "clip-path": "url(#l)"
    }
  }, [_c('image', {
    attrs: {
      "overflow": "visible",
      "width": "58",
      "height": "50",
      "xlink:href": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAA1CAYAAAD2xDO5AAAACXBIWXMAACboAAAm6AEWeMBbAAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAoRJREFUeNrsWkuKG0EMrSdVGw+B DMx+yDYHmENknXvkFLlCDpFdIJBzzGYWs8gyDISEWUwgH2K3Ul3V/nXKbvXSzy4Q2E1tXkt6epI6 hPM5zYPhg58f394svty/bp++XwdtOFCahRCbP2jmHy7fvP+0ehyH9xLoF8vHb6+Wjw8v0QgNeDSz JWbzz+nffvBBEmBtG0S7gIIkwJPnFb8ztq1TAa8GQYuYLkYlwd45VNtsh8Abyt3OgoAn7IGEaRdP PanTxWxEvJ6dOYAUq8Brv4895ysOrYPviGFlJNgD/scT94Z8NiI5I27PoysNRJ4vhIcx8JIAp1K3 NhaBh4xrJOytY8aUH20ygMTzCZUlr8uY53Odz/kuNGyf+a6r8+PgN2xvwuP5oG627wUBjcLbIvLD 2l76mqhUbB+gBZdP5ICG8Cy0xet+kcNDeAjik7fogdfq4vFGveUoxljYZyUk2JQ7jp6u2qvsCXu2 xsaqaVyp8z3bJ3Y0IoWHFS6X54nkraEPe6izqyMKe5g75/tLSpbzvXZxh31WeRTg2ymTHCUjPHgJ T9Y5D7awHwUvjAPMKYQHsn5+JXKmTW95Fhd5Jjlpbs9CeHDK222RA6Yx1qTGBoSEByfhQZQv7MXV z2tmerAovDzGciwtSr6jXKTJeefGZndLy1LqZO1UR85zjbHKfl7C8FuM0xhj5VKnE/p5pqVFt6j0 9POGsqU1Jnlrpa11KLz+DYFM3gp8A8zseaKPEwrhO8OebkVttiHyMYW3U+tPaZhh1qqFbGXwR8J4 CG1jtoyHc765+IXZs6+wxWVA5AEv8W+Q+OMgeJk9v5P51TtoczXccBz30UUCfxvO53zCPwEGALgk kiMRmnxMAAAAAElFTkSuQmCC",
      "transform": "matrix(.2842 0 0 -.2865 624.964 403.037)"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "c100 small",
    class: ['p' + _vm.prc, {
      'hide': _vm.prc === 100
    }]
  }, [_c('span'), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "text",
    class: {
      'hide': _vm.prc === 100
    }
  }, [_vm._v("Loading assets...")])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slice"
  }, [_c('div', {
    staticClass: "bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "fill"
  })])
}]}

/***/ }),
/* 291 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auctions"
  }, [_c('div', {
    staticClass: "media-box"
  }, [_c('h2', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_vm._v(_vm._s(_vm.$t('infoBox.newsTitle')))]), _vm._v(" "), _vm._l((_vm.news), function(item, index) {
    return (_vm.lang === 'pl') ? _c('div', {
      key: item.title + index,
      staticClass: "news-container",
      attrs: {
        "data-aos": "fade-up"
      }
    }, [(item.img) ? _c('div', {
      staticClass: "foto"
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": item.title
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "title",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "info",
      domProps: {
        "innerHTML": _vm._s(item.body)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "posted"
    }, [_c('p', {
      staticClass: "par_posted"
    }, [_vm._v(_vm._s(_vm.$t('infoBox.postedDescription')) + " " + _vm._s(item.date))])])])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.news_en), function(item, index) {
    return (_vm.lang !== 'pl') ? _c('div', {
      key: item.title + index,
      staticClass: "news-container",
      attrs: {
        "data-aos": "fade-up"
      }
    }, [(item.img) ? _c('div', {
      staticClass: "foto"
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": item.title
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "title",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "info",
      domProps: {
        "innerHTML": _vm._s(item.body)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "posted"
    }, [_c('p', {
      staticClass: "par_posted"
    }, [_vm._v(_vm._s(_vm.$t('infoBox.postedDescription')) + " " + _vm._s(item.date) + " ")])])])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.$t('infoBox.infoBoxes')), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "news-container",
      attrs: {
        "data-aos": "fade-up"
      }
    }, [(item.img) ? _c('div', {
      staticClass: "foto"
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": item.title
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "title",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "info",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    }), _vm._v(" "), (item.video) ? _c('div', {
      staticClass: "video-container"
    }, [_c('video', {
      attrs: {
        "src": item.video,
        "poster": item.poster,
        "controls": ""
      }
    })]) : _vm._e(), _vm._v(" "), (item.link) ? _c('div', {
      staticClass: "link"
    }, [_vm._v(_vm._s(_vm.$t('infoBox.linkDescription')) + "\n          "), _c('a', {
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fas fa-link"
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "posted"
    }, [_c('p', {
      staticClass: "par_posted"
    }, [_vm._v(_vm._s(_vm.$t('infoBox.postedDescription')) + " " + _vm._s(item.date) + " ")])])]), _vm._v(" "), _c('hr', {
      staticClass: "separate"
    })])
  }), _vm._v(" "), _c('vs-collapse', [_c('vs-collapse-item', {
    attrs: {
      "not-arrow": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', {
    staticClass: "archive",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-double-right"
  }), _vm._v(" " + _vm._s(_vm.$t('infoBox.archiveTitle')) + " "), _c('i', {
    staticClass: "fas fa-angle-double-left"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-box centered"
  }, _vm._l((_vm.$t('mediaBox.mediaBoxes')), function(item, index) {
    return _c('a', {
      key: index,
      class: ['box', item.type],
      attrs: {
        "target": "_blank",
        "href": item.link,
        "data-aos": "fade-up"
      }
    }, [_c('div', {
      staticClass: "image"
    }, [_c('div', {
      staticClass: "img",
      style: ({
        backgroundImage: 'url(' + item.img + ')'
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('span', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    })])])
  }), 0)])], 1)], 2), _vm._v(" "), _c('footer-main')], 1)
},staticRenderFns: []}

/***/ }),
/* 292 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "menu bioseco"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "menu-box"
  }, [_c('ul', {
    staticClass: "main-menu"
  }, [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/",
      "exact": ""
    }
  }, [_c('a', [_c('span', {
    on: {
      "click": _vm.menuClicked
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.home')))])])]), _vm._v(" "), _c('router-link', {
    staticClass: "submenu",
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/products"
    }
  }, [_c('a', [_c('span', {
    on: {
      "click": _vm.menuClicked
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.products.title')))])]), _vm._v(" "), _c('ul', [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/products/farms"
    }
  }, [_c('a', [_c('span', {
    on: {
      "click": _vm.menuClicked
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.products.farms')))])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/products/airport"
    }
  }, [_c('a', [_c('span', {
    on: {
      "click": _vm.menuClicked
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.products.airports')))])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/products/area"
    }
  }, [_c('a', [_c('span', {
    on: {
      "click": _vm.menuClicked
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.products.ornithologists')))])])])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/infonews"
    }
  }, [_c('a', [_c('span', {
    on: {
      "click": _vm.menuClicked
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.news')))])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/certificates"
    }
  }, [_c('a', [_c('span', {
    on: {
      "click": _vm.menuClicked
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.certs')))])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/awards"
    }
  }, [_c('a', [_c('span', {
    on: {
      "click": _vm.menuClicked
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.awards')))])])]), _vm._v(" "), _c('router-link', {
    staticClass: "submenu disabled",
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/grants",
      "event": ''
    }
  }, [_c('a', [_c('span', {
    on: {
      "click": _vm.menuClicked
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.grants.title')))])]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/grants/bps"
    }
  }, [_c('a', [_c('span', {
    on: {
      "click": _vm.menuClicked
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.grants.bps')))])])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/grants/afms"
    }
  }, [_c('a', [_c('span', {
    on: {
      "click": _vm.menuClicked
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.grants.afms')))])])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/grants/bridgealfa"
    }
  }, [_c('a', [_c('span', {
    on: {
      "click": _vm.menuClicked
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.grants.ba')))])])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/grants/pmt"
    }
  }, [_c('a', [_c('span', {
    on: {
      "click": _vm.menuClicked
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.grants.pmt')))])])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/grants/eic"
    }
  }, [_c('a', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('menu.grants.eic'))
    },
    on: {
      "click": _vm.menuClicked
    }
  })])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/grants/bps2"
    }
  }, [_c('a', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('menu.grants.bps2'))
    },
    on: {
      "click": _vm.menuClicked
    }
  })])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/grants/pbe"
    }
  }, [_c('a', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('menu.grants.pbe'))
    },
    on: {
      "click": _vm.menuClicked
    }
  })])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/grants/pbe2"
    }
  }, [_c('a', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('menu.grants.pbe2'))
    },
    on: {
      "click": _vm.menuClicked
    }
  })])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/grants/ppbb"
    }
  }, [_c('a', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('menu.grants.ppbb'))
    },
    on: {
      "click": _vm.menuClicked
    }
  })])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/grants/offshore"
    }
  }, [_c('a', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('menu.grants.offshore'))
    },
    on: {
      "click": _vm.menuClicked
    }
  })])])], 1)])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/about"
    }
  }, [_c('a', [_c('span', {
    on: {
      "click": _vm.menuClicked
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.about')))])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/contact"
    }
  }, [_c('a', [_c('span', {
    on: {
      "click": _vm.menuClicked
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.contact')))])])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.showModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.ask')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "menu-box"
  }, [_c('ul', {
    staticClass: "lang-menu"
  }, [_c('li', {
    class: {
      'active': _vm.lang === 'en'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setLang('en')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.english')))])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.lang === 'pl'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setLang('pl')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.polish')))])])]), _vm._v(" "), _c('a', {
    staticClass: "fb-icon",
    attrs: {
      "href": "https://www.facebook.com/Bioseco-497515667013273/",
      "target": "_blank"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "linked-icon",
    attrs: {
      "href": "https://pl.linkedin.com/company/bioseco/",
      "target": "_blank"
    }
  })])])])])])
},staticRenderFns: []}

/***/ }),
/* 293 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product bps",
    class: {
      contrasted: _vm.isPageContrasted, fontBigger: _vm.isFontBigger
    }
  }, [_c('header', {
    staticClass: "page-header",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.lang === 'pl') ? _c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Kompleksowa ochrona ptaków wokół morskich farm wiatrowych")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Comprehensive protection of birds around offshore wind farms")]) : _vm._e(), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-left",
      "data-aos-delay": "150"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "why-us-solution",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "elements"
  }, [_c('div', {
    staticClass: "element bps clearfix"
  }, [_c('div', {
    staticClass: "text-box"
  }, [(_vm.lang === 'pl') ? _c('ul', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('ul', [_vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9)]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                Bioseco Spółka Akcyjna realizuje projekt z udziałem wsparcia UE pod tytułem:\n                „Kompleksowa ochrona ptaków wokół morskich farm wiatrowych - implementacja sztucznej inteligencji w rozproszonej sieci sensorów”.\n                "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                  Celem modułu B+R jest realizacja prac badawczych, nad pierwszym w Polsce systemem ochrony awifauny na morskich farmach wiatrowych opartym na rozproszonej sieci sensorów, połączonych oprogramowaniem opartym na algorytmach sztucznej inteligencji. Badania umożliwia opracowanie prototypu rozwiązania – urządzenia do detekcji ptaków w ekstremalnie trudnych warunkach morskich, zapobiegających kolizjom elektrowni z ptakami. \n                  Efektem prac będzie system ochrony ptaków: Offshore Bird Protection System.\n                  Grupą docelowe rozwiązania są inwestorzy i operatorzy farm wiatrowych na morzu.\n                  "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                  Efekty projektu będą komercjalizowane poprzez uczestnictwo w targach na rynkach zagranicznych, w ramach modułu Internacjonalizacja.\n                  "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                  Projekt współfinansowany jest z Europejskiego Funduszu Rozwoju Regionalnego w ramach programu: Fundusze Europejskie dla Nowoczesnej Gospodarki, "), _c('br'), _vm._v("\n                  Priorytet 1: „Wsparcie dla przedsiębiorców”"), _c('br'), _vm._v("\n                  Działanie: Ścieżka SMART"), _c('br'), _vm._v("\n                  Umowa o dofinansowanie nr FENG.01.01-IP.02-0673/24\n                  "), _c('br'), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "text"
  }, [_c('br'), _vm._v("\n                Wartość projektu:"), _c('br'), _vm._v("\n                21 537 216,50 zł\n                "), _c('br'), _c('br'), _vm._v("\n                Dofinansowanie projektu ze środków UE:"), _c('br'), _vm._v("\n                14 333 627,00 zł\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                Bioseco Spółka Akcyjna is implementing a project with the support of the European Union entitled:\n                “Comprehensive protection of birds around offshore wind farms – implementation of artificial intelligence in a distributed sensor network.”\n                "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                The objective of the R&D module is to carry out research work on the first system in Poland for the protection of avifauna at offshore wind farms, based on a distributed network of sensors integrated with software using artificial intelligence algorithms. The research will enable the development of a prototype solution - a device for detecting birds in extremely challenging offshore conditions, aimed at preventing collisions between wind turbines and birds.\n                The outcome of the work will be a bird protection system: Offshore Bird Protection System.\n                The target group for the solution consists of investors and operators of offshore wind farms\n                  "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                The project results will be commercialized through participation in international trade fairs as part of the Internationalization module.\n                  "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                The project is co-financed by the European Regional Development Fund under the programme: European Funds for Smart Economy,"), _c('br'), _vm._v("\n                Priority 1: „Support for entrepreneurs”"), _c('br'), _vm._v("\n                Measure: SMART Path"), _c('br'), _vm._v("\n                Grant agreement no. FENG.01.01-IP.02-0673/24\n                  "), _c('br'), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "text"
  }, [_c('br'), _vm._v("\n                Project value:"), _c('br'), _vm._v("\n                PLN 21 537 216,50\n                "), _c('br'), _c('br'), _vm._v("\n                EU funding for the project:"), _c('br'), _vm._v("\n                PLN 14,333,627.00\n              ")])])
}]}

/***/ }),
/* 294 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "main-footer"
  }, [_c('div', {
    staticClass: "content clearfix"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v(" Copyright " + _vm._s(_vm.year) + " "), _c('strong', [_vm._v(" Bioseco S.A.")])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v(_vm._s(_vm.$t('footer.about')))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v(_vm._s(_vm.$t('footer.contact')))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/privacy-policy"
    }
  }, [_vm._v(_vm._s(_vm.$t('footer.privacy')))])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('footer.created')))]), _vm._v(" "), _vm._m(2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "fb-icon",
    attrs: {
      "href": "https://www.facebook.com/Bioseco-497515667013273/",
      "target": "_blank"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "linked-icon",
    attrs: {
      "href": "https://pl.linkedin.com/company/bioseco/",
      "target": "_blank"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": "/static/img/soppo-logo.svg",
      "alt": "soppo-logo"
    }
  })])
}]}

/***/ }),
/* 295 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "show"
    }
  }, [_c('header', {
    staticClass: "main-header",
    class: {
      contrasted: _vm.isPageContrasted, orange: _vm.isDecember
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "left-container"
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": "/"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeModal($event)
      }
    }
  }, [(_vm.isHomePage) ? _c('img', {
    class: {
      'logo-wide': _vm.isDecember
    },
    attrs: {
      "src": _vm.logoSrc,
      "alt": "logo",
      "data-scroll-offset": "0"
    },
    on: {
      "click": _vm.smoothScroll
    }
  }) : _c('img', {
    class: {
      'logo-wide': _vm.isDecember
    },
    attrs: {
      "src": _vm.logoSrc,
      "alt": "logo"
    }
  }), _vm._v(" "), (!_vm.isDecember) ? _c('div', {
    staticClass: "subtitle",
    class: {
      'hidden': _vm.route === 'home'
    }
  }, [_c('span', [_c('img', {
    attrs: {
      "src": "/static/img/subtitle.svg",
      "alt": "logo"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.isBlogPage) ? _c('div', {
    staticClass: "text"
  }, [_vm._v("blog")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "logos"
  }, [(_vm.lang === 'pl') ? _c('img', {
    staticClass: "header-logos",
    attrs: {
      "src": "/static/img/logo-header-pl.png",
      "alt": "FE"
    }
  }) : _c('img', {
    staticClass: "header-logos",
    attrs: {
      "src": "/static/img/logo-header.png",
      "alt": "FE"
    }
  })])], 1), _vm._v(" "), (_vm.isAccessibilityVisible) ? _c('div', {
    staticClass: "size-icon",
    on: {
      "click": _vm.sizeToggle
    }
  }, [(!_vm.isPageContrasted) ? _c('img', {
    attrs: {
      "src": "/static/img/zoom-in-icon.svg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPageContrasted) ? _c('img', {
    attrs: {
      "src": "/static/img/zoom-in-icon-yellow.svg"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isAccessibilityVisible) ? _c('div', {
    staticClass: "eye-icon",
    on: {
      "click": _vm.contrastToggle
    }
  }, [(!_vm.isPageContrasted) ? _c('img', {
    attrs: {
      "src": "/static/img/eye-icon.svg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPageContrasted) ? _c('img', {
    attrs: {
      "src": "/static/img/eye-icon-yellow.svg"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "burger",
    class: {
      close: _vm.isMenuOpen
    },
    on: {
      "click": _vm.menuToggle
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])])])])
},staticRenderFns: []}

/***/ }),
/* 296 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product bps",
    class: {
      contrasted: _vm.isPageContrasted, fontBigger: _vm.isFontBigger
    }
  }, [_c('header', {
    staticClass: "page-header",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.lang === 'pl') ? _c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Grant PBE - Pomorski Broker Eksportowy")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Project PBE Grant - Pomorski Broker\n          Eksportowy\n        ")]) : _vm._e(), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-left",
      "data-aos-delay": "150"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "why-us-solution",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "elements"
  }, [_c('div', {
    staticClass: "element bps clearfix"
  }, [_c('div', {
    staticClass: "text-box"
  }, [(_vm.lang === 'pl') ? _c('ul', [_vm._m(0), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('ul', [_vm._m(2), _vm._v(" "), _vm._m(3)]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n           Grant PBE (\"Pomorski Broker Eksportowy\") ma na celu promocję Bioseco, jako wystawcy, w 4 międzynarodowych targach i wystawach do 31.03.2023 r. Udział w renomowanych międzynarodowych imprezach wystawienniczych przyczyni się do zmiany modelu biznesowego Bioseco SA, a w konsekwencji przełoży się na wzrost eksportu innowacyjnych systemów detekcji wizyjnej\n"), _c('br'), _c('br'), _vm._v("\nCelem zrealizowanego projektu była promocja firmy Bioseco, jako wystawcy, w 4 międzynarodowych targach i wystawach w terminie do 31.03.2023 roku. Przedstawiciele spółki wzięli udział w 6 wydarzeniach wystawienniczych.\nRealizacja projektu pozwoliła na zaprezentowanie oferty produktowej Bioseco w ważnych z punktu widzenia ekspansji wydarzeniach. Przedstawiciele spółki zaprezentowali nie tylko marketingowe aspekty rozwiązania, ale także podjęli wysiłek eksperckiego potwierdzenia skuteczności oferowanych rozwiązań.\nZrealizowane działania były zgodne z polityką internacjonalizacji Bioseco, poprzez efektywne połączenie działalności promocyjnej z elementem budowania pozycji eksperta branżowego, wspieranym przez udział przedstawicieli firmy w panelach dyskusyjnych i prezentacjach.\n"), _c('br'), _c('br'), _vm._v("\nProjekt Grant PBE (\"Pomorski Broker Eksportowy\") jest współfinansowany z Unii Europejskiej. "), _c('br'), _vm._v("Numer umowy: UDG-PBE.06.2022/051\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("\n                  Kwota dofinansowania z UE:"), _c('br'), _vm._v("\n                  80 000.00PLN 49,14%\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n              Project PBE Grant („Pomorski Broker Eksportowy”) aims to promote Bioseco, as an exhibitor, in 4 international fairs and exhibitions until 31.03.2023. Participation in renowned international exhibition events will contribute to a change in the business model of Bioseco SA and, as a result, will translate into increased exports of innovative vision detection systems\n"), _c('br'), _c('br'), _vm._v("\nThe aim of the project was to promote Bioseco, as an exhibitor, in 4 international fairs and exhibitions by 31.03.2023. Delegates of the company participated in 6 exhibition events.\nThe implementation of the project enabled the Bioseco’s portfolio to be presented at key wind industry events. Representatives of the company presented not only the marketing aspects of the solution, but also made an effort to expertly confirm the effectiveness of the BPS.\nThe realized activities were in line with Bioseco's internationalization policy, by effectively combining promotional activities with the element of building the position of an industry expert, supported by the participation of company representatives in discussions and presentations.\n"), _c('br'), _c('br'), _c('br'), _vm._v("Project PBE Grant („Pomorski Broker Eksportowy”) is co-financed from the European Union.\n                  "), _c('br'), _vm._v("Agreement number: UDG-PBE.06.2022/051\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("\n                  Amount of founding from UE:"), _c('br'), _vm._v("\n                  80 000.00PLN  49,14%\n                ")])])
}]}

/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slides clearfix"
  }, [_c('div', {
    staticClass: "page-shadow"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('areaProducts.headerTopTextPresentation')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('areaProducts.headerTopSubTextPresentation')))])]), _vm._v(" "), _c('div', {
    staticClass: "right-box",
    class: {
      'show': _vm.showText
    }
  }, [_c('div', {
    staticClass: "vertical-middle"
  }, [_c('div', {
    staticClass: "right-box-content"
  }, [_c('div', {
    staticClass: "number",
    class: 'current-' + _vm.currentStep,
    attrs: {
      "id": "bigNumber"
    }
  }, [_c('div', {
    staticClass: "numbers"
  }, _vm._l((_vm.steps.length), function(i) {
    return _c('span', [_vm._v(_vm._s(i))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "text-content"
  }, [_c('h3', [_vm._v(_vm._s(_vm.steps[_vm.currentStep !== 0 ? _vm.currentStep - 1 : _vm.currentStep].title))]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "content"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.steps[_vm.currentStep !== 0 ? _vm.currentStep - 1 : _vm.currentStep].text)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-hover"
  }, [_c('a', {
    staticClass: "btn orange next-step",
    class: {
      'visible': _vm.currentStep !== _vm.steps.length
    },
    attrs: {
      "id": "playButton"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v(_vm._s(_vm.$t('steps.next'))), _c('span')])]), _vm._v(" "), _c('div', {
    staticClass: "last-step",
    class: {
      'visible': _vm.currentStep === _vm.steps.length
    }
  }, [_c('div', {
    staticClass: "btn-hover"
  }, [_c('div', {
    staticClass: "btn orange",
    on: {
      "click": _vm.showModal
    }
  }, [_vm._v(_vm._s(_vm.$t('steps.ask')))])]), _vm._v(" "), _c('div', {
    staticClass: "btn-hover"
  }, [_c('router-link', {
    staticClass: "btn red-border",
    attrs: {
      "to": "/products/area"
    }
  }, [_vm._v(_vm._s(_vm.$t('steps.learnMore'))), _c('span')])], 1)])])])])]), _vm._v(" "), _c('FooterOrange')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-modal"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.hideModal()
      }
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('questionModal.haveQuestion')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('questionModal.completeForm')))]), _vm._v(" "), _c('div', {
    staticClass: "inputs"
  }, [_c('div', {
    staticClass: "input",
    class: {
      error: _vm.nameError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "name",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('questionModal.name')
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "input",
    class: {
      error: _vm.emailError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "email",
    attrs: {
      "type": "email",
      "placeholder": _vm.$t('questionModal.email')
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('label', {
    staticClass: "select-box",
    class: {
      error: _vm.questionError
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.question),
      expression: "question"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.question = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('questionModal.queryTopicText')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "farms"
    }
  }, [_vm._v(_vm._s(_vm.$t('questionModal.queryTopic.questionOne')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "airport"
    }
  }, [_vm._v(_vm._s(_vm.$t('questionModal.queryTopic.questionTwo')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "area"
    }
  }, [_vm._v(_vm._s(_vm.$t('questionModal.queryTopic.questionThree')))]), _vm._v(" "), _c('option', [_vm._v(_vm._s(_vm.$t('questionModal.queryTopic.questionFour')))]), _vm._v(" "), _c('option', [_vm._v(_vm._s(_vm.$t('questionModal.queryTopic.questionFive')))])])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    class: {
      error: _vm.contentError
    },
    attrs: {
      "placeholder": _vm.$t('questionModal.content')
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "rodo"
  }, [_vm._v(_vm._s(_vm.$t('questionModal.rodo'))), _c('router-link', {
    attrs: {
      "to": "/privacy-policy"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.hideModal($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('questionModal.rodoLink')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [(_vm.error) ? _c('div', {
    staticClass: "alert"
  }, [_vm._m(2), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('questionModal.errorMsg')))])]) : _vm._e(), _vm._v(" "), (_vm.sendError) ? _c('div', {
    staticClass: "alert"
  }, [_vm._m(3), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('questionModal.errorSendMsg')))])]) : _vm._e(), _vm._v(" "), (_vm.sendComplete) ? _c('div', {
    staticClass: "alert done"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('questionModal.sendMsg')))])]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "button btn orange",
    on: {
      "click": function($event) {
        _vm.sendForm()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('questionModal.send')) + " "), _c('span')])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hexagon-error"
  }, [_c('span', [_vm._v("!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hexagon-error"
  }, [_c('span', [_vm._v("!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hexagon-error"
  }, [_c('span', [_vm._v("!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hexagon-error"
  }, [_c('span', [_vm._v("!")])])
}]}

/***/ }),
/* 299 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product pmt",
    class: {
      contrasted: _vm.isPageContrasted, fontBigger: _vm.isFontBigger
    }
  }, [_c('header', {
    staticClass: "page-header",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.lang === 'pl') ? _c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Polskie Mosty Technologiczne USA")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Polish Technology Bridge to USA")]) : _vm._e(), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-left",
      "data-aos-delay": "150"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "why-us-solution",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "elements"
  }, [_c('div', {
    staticClass: "element bps clearfix"
  }, [_c('div', {
    staticClass: "text-box"
  }, [(_vm.lang === 'pl') ? _c('ul', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('ul', [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n           Projekt Polskie Mosty Technologiczne ma na celu wspieranie polskich firm w procesie internacjonalizacji. Projekt organizowany jest przez Polską Agencję Inwestycji i Handlu.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\nCelem projektu jest ekspansja na rynek amerykański. Trzeba pamiętać, że USA jest wiodącym krajem, jeśli chodzi o energetykę wiatrową. W ramach etapu krajowego tego projektu wypracowaliśmy strategię ekspansji, którą będziemy konsekwentnie wdrażać w etapie zagranicznym, trwającym do sierpnia 2021. Celem projektu Bioseco jest wybór najatrakcyjniejszego lokalnego rynku na terenie Stanów Zjednoczonych i rozpoznanie wymogów regulacyjnych pozwalających na sprzedaż Bird Protection System. W konsekwencji naszym nadrzędnym celem jest nawiązanie współpracy handlowej z podmiotami w USA.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\nProjekt Polskie Mosty Technologiczne współfinansowany jest z Europejskiego Funduszu Rozwoju Regionalnego w ramach III Osi priorytetowej - Wsparcie innowacji w przedsiębiorstwach; Działanie: 3.3. Wsparcie promocji oraz internacjonalizacji innowacyjnych przedsiębiorstw, Programu Operacyjnego Inteligentny Rozwój 2014-2020. Nr umowy: POIR-03.03.01-00-0001/17-00.\n                "), _c('br'), _c('br'), _vm._v("\n                  Dofinansowanie projektu przez PAIH:"), _c('br'), _vm._v("200.000,00 PLN\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n             Project PMT („Polskie Mosty Technologiczne”) aims to support Polish companies in the process of internationalization. The project is organized by the Polish Investment and Trade Agency.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                  The aim of the project is expansion to the American market. The USA is the leading country in wind energy. As part of the first stage, we have developed an expansion strategy, which we will consistently implement in the second stage, lasting until August 2021. During the project Bioseco aims to select the most attractive market in the United States and to identify regulatory requirements allowing the sale of the Bird Protection System. Consequently, our main goal is to establish commercial cooperation with entities in the USA.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\nThe project PMT (Polskie Mosty Technologiczne) is co-financed from the European Regional Development Fund, under the Priority 3 - Support for innovation in enterprises; Measure: 3.3. Support for the promotion and internationalization of innovative enterprises, the Intelligent Development Operational Program 2014-2020. Agreement number: POIR-03.03.01-00-0001/17-00.\n               "), _c('br'), _c('br'), _vm._v("\n                  Amount of founding from UE:"), _c('br'), _vm._v("\n200.000.00 PLN\n                ")])])
}]}

/***/ }),
/* 300 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product ba",
    class: {
      contrasted: _vm.isPageContrasted, fontBigger: _vm.isFontBigger
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "why-us-solution",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "elements"
  }, [_c('div', {
    staticClass: "element bps clearfix"
  }, [_c('div', {
    staticClass: "text-box"
  }, [(_vm.lang === 'pl') ? _c('ul', [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('ul', [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "page-header",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Bridge Alfa")]), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-left",
      "data-aos-delay": "150"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n             W kwietniu 2016 LSI Fund stało się znaczącym udziałowcem Bioseco. Pieniądze, za które Fundusz objął udziały w 80% pochodziły ze wsparcia NCBIR. Te pieniądze pozwoliły Bioseco rozwinąć stereoskopową technologię wizyjną i zaprojektować pierwsze wersje prototypów urządzenia przeznaczonego dla operatorów farm wiatrowych oraz lotnisk. Urządzenia w wersji MVP zostały potem zaimplementowane u pierwszych branżowych klientów Bioseco. Niewątpliwym sukcesem tego etapu działalności Bioseco był fakt, że po zainstalowaniu urządzeń śmiertelność ptaków pod turbinami spadła do zera.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                W okresie 04.2016-05.2019 Bioseco S.A. realizowała projekt pod tytułem „Bioseco” w ramach Programu Operacyjnego Inteligentny Rozwój 2014-2020, Priorytet 1, Działanie 1.3,\nPoddziałanie 1.3.1 – Wsparcie Projektów Badawczo-Rozwojowych w fazie preseed przez fundusze typu Proof of Concept – Bridge Alfa.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                  Cel projektu:"), _c('br'), _vm._v("\nCelem Projektu było zaprojektowanie, wytworzenie oraz wdrożenie na rynek innowacyjnego urządzenia wspomagającego rozwój inwestycji energetycznych i lotniskowych oraz procesy prowadzenia badań środowiskowych.\n "), _c('br'), _c('br'), _c('br'), _vm._v("\n                Wartosć projektu:"), _c('br'), _vm._v("\n                3 000 000,00PLN\n                  "), _c('br'), _c('br'), _vm._v("\n                  Dofinansowanie projektu z UE:"), _c('br'), _vm._v("\n                2 400 000.00PLN\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n               In April 2016, LSI Fund became a significant shareholder in Bioseco. 80% of the money for which the Fund acquired shares came from the NCBIR support. These funds have allowed Bioseco to develop stereoscopic vision technology and to design the first versions of device prototypes for wind farm and airports. The devices in the MVP version were later implemented at the first customers of Bioseco. The undoubted success of this stage of Bioseco's activity was the fact that after installing the devices, the mortality of birds where the system was operating dropped to zero.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                04.2016-05.2019 Bioseco SP. z o.o. realized project called “Bioseco” within the Operational Programme Smart Growth 2014-2020, Priority 1, Measure 1.3.,\nSub- measure 1.3.1 - Support for R&D projects at the ‘pre-seed’ stage by proof of concept funds – Bridge Alfa\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n               The aim of the Project was to design, manufacture and implement to the market an innovative tool supporting the development of energy and airport investments and the processes of conducting the environmental assessment.\n                "), _c('br'), _c('br'), _c('br'), _vm._v("\n                Project value:"), _c('br'), _vm._v("\n                3 000 000,00PLN\n                  "), _c('br'), _c('br'), _vm._v("\n                 Amount of founding from UE:"), _c('br'), _vm._v("\n                2 400 000.00PLN\n                ")])])
}]}

/***/ }),
/* 301 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-modal"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.hideModal()
      }
    }
  }), _vm._v(" "), _c('iframe', {
    attrs: {
      "src": 'https://www.youtube.com/embed/' + _vm.$store.state.videoModalSrc,
      "frameborder": "0",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": ""
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 302 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blog"
  }, [_vm._m(0), _vm._v(" "), _c('footer-main')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper container clearfix"
  }, [_c('div', {
    staticClass: "posts"
  }, [_c('div', {
    staticClass: "post"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "background-image": "url('static/img/blog/post.jpg')"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("Excepteur sint occaecat cupidatat non proident")]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("02.05.2017")])])]), _vm._v(" "), _c('div', {
    staticClass: "post-text"
  }, [_c('p', [_vm._v("Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam\n            rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt\n            explicabo. Nemo enim ipsam\n            voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui\n            ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet,\n            consectetur, adipisci velit,\n            sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut\n            enim ad minima veniam, quis nostrum ")]), _vm._v(" "), _c('div', {
    staticClass: "read-more"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Czytaj więcej")])])])]), _vm._v(" "), _c('div', {
    staticClass: "post"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "background-image": "url('static/img/blog/post.jpg')"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("At vero eos et accusamus et iusto")]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("02.05.2017")])])]), _vm._v(" "), _c('div', {
    staticClass: "post-text"
  }, [_c('p', [_vm._v("Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam\n            rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt\n            explicabo. Nemo enim ipsam\n            voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui\n            ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet,\n            consectetur, adipisci velit,\n            sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut\n            enim ad minima veniam, quis nostrum ")]), _vm._v(" "), _c('div', {
    staticClass: "read-more"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Czytaj więcej")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "other-posts"
  }, [_c('div', {
    staticClass: "top-text"
  }, [_vm._v("Pozostałe wpisy")]), _vm._v(" "), _c('ul', [_c('li', [_c('div', {
    staticClass: "dot"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("25.01.2017")]), _vm._v(" "), _c('p', [_vm._v("Nam libero tempore, cum soluta nobis.")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "dot"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("25.01.2017")]), _vm._v(" "), _c('p', [_vm._v("Nam libero tempore, cum soluta nobis.")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "dot"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("25.01.2017")]), _vm._v(" "), _c('p', [_vm._v("Nam libero tempore, cum soluta nobis.")])])])])])])
}]}

/***/ }),
/* 303 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-us",
    attrs: {
      "id": "aboutUs"
    }
  }, [_c('header', {
    staticClass: "page-header",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('about.hedingTopText'))
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('about.hedingSubText'))
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "line",
    attrs: {
      "data-aos": "fade-up"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('about.headingText'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-hover",
    on: {
      "click": function($event) {
        _vm.openVideoModal('presentation')
      }
    }
  }, [_c('div', {
    staticClass: "btn orange",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_vm._v(_vm._s(_vm.$t('component.watchPromoVideo'))), _c('span')])])]), _vm._v(" "), _c('a', {
    staticClass: "more-about-us white",
    attrs: {
      "href": "#top",
      "data-scroll-offset": _vm.scrollOffset,
      "data-aos": "fade-up"
    },
    on: {
      "click": _vm.smoothScroll
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('component.moreAboutUs')))])])]), _vm._v(" "), _c('div', {
    staticClass: "heading clearfix",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "description"
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('about.headSectionTopText'))
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('about.headSectionText'))
    }
  })]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "certs",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "heading-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('about.ourCertsTitle'))
    }
  })]), _vm._v(" "), _c('certs')], 1), _vm._v(" "), _c('div', {
    staticClass: "our-team orange-bg"
  }, [_c('div', {
    staticClass: "top-text"
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('about.ourTeamTitle'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "description",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('about.ourTeamText'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, _vm._l((_vm.team), function(member) {
    return _c('div', {
      key: member.img,
      staticClass: "team-box"
    }, [_c('img', {
      attrs: {
        "src": 'static/img/team/' + member.img + '?2',
        "alt": member.name,
        "data-aos": "fade-up",
        "data-aos-delay": "100"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text",
      attrs: {
        "data-aos": "fade-up",
        "data-aos-delay": "200"
      }
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(member.name))]), _vm._v(" "), _c('div', {
      staticClass: "role"
    }, [_vm._v(_vm._s(member.role))])])])
  }), 0)]), _vm._v(" "), _c('clients'), _vm._v(" "), _c('media-box'), _vm._v(" "), _c('footer-more-information', {
    attrs: {
      "modalpage": ''
    }
  }), _vm._v(" "), _c('footer-main')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-container"
  }, [_c('video', {
    staticClass: "header-video",
    attrs: {
      "src": "static/img/about-us/falcon.mp4",
      "autoplay": "",
      "loop": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image"
  }, [_c('figure', {
    staticClass: "hexagon-image",
    staticStyle: {
      "background-image": "url('static/img/about-us/why-us.jpg')"
    },
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('div', {
    staticClass: "hexTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "hexBottom"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "divider",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "line-horizontal-start"
  }), _vm._v(" "), _c('div', {
    staticClass: "line-diagonal"
  }), _vm._v(" "), _c('div', {
    staticClass: "line-horizontal-end"
  })])
}]}

/***/ }),
/* 304 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product bps",
    class: {
      contrasted: _vm.isPageContrasted, fontBigger: _vm.isFontBigger
    }
  }, [_c('header', {
    staticClass: "page-header",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.lang === 'pl') ? _c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Bird Protection System - przełomowa technologia ochrony ptaków na farmach wiatrowych, pozwalająca na zrównoważony rozwój energetyki ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Bird Protection System - a disruptive technology for bird protection at wind farms, allowing for sustainable wind and power development")]) : _vm._e(), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-left",
      "data-aos-delay": "150"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-hover"
  }, [_c('router-link', {
    staticClass: "btn orange",
    attrs: {
      "to": "/products/farms/presentation",
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('component.watchPresentation'))), _c('span')])], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-hover",
    on: {
      "click": function($event) {
        _vm.$modal.show('video-static')
      }
    }
  }, [_c('div', {
    staticClass: "btn orange",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_vm._v(_vm._s(_vm.$t('component.watchVideo'))), _c('span')])])])]), _vm._v(" "), _c('div', {
    staticClass: "why-us-solution",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "elements"
  }, [_c('div', {
    staticClass: "element bps clearfix"
  }, [_c('div', {
    staticClass: "text-box"
  }, [(_vm.lang === 'pl') ? _c('ul', [_vm._m(0), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('ul', [_vm._m(2), _vm._v(" "), _vm._m(3)]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n              Celem projektu jest opracowanie w pełni dostosowanego do potrzeb rynku rozwiązania do wykrywania  i odstraszania ptaków w okolicy farm wiatrowych.  Ze względu na wysokie ryzyko kolizji z ptakami, niektóre z istniejących farm są zmuszone do wyłączenia turbin. Opracowaliśmy pierwotną wersję systemu do wykrywania ptaków i wprowadzania odpowiedniej reakcji, która sprawdziła się w działaniu. Obecnie w pełni rozumiemy problemy dotyczące awifauny na farmach wiatrowych i pragniemy opracować w pełni automatyczne i bardzo precyzyjne rozwiązanie, które w znacznym stopniu ograniczy liczbę kolizji, a także straty właścicieli turbin. Opracowane w ramach projektu rozwiązanie będzie charakteryzować się:\n            "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" 1.  Zwiększoną dokładnością klasyfikacji obiektów oraz minimalną liczbą fałszywych detekcji. W tym celu zastosujemy samouczące się algorytmy bazujące na sztucznej inteligencji oraz paradygmacie Big Data w rozproszonym systemie IoT.\n                  "), _c('br'), _vm._v(" 2. Wysoką niezawodnością systemu. Nowa metoda autodiagnostyki i in-situ auto-kalibracji umożliwi na skrócenie czasu instalacji oraz ich długą żywotność.\n                  "), _c('br'), _vm._v(" 3. Otwartą elastyczną architekturą systemu, która pozwoli na łatwe skalowanie produktu i jego kastomizację.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("\n                Wartosć projektu:"), _c('br'), _vm._v("\n                3 866 129,08PLN\n                  "), _c('br'), _c('br'), _vm._v("\n                  Dofinansowanie projektu z UE:"), _c('br'), _vm._v("\n                2 890 434.62PLN\n                  "), _c('br'), _c('br'), _vm._v("\n                  Okres realizacji: 01.09.2021 – 31.08.2023\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                The aim of the project is to develop solutions to meet the needs of the bird advisory and deterrent market in the vicinity of wind farms. We have noticed that wind farms development poses a threat to local environment, especially avifauna. Even some of the existing power plants have been obliged to shut down turbines due to the high risk of collision with birds. We developed the initial detection and deterrence system that has been proved to be of high value. Currently, we fully understand the problems regarding avifauna on wind farms and wish to develop a fully automatic and very precise solution that will largely reduce the number of collisions, as well as wind farm owners’ losses.\nIn this project our goal is to develop a market-tailored bird protection solution that will be characterised by:\n                "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" 1.  Improved object classification accuracy, which will reduce the number of false positive detections. We will implement\na self-adapting artificial intelligence algorithms and methods based on paradigm of big data in a large-scale IoT distributed\nsystem.\n                  "), _c('br'), _vm._v(" 2. Low acquisition system uncertainty, which also affects robustness. A regular in situ auto-calibration method is crucial\nto ensure high system efficiency and long product lifetime.\n                  "), _c('br'), _vm._v(" 3. An open flexible architecture of the system that can be adapted to particular customer’s requirements.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("\n                Project value:"), _c('br'), _vm._v("\n                   3 866 129,08PLN\n                  "), _c('br'), _c('br'), _vm._v("\n                 Amount of founding from UE:"), _c('br'), _vm._v("\n                2 890 434.62PLN\n                  "), _c('br'), _c('br'), _vm._v("\n                  Period of implementation: 01.09.2021 – 31.08.2023\n                ")])])
}]}

/***/ }),
/* 305 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product"
  }, [_c('header', {
    staticClass: "page-header",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('airportProducts.headerTopText'))
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.headerTopSubText')))]), _vm._v(" "), _c('span', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-left",
      "data-aos-delay": "150"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('airportProducts.headerText'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-hover"
  }, [_c('router-link', {
    staticClass: "btn orange",
    attrs: {
      "to": "/products/airport/presentation",
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('component.watchPresentation'))), _c('span')])], 1)]), _vm._v(" "), _c('a', {
    staticClass: "more-about-us white",
    attrs: {
      "data-scroll-offset": "120",
      "href": "#top",
      "data-aos": "fade-up",
      "data-aos-delay": "300"
    },
    on: {
      "click": _vm.smoothScroll
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('component.moreAboutUs')))])])]), _vm._v(" "), _c('div', {
    staticClass: "why-us-solution",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "top-text"
  }, [_c('p', {
    attrs: {
      "data-aos": "fade-up"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('airportProducts.whyOurSolutionText'))
    }
  }), _vm._v(" "), _c('h2', {
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.whyOurSolution')))])]), _vm._v(" "), _c('div', {
    staticClass: "elements"
  }, [_c('div', {
    staticClass: "element right clearfix"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionOneTitle')))])]), _vm._v(" "), _c('ul', [_c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionOneText1')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionOneText2')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "300"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionOneText3')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "350"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionOneText4')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "400"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionOneText5')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "element left clearfix"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._m(3), _vm._v(" "), _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionTwoTitle')))])]), _vm._v(" "), _c('ul', [_c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionTwoText1')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionTwoText2')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "300"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionTwoText3')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "350"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionTwoText4')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "400"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionTwoText5')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "450"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionTwoText6')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "500"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionTwoText7')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "550"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionTwoText8')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "600"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionTwoText9')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "element right clearfix"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._m(5), _vm._v(" "), _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionThreeTitle')))])]), _vm._v(" "), _c('ul', [_c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionThreeText1')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionThreeText2')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "300"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionThreeText3')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "350"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionThreeText4')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "400"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.sectionThreeText5')))])])])])])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "bottom-last"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h2', {
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(_vm._s(_vm.$t('airportProducts.whyIShouldUseThis')))]), _vm._v(" "), _c('div', {
    staticClass: "elements"
  }, [_c('div', {
    staticClass: "element"
  }, [_c('Counter', {
    attrs: {
      "data": _vm.circleValues[0]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "150"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('airportProducts.whyIShouldUseThisOneText')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "element"
  }, [_c('Counter', {
    attrs: {
      "data": _vm.circleValues[1]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('airportProducts.whyIShouldUseThisTwoText')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "element"
  }, [_c('Counter', {
    attrs: {
      "data": _vm.circleValues[2]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "350"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('airportProducts.whyIShouldUseThisThreeText')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "element"
  }, [_c('Counter', {
    attrs: {
      "data": _vm.circleValues[3]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "450"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('airportProducts.whyIShouldUseThisFourText')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "btn-hover"
  }, [_c('router-link', {
    staticClass: "btn orange",
    attrs: {
      "to": "/products/airport/presentation",
      "data-aos": "fade-up"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('component.watchPresentation'))), _c('span')])], 1)])]), _vm._v(" "), _c('footer-more-information', {
    attrs: {
      "modalpage": 'airport'
    }
  }), _vm._v(" "), _c('footer-main')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image",
    attrs: {
      "data-aos": "flip-left"
    }
  }, [_c('figure', {
    staticClass: "hexagon-image resizable",
    staticStyle: {
      "background-image": "url('/static/img/product/image1-airport.jpg')"
    }
  }, [_c('div', {
    staticClass: "hexTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "hexBottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-right"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }, [_c('span', [_vm._v("1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image",
    attrs: {
      "data-aos": "flip-right"
    }
  }, [_c('figure', {
    staticClass: "hexagon-image resizable",
    staticStyle: {
      "background-image": "url('/static/img/product/image2-airport.jpg')"
    }
  }, [_c('div', {
    staticClass: "hexTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "hexBottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-left"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }, [_c('span', [_vm._v("2")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image",
    attrs: {
      "data-aos": "flip-left"
    }
  }, [_c('figure', {
    staticClass: "hexagon-image resizable",
    staticStyle: {
      "background-image": "url('/static/img/product/image3-airport.jpg')"
    }
  }, [_c('div', {
    staticClass: "hexTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "hexBottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-right"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }, [_c('span', [_vm._v("3")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom-first orange-bg"
  }, [_c('div', {
    staticClass: "image-boxes inline-boxes"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "box",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/product/image-box-1.jpg",
      "alt": "team1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "150"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/product/image-box-2-airport.jpg",
      "alt": "team2"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/product/image-box-5.jpg",
      "alt": "team3"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/product/image-box-4-airport.jpg",
      "alt": "team4"
    }
  })])])])])
}]}

/***/ }),
/* 306 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auctions"
  }, [_vm._m(0), _vm._v(" "), _c('footer-main')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper container clearfix"
  }, [_c('div', {
    staticClass: "posts"
  }, [_c('div', {
    staticClass: "post"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("Excepteur sint occaecat cupidatat non proident")]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("02.05.2017")])])]), _vm._v(" "), _c('div', {
    staticClass: "post-text"
  }, [_c('p', [_vm._v("Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam\n            rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt\n            explicabo. Nemo enim ipsam\n            voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui\n            ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet,\n            consectetur, adipisci velit,\n            sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut\n            enim ad minima veniam, quis nostrum ")]), _vm._v(" "), _c('div', {
    staticClass: "read-more"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Czytaj więcej")])])])]), _vm._v(" "), _c('div', {
    staticClass: "post"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("At vero eos et accusamus et iusto")]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("02.05.2017")])])]), _vm._v(" "), _c('div', {
    staticClass: "post-text"
  }, [_c('p', [_vm._v("Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam\n            rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt\n            explicabo. Nemo enim ipsam\n            voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui\n            ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet,\n            consectetur, adipisci velit,\n            sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut\n            enim ad minima veniam, quis nostrum ")]), _vm._v(" "), _c('div', {
    staticClass: "read-more"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Czytaj więcej")])])])]), _vm._v(" "), _c('div', {
    staticClass: "post"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("At vero eos et accusamus et iusto")]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("02.05.2017")])])]), _vm._v(" "), _c('div', {
    staticClass: "post-text"
  }, [_c('p', [_vm._v("Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam\n            rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt\n            explicabo. Nemo enim ipsam\n            voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui\n            ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet,\n            consectetur, adipisci velit,\n            sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut\n            enim ad minima veniam, quis nostrum ")]), _vm._v(" "), _c('div', {
    staticClass: "read-more"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Czytaj więcej")])])])]), _vm._v(" "), _c('div', {
    staticClass: "post"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("At vero eos et accusamus et iusto")]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("02.05.2017")])])]), _vm._v(" "), _c('div', {
    staticClass: "post-text"
  }, [_c('p', [_vm._v("Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam\n            rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt\n            explicabo. Nemo enim ipsam\n            voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui\n            ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet,\n            consectetur, adipisci velit,\n            sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut\n            enim ad minima veniam, quis nostrum ")]), _vm._v(" "), _c('div', {
    staticClass: "read-more"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Czytaj więcej")])])])]), _vm._v(" "), _c('div', {
    staticClass: "post"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("At vero eos et accusamus et iusto")]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("02.05.2017")])])]), _vm._v(" "), _c('div', {
    staticClass: "post-text"
  }, [_c('p', [_vm._v("Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam\n            rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt\n            explicabo. Nemo enim ipsam\n            voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui\n            ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet,\n            consectetur, adipisci velit,\n            sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut\n            enim ad minima veniam, quis nostrum ")]), _vm._v(" "), _c('div', {
    staticClass: "read-more"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Czytaj więcej")])])])]), _vm._v(" "), _c('div', {
    staticClass: "post"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("At vero eos et accusamus et iusto")]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("02.05.2017")])])]), _vm._v(" "), _c('div', {
    staticClass: "post-text"
  }, [_c('p', [_vm._v("Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam\n            rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt\n            explicabo. Nemo enim ipsam\n            voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui\n            ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet,\n            consectetur, adipisci velit,\n            sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut\n            enim ad minima veniam, quis nostrum ")]), _vm._v(" "), _c('div', {
    staticClass: "read-more"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Czytaj więcej")])])])])])])
}]}

/***/ }),
/* 307 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "projects-container"
  }, [_c('div', {
    staticClass: "project-content"
  }, [(_vm.lang !== 'pl') ? _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("\n        Bioseco S.A. realizes the project co-financed by European Funds."), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Project title:")]), _c('br'), _vm._v("\n        Realization of R&D works leading to the implementation of a new solution - MULTIREJESTRATOR PLUS for\n        monitoring and control of the power system in terms of operational efficiency, the life span extending and\n        optimizing the impact on the\n        surrounding wind farms."), _c('br'), _c('br'), _vm._v("\n        Summary:"), _c('br'), _vm._v("\n        The aim of the project is to carry out R&D works leading to the\n        development of a radio and video prototype system that will improve the efficiency and performance of wind\n        turbines, which will affect the growth of innovation in the national electricity sector. The project will be\n        implemented by a qualified project team in 4 research tasks, the aim of which will be to design a complete\n        vision system that allows the prediction of bird traffic near wind farms. The project will end with the\n        creation\n        of technical documentation enabling the implementation of MULTIREJESTRATOR PLUS technology on the market. It\n        is\n        planned to cover the results of R&D works with patent protection on the Polish, British and then European\n        markets."), _c('br'), _vm._v("MULTIREJESTRATOR PLUS will ensure uninterrupted or rarely interrupted work of wind farms, through\n        the active protection of valuable bird species."), _c('br'), _c('br'), _vm._v("Project value:"), _c('br'), _vm._v("4 109 660,41"), _c('br'), _c('br'), _vm._v("Amount of\n        founding\n        from UE:"), _c('br'), _vm._v("3 021 687,62\n      ")]) : _vm._e(), _vm._v(" "), (_vm.lang === 'pl') ? _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("\n        Bioseco S.A. realizuje projekt dofinansowany z Funduszy Europejskich."), _c('br'), _c('br'), _vm._v("\n        Tytuł projektu:"), _c('br'), _vm._v("\n        Realizacja prac B+R, prowadzących do wdrożenia nowego rozwiązania - MULTIREJESTRATOR PLUS dla monitorowania i\n        kontroli systemu elektroenergetycznego pod kątem efektywności eksploatacji, wydłużenia czasu życia i\n        optymalizacji oddziaływania na otoczenie farm wiatrowych.\n        "), _c('br'), _c('br'), _vm._v("\n        Cel projektu:"), _c('br'), _vm._v("\n        Celem projektu jest przeprowadzenie prac B+R prowadzących do opracowania prototypu systemu radiowo wizyjnego,\n        który pozwoli podnieść sprawność i wydajność pracy turbin wiatrowych."), _c('br'), _c('br'), _vm._v("\n        Wartosć projektu: "), _c('br'), _vm._v("4 109 660,41PLN"), _c('br'), _c('br'), _vm._v("\n        Dofinansowanie projektu z UE: "), _c('br'), _vm._v("3 021 687.62PLN"), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "project-content"
  }, [(_vm.lang !== 'pl') ? _c('p', {
    staticClass: "project-desc"
  }, [_c('b', [_vm._v("Project title:")]), _c('br'), _vm._v("\n        Carrying out research and development works necessary to develop a new autonomous AIRPORT FAUNA MONITORING\n        SYSTEM (AFMS) reducing the number of collisions between aircraft and birds and mammals\n        "), _c('br'), _c('br'), _vm._v("\n        Summary:"), _c('br'), _vm._v("\n        The aim of the project is to carry out R&D works enabling the development of a prototype of the new AIRPORT\n        FAUNA MONITORING SYSTEM (AFMS - monitoring system around the airport for the detection of land mammal\n        avifauna).\n        "), _c('br'), _c('br'), _vm._v("\n        Project value: "), _c('br'), _vm._v("3 493 437,50PLN"), _c('br'), _c('br'), _vm._v("\n        Amount of founding from UE: "), _c('br'), _vm._v("2 632 075.00PLN"), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.lang === 'pl') ? _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("\n        Tytuł projektu:"), _c('br'), _vm._v("\n        Przeprowadzenie prac badawczo-rozwojowych niezbędnych do opracowania nowego autonomicznego systemu AIRPORT\n        FAUNA MONITORING SYSTEM (AFMS) redukującego liczbę kolizji statków powietrznych z ptakami i ssakami.\n        "), _c('br'), _c('br'), _vm._v("\n        Cel projektu:"), _c('br'), _vm._v("\n        Celem projektu jest przeprowadzenie prac B+R pozwalających na opracowanie prototypu nowego systemu AIRPORT\n        FAUNA MONITORING SYSTEM (AFMS - system monitoringu okolic portu lotniczego do detekcji awifauny ssaków\n        lądowych)."), _c('br'), _c('br'), _vm._v("\n        Wartość projektu: "), _c('br'), _vm._v("3 493 437,50PLN"), _c('br'), _c('br'), _vm._v("\n        Dofinansowanie projektu z UE: "), _c('br'), _vm._v("2 632 075.00PLN"), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "project-content"
  }, [(_vm.lang !== 'pl') ? _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("\n        04.2016-05.2019 Bioseco SP. z o.o. realized project called “Bioseco” within the Operational Programme Smart Growth 2014-2020, Priority 1, Measure 1.3.,"), _c('br'), _vm._v("\n        Sub- measure 1.3.1 - Support for R&D projects at the ‘pre-seed’ stage by proof of concept funds – Bridge Alfa"), _c('br'), _c('br'), _vm._v("\n        The aim of the Project was to design, manufacture and implement to the market an innovative tool supporting the development of energy and airport investments and the processes of conducting the environmental assessment.\n        "), _c('br'), _c('br'), _vm._v("\n        Project Value : 3.000.000 PLN"), _c('br'), _vm._v("\n        EU cofinancing: 2.400.000 PLN\n      ")]) : _vm._e(), _vm._v(" "), (_vm.lang === 'pl') ? _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("\n        W okresie 04.2016-05.2019 Bioseco S.A. realizowała projekt pod tytułem „Bioseco” w ramach Programu Operacyjnego Inteligentny Rozwój 2014-2020, Priorytet 1, Działanie 1.3,"), _c('br'), _vm._v("\n        Poddziałanie 1.3.1 – Wsparcie Projektów Badawczo-Rozwojowych w fazie preseed  przez fundusze typu Proof of Concept – Bridge Alfa."), _c('br'), _c('br'), _vm._v("\n        Celem Projektu było zaprojektowanie, wytworzenie oraz wdrożenie na rynek innowacyjnego urządzenia wspomagającego rozwój inwestycji energetycznych i lotniskowych oraz procesy prowadzenia badań środowiskowych.\n        "), _c('br'), _c('br'), _vm._v("\n        Wartość projektu: 3.000.000 złotych"), _c('br'), _vm._v("\n        Wartość dofinansowania UE: 2.400.000 złotych\n      ")]) : _vm._e()])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "more-link"
  }, [_c('router-link', {
    staticClass: "more-about-us",
    attrs: {
      "active-class": "active",
      "to": "/about"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('component.moreAboutUs')))])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "poster-holder"
  }, [_c('img', {
    attrs: {
      "src": "static/img/eu-small.png",
      "width": "100%"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-hexagons"
  }, [_c('div', {
    staticClass: "bg-hexagon"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-hexagon"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-hexagon"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-hexagon"
  })])
}]}

/***/ }),
/* 308 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "our-clients",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "title-wrapper"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('about.ourClientsTitle'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "indentation"
  })]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.clients), function(client, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('img', {
      staticClass: "client-logo",
      attrs: {
        "loading": "lazy",
        "src": client.src,
        "alt": client.alt
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "aria-hidden": ""
    }
  }, _vm._l((_vm.clients), function(client, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('img', {
      staticClass: "client-logo",
      attrs: {
        "loading": "lazy",
        "src": client.src,
        "alt": client.alt
      }
    })])
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.isAppLoaded) ? _c('preloader') : _vm._e()], 1), _vm._v(" "), (_vm.isAppLoaded) ? _c('div', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isModalOpen) ? _c('modal') : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isModalVideoOpen) ? _c('video-modal') : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isMenuOpen) ? _c('main-menu') : _vm._e()], 1), _vm._v(" "), _c('video-static-modal', {
    attrs: {
      "videoType": _vm.modalStaticVideoType
    }
  }), _vm._v(" "), _c('main-header'), _vm._v(" "), _c('router-view')], 1) : _vm._e(), _vm._v(" "), _c('canvas-animation'), _vm._v(" "), _c('ScrollTop')], 1)
},staticRenderFns: []}

/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, _vm._l((_vm.certs), function(cert) {
    return _c('div', {
      key: cert.key,
      staticClass: "isoWrapper",
      on: {
        "click": function($event) {
          _vm.openCert(cert)
        }
      }
    }, [_c('img', {
      staticClass: "iso",
      attrs: {
        "src": cert.img,
        "alt": cert.alt
      }
    })])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-us awards",
    attrs: {
      "id": "awards"
    }
  }, [_c('header', {
    staticClass: "page-header",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('privacy.title'))
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "more-about-us white",
    attrs: {
      "href": "#top",
      "data-scroll-offset": _vm.scrollOffset,
      "data-aos": "fade-up"
    },
    on: {
      "click": _vm.smoothScroll
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('privacy.see')))])])]), _vm._v(" "), _c('div', {
    staticClass: "product"
  }, [_c('div', {
    staticClass: "why-us-solution",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "elements"
  }, [_c('div', {
    staticClass: "element clearfix"
  }, [_c('div', [_c('div', [(_vm.lang === 'pl') ? _c('p', {
    staticClass: "header-text"
  }, [_vm._v("\n                BIOSECO Sp. z o.o. - Polityka Prywatności i RODO\n              ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('p', {
    staticClass: "header-text"
  }, [_vm._v("\n                BIOSECO Sp. z o.o. Privacy Policy\n              ")]) : _vm._e(), _vm._v(" "), (_vm.lang === 'pl') ? _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                Zgodnie z art. 13 Rozporządzenia Parlamentu Europejskiego i Rady (UE) nr 2016/679 z dnia 27.04.2016 r. (dalej RODO), informujemy Państwa o następujących kwestiach: "), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                Pursuant to Article 13 of Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 (hereinafter “GDPR”), we hereby inform you of the following: "), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.lang === 'pl') ? _c('div', [_c('ul', {
    staticClass: "text"
  }, [_c('li', [_vm._v(" 1. Administratorem Państwa danych osobowych jest firma Bioseco SA, z siedzibą w Gdańsku (80-298), przy ul. Budowlanych 68.")]), _vm._v(" "), _c('li', [_vm._v(" 2. Wszelkie pytania dotyczące sposobu i zakresu przetwarzania Państwa danych osobowych oraz zakresu przysługujących Państwu uprawnień, prosimy kierować na adres: jacek.witt@bioseco.com.")]), _vm._v(" "), _c('li', [_vm._v(" 3. Państwa dane osobowe przetwarzamy w celu zawarcia umowy, na podstawie art. 6 ust. 1 lit. b RODO, a także na podstawie art. 6 ust. 1 lit. c RODO, w związku z obowiązkiem prawnym wynikającym z Ustawy z dnia 14.06.2024 r. o ochronie sygnalistów oraz art. 6 ust. 1 lit. f RODO, tzn. wykorzystując prawnie uzasadniony interes Administratora, jakim jest: \n                    "), _c('ol', [_vm._v("(a) kontakt telefoniczny bądź mailowy z osobą, która skontaktuje się z nami poprzez adres e-mail umieszczony na stronie: "), _c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("https://bioseco.com/contact")]), _vm._v(",")], 1), _vm._v(" "), _c('ol', [_vm._v("(b) przyjmowanie, weryfikowanie i wyjaśnianie zgłoszeń dotyczących naruszeń prawa.")])]), _vm._v(" "), _c('li', [_vm._v(" 4. Mogą Państwo zwrócić się do nas z żądaniem dostępu do swoich danych, ich sprostowania, przeniesienia, usunięcia, ograniczenia przetwarzania, jak również wnieść sprzeciw wobec ich dalszego przetwarzania w każdym momencie. W tym celu, oraz w każdym innym związanym z przetwarzaniem danych osobowych, należy kontaktować się z nami mailowo, wysyłając wiadomość na adres e-mail, bądź pocztą tradycyjną, wysyłając je na adresy wskazane w punkcie 1 powyżej. Każde zgłoszenie, zgodnie z przepisami prawa, jest przez nas rejestrowane i rozpatrywane, a jeżeli będzie możliwość jego spełnienia, zostaną Państwo poinformowani o wyniku realizacji zgłoszenia.\n                  ")]), _vm._v(" "), _c('li', [_vm._v(" 5. Dane osobowe, które nam Państwo powierzacie, przechowywane są w bazie kontrahentów, kontaktów oraz sygnalistów. Bazy te są odpowiednio zabezpieczone tak, aby nie dostały się w niepowołane ręce, ani nie zostały utracone. Dane osobowe w nich zawarte będziemy przetwarzać do momentu ustania celu przetwarzania, tj. do zakończenia współpracy bądź kontaktu, albo do chwili wycofania przez Państwo zgody na ich przetwarzanie, po czym będziemy je archiwizować przez 3 lata. W przypadku danych osobowych sygnalistów i osób wymienionych w zgłoszeniu naruszenia przepisów prawa, będą one przetwarzanie przez 3 lata od chwili wpłynięcia zgłoszenia.\n                  ")]), _vm._v(" "), _c('li', [_vm._v(" 6. Odbiorcami Państwa danych osobowych będą jedynie podmioty uprawnione do ich przetwarzania w związku z realizacją umowy bądź innego celu przetwarzania.\n                  ")]), _vm._v(" "), _c('li', [_vm._v(" 7. Nie będziemy przekazywać Państwa danych osobowych do państw trzecich, tzn. poza obszar Europejskiego Obszaru Gospodarczego.")]), _vm._v(" "), _c('li', [_vm._v(" 8. Państwa dane osobowe nie będą podlegały zautomatyzowanemu procesowi podejmowania decyzji, w tym tzw. profilowaniu.\n                  ")]), _vm._v(" "), _c('li', [_vm._v(" 9. W przypadku zidentyfikowania nieprawidłowości w przetwarzaniu danych osobowych przez Administratora, mają Państwo prawo skierować skargę do Prezesa Urzędu Ochrony Danych Osobowych, z siedzibą w Warszawie (00-923), przy ul. Stawki 2.\n                  ")]), _vm._v(" "), _c('li', [_vm._v(" 10. Podanie danych osobowych jest dobrowolne, jednakże odmowa ich podania może skutkować odmową kontaktu i/lub nawiązania współpracy, a także brakiem możliwości potwierdzenia otrzymania zgłoszenia sygnalisty w zakresie naruszenia przepisów prawa.\n                  ")])])]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('div', [_c('ul', {
    staticClass: "text"
  }, [_c('li', [_vm._v("1. The controller of your personal data is Bioseco SA, with its registered office in Gdańsk (80-298), at 68 Budowlanych Street.")]), _vm._v(" "), _c('li', [_vm._v("2. Any questions regarding the method and scope of the processing of your personal data and your rights should be directed to: jacek.witt@bioseco.com.")]), _vm._v(" "), _c('li', [_vm._v("3. We process your personal data for the purpose of concluding a contract pursuant to Article 6(1)(b) of the GDPR, and also pursuant to Article 6(1)(c) of the GDPR, due to a legal obligation arising from the Act of 14 June 2024 on the protection of whistleblowers, and pursuant to Article 6(1)(f) of the GDPR, meaning the legitimate interests of the Controller, including:\n                    "), _c('ol', [_vm._v("(a) contacting a person by phone or email who reaches out via the email address provided at: "), _c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("https://bioseco.com/contact")]), _vm._v(",")], 1), _vm._v(" "), _c('ol', [_vm._v("(b) receiving, verifying, and clarifying reports regarding legal violations.")])]), _vm._v(" "), _c('li', [_vm._v("4. You may request access to your data, rectification, portability, erasure, restriction of processing, and object to further processing at any time. For these matters and any others related to personal data processing, please contact us by email or traditional mail using the contact details provided in point 1 above. Each request is registered and considered in accordance with legal provisions. If your request can be fulfilled, you will be informed of the result.")]), _vm._v(" "), _c('li', [_vm._v("5. The personal data you entrust to us is stored in a database of contractors, contacts, and whistleblowers. These databases are properly secured against unauthorized access or loss. We will process the data until the purpose of processing ceases, i.e., the end of cooperation or contact, or until consent is withdrawn. Afterward, it will be archived for 3 years. Personal data of whistleblowers and persons mentioned in legal violation reports will be processed for 3 years from the date the report is received.")]), _vm._v(" "), _c('li', [_vm._v("6. The recipients of your personal data will be only entities authorized to process it in connection with the fulfillment of a contract or other processing purpose.")]), _vm._v(" "), _c('li', [_vm._v("7. We will not transfer your personal data to third countries, i.e., outside the European Economic Area.")]), _vm._v(" "), _c('li', [_vm._v("8. Your personal data will not be subject to automated decision-making, including profiling.")]), _vm._v(" "), _c('li', [_vm._v("9. If you identify any irregularities in the processing of your personal data by the Controller, you have the right to file a complaint with the President of the Personal Data Protection Office, located in Warsaw (00-923), at 2 Stawki Street.")]), _vm._v(" "), _c('li', [_vm._v("10. Providing personal data is voluntary; however, failure to provide it may result in the refusal of contact and/or the establishment of cooperation, as well as the inability to confirm receipt of a whistleblower's report on a legal violation.")])])]) : _vm._e()])])])])])]), _vm._v(" "), _c('footer-main')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-container"
  }, [_c('video', {
    staticClass: "header-video",
    attrs: {
      "src": "static/img/about-us/falcon.mp4",
      "autoplay": "",
      "loop": ""
    }
  })])
}]}

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-us awards",
    attrs: {
      "id": "awards"
    }
  }, [_c('header', {
    staticClass: "page-header",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('awards.hedingTopText'))
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "more-about-us white",
    attrs: {
      "href": "#top",
      "data-scroll-offset": _vm.scrollOffset,
      "data-aos": "fade-up"
    },
    on: {
      "click": _vm.smoothScroll
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('awards.seeAwards')))])])]), _vm._v(" "), _c('div', {
    staticClass: "product"
  }, [_c('div', {
    staticClass: "why-us-solution",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "elements"
  }, [_c('div', {
    staticClass: "element clearfix"
  }, [_c('div', [_c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), (_vm.lang === 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Uniejów, 06.2025 Lider Inteligentnego Rozwoju")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Leader of Intelligent Development")]) : _vm._e()]), _vm._v(" "), (_vm.lang === 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("\n                  W czerwcu 2025 roku podczas gali w Uniejowie zostaliśmy uhonorowani nagrodą „Lider Inteligentnego Rozwoju”. To wyróżnienie potwierdza naszą determinację w dążeniu do innowacji oraz rozwój oparty na nowoczesnych technologiach.\n\n                ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("\n                  Bioseco was honored with the “Leader of Intelligent Development” award. This recognition confirms our commitment to innovation and growth driven by cutting-edge technologies.\n                ")]) : _vm._e()])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "element clearfix"
  }, [_vm._m(2), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), (_vm.lang === 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("2024 Polsko–Niemiecka Nagroda Gospodarcza")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Polish-German Economic Award")]) : _vm._e()]), _vm._v(" "), (_vm.lang === 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("\n                 Bioseco otrzymało Polsko–Niemiecką Nagrodę Gospodarczą, która podkreśla nasze zasługi w budowaniu partnerskich relacji biznesowych między Polską a Niemcami. To wyróżnienie stanowi dowód na naszą skuteczność i zaangażowanie w rozwój współpracy międzynarodowej.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("\nBioseco received the Polish-German Economic Award, which highlights our contributions to building strong business partnerships between Poland and Germany. This recognition serves as proof of our effectiveness and commitment to fostering international cooperation.                ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "element clearfix"
  }, [_c('div', [_c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), (_vm.lang === 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("2023 Nagroda Pomorska Gryf Gospodarczy")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Pomeranian Economic Griffin Award")]) : _vm._e()]), _vm._v(" "), (_vm.lang === 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("\nZostaliśmy uhonorowani Nagrodą Pomorski Gryf Gospodarczy, która docenia nasz wkład w rozwój regionalnej gospodarki. To prestiżowe wyróżnienie podkreśla nasze zaangażowanie i sukcesy na Pomorzu.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("\nWe were honored with the Pomeranian Economic Griffin Award, recognizing our contribution to the development of the regional economy. This prestigious distinction highlights our commitment and achievements in the Pomerania region.                ")]) : _vm._e()])]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "element clearfix"
  }, [_vm._m(4), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), (_vm.lang === 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("2022 Orzeł Innowacji „Rzeczpospolitej”")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Eagle of Innovation")]) : _vm._e()]), _vm._v(" "), (_vm.lang === 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("\nOtrzymaliśmy prestiżową nagrodę Orzeł Innowacji „Rzeczpospolitej”, która wyróżnia naszą innowacyjność i nowatorskie rozwiązania. To potwierdzenie naszego zaangażowania w rozwój technologiczny i ciągłe poszukiwanie innowacji.                ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("\nBioseco received the prestigious “Rzeczpospolita” Eagle of Innovation Award, which recognizes our innovation and pioneering solutions. This accolade confirms our dedication to technological development and continuous pursuit of innovation.    ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "element clearfix"
  }, [_c('div', [_c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), (_vm.lang === 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("2021 Polski Produkt Przyszłości")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Polish Product of the Future")]) : _vm._e()]), _vm._v(" "), (_vm.lang === 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("\nzdobyliśmy wyróżnienie Polski Produkt Przyszłości, które podkreśla innowacyjny charakter naszego rozwiązania. To potwierdzenie naszej wizji i zaangażowania w tworzenie nowoczesnych technologii.               ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("\nWe were awarded the Polish Product of the Future distinction, which highlights the innovative nature of our solution. This recognition confirms our vision and commitment to developing modern technologies.    ")]) : _vm._e()])]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "element clearfix"
  }, [_vm._m(6), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), (_vm.lang === 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("2021 Zielony Orzeł \"Rzeczpospolitej\"")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("“Rzeczpospolita” Green Eagle")]) : _vm._e()]), _vm._v(" "), (_vm.lang === 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("\nOtrzymaliśmy Zielonego Orła „Rzeczpospolitej”, nagrodę za nasze działania na rzecz zrównoważonego rozwoju i ekologii. To wyróżnienie podkreśla nasze zaangażowanie w ochronę środowiska i odpowiedzialność społeczną.              ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("\n\nBioseco received the “Rzeczpospolita” Green Eagle Award for our efforts in sustainable development and environmental protection. This recognition highlights our commitment to environmental stewardship and social responsibility.    ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "element clearfix"
  }, [_c('div', [_c('div', {
    staticClass: "text-box"
  }, [_vm._m(7), _vm._v(" "), (_vm.lang === 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Genewa-Bruksela, 10.2020.")]), _vm._v("\n                  Bioseco znalazła się w gronie zwycięzców programu Tech Tour Photonics.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Geneva-Brussels, 10.2020.")]), _vm._v("\n                  Bioseco was among the winners of the Tech Tour Photonics program.\n                ")]) : _vm._e()])]), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('div', {
    staticClass: "element clearfix"
  }, [_vm._m(9), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), (_vm.lang === 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("50 Najbardziej Kreatywnych")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("50 Most Creative People in Business")]) : _vm._e()]), _vm._v(" "), (_vm.lang === 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Warszawa, 28.09.2020.")]), _vm._v("\n                  II Miejsce wśród 50 Najbardziej Kreatywnych Ludzi w Biznesie dla Krzysztofa Paszka, współzałożyciela\n                  Bioseco. Nagroda zdobyta na dziesiątej Jubileuszowej Gali pod patronatem Ministerstwa Rozwoju, PKN\n                  Orlen SA, Google for Startups, Santander Bank Polska, Krajowa Izba Gospodarcza.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Warsaw, September 28, 2020.")]), _vm._v("2nd place among the 50 Most Creative People in Business for Krzysztof\n                  Paszek, co-founder of Bioseco. The award was won at the tenth Jubilee Gala under the patronage of the\n                  Polish Ministry of Development, PKN Orlen SA, Google for Startups, Santander Bank Polska, the Polish\n                  Chamber of Commerce.\n                ")]) : _vm._e()])]), _vm._v(" "), _vm._m(10)]), _vm._v(" "), _c('div', {
    staticClass: "element clearfix"
  }, [_c('div', [_c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), (_vm.lang === 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Miesięcznik „My Company”")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Monthly newspaper \"My Company\"")]) : _vm._e()]), _vm._v(" "), (_vm.lang === 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Warszawa, 08.2019")]), _vm._v("\n                  Bioseco w gronie dwudziestu firm, które zmienią Polskę według miesięcznika „My Company”.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Warsaw, 08.2019.")]), _vm._v("\n                  Bioseco among twenty companies that will change Poland according to the monthly newspaper \"My\n                  Company\".\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div')]), _vm._v(" "), _c('div', {
    staticClass: "element clearfix"
  }, [_vm._m(11), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), (_vm.lang === 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Bioseco startupem pozytywnego wpływu")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Bioseco - Positive Impact Startup")]) : _vm._e()]), _vm._v(" "), (_vm.lang === 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Warszawa, 04.2019.")]), _vm._v("\n                  Bioseco startupem pozytywnego wpływu. W pierwszej edycji Raportu Startupów Pozytywnego Wpływu 2019\n                  organizowanego przez Kozminski Business Hub wśród innowacyjnych polskich startupów znalazło się\n                  Bioseco.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Warsaw, 04.2019.")]), _vm._v("\n                  Bioseco - Positive Impact Startup. In the first edition of the 2019 Positive\n                  Impact Startup Report organized by Kozminski Business Hub, Bioseco was among the innovative Polish\n                  startups.")]) : _vm._e()])]), _vm._v(" "), _vm._m(12)]), _vm._v(" "), _c('div', {
    staticClass: "element clearfix"
  }, [_c('div', [_c('div', {
    staticClass: "text-box"
  }, [_vm._m(13), _vm._v(" "), (_vm.lang === 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Parlament Europejski. Bruksela, 2019.")]), _vm._v("\n                  Bioseco znalazło się w gronie firm z obszaru innowacyjnych technologii wybranych przez jury IEEE\n                  Entrepreneurship Stars, organizacji pod patronatem Parlamentu Europejskiego.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Brussels, 2019.")]), _vm._v("\n                  2018 IEEE N3XT® STAR. Bioseco is among the companies in the area of ​​innovative\n                  technologies selected by the jury of IEEE Entrepreneurship Stars, an organization under the patronage\n                  of the European Parliament.\n                ")]) : _vm._e()])]), _vm._v(" "), _vm._m(14)]), _vm._v(" "), _c('div', {
    staticClass: "element clearfix"
  }, [_vm._m(15), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "text-box"
  }, [_vm._m(16), _vm._v(" "), (_vm.lang === 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Bruksela, 29.11.2018.")]), _vm._v("\n                  Wygrana w prestiżowym konkursie EUtop50 dla innowatorów z całej Unii Europejskiej. Dziesiąta edycja\n                  konkursu organizowanego przez Parlament Europejski.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Brussels, 29/11/2018.")]), _vm._v("\n                  Winner of the prestigious EUtop50 Innovators, contest for young companies\n                  from all over the European Union. The tenth edition of the competition organized by the European\n                  Parliament.\n                ")]) : _vm._e()])]), _vm._v(" "), _vm._m(17)]), _vm._v(" "), _c('div', {
    staticClass: "element clearfix"
  }, [_c('div', [_c('div', {
    staticClass: "text-box"
  }, [_vm._m(18), _vm._v(" "), (_vm.lang === 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Gdańsk, 08.04.2015.")]), _vm._v("\n                  Pomorskie Sztormy, Zwycięzca konkursu w kategorii Młoda Firma Roku 2014. 10 edycja plebiscytu Gazety\n                  Wyborczej i Marszałka Województwa Pomorskiego.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Gdańsk, April 8, 2015.")]), _vm._v("\n                  “Pomorskie Sztormy”, Winner of the competition in the Young Company of the\n                  Year 2014 category. 10th edition of the Gazeta Wyborcza and the Marshal of the Pomeranian Voivodeship.\n                ")]) : _vm._e()])]), _vm._v(" "), _vm._m(19)]), _vm._v(" "), _c('div', {
    staticClass: "element clearfix"
  }, [_vm._m(20), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), (_vm.lang === 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Lider PPNT")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Leader of the PPNT")]) : _vm._e()]), _vm._v(" "), (_vm.lang === 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Gdynia 12.2014.")]), _vm._v("\n                  Lider Pomorskiego Parku Naukowo-Technologicznego w Gdyni. Nagroda przyznana przez społeczność prawie\n                  trzystu firm z obszaru nowych technologii.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Gdynia 12.2014.")]), _vm._v("\n                  Leader of the Pomeranian Science and Technology Park in Gdynia. The award was\n                  granted by a community of three hundred innovative companies.\n                ")]) : _vm._e()])]), _vm._v(" "), _vm._m(21)]), _vm._v(" "), _c('div', {
    staticClass: "element clearfix"
  }, [_c('div', [_c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), (_vm.lang === 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Nagroda Grand Prix Innowacje 2014")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Grand Prix Innovation 2014 award")]) : _vm._e()]), _vm._v(" "), (_vm.lang === 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Gdańsk, 24.10.2014.")]), _vm._v("\n                  Nagroda Grand Prix Innowacje 2014. Technikon, 10 Targi Techniki Przemysłowej Nauki i Innowacji.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Gdańsk, October 24, 2014.")]), _vm._v("\n                  Grand Prix Innovation 2014 award. Technikon, 10th Industrial Technology,\n                  Science and Innovation Fairs.\n                ")]) : _vm._e()])]), _vm._v(" "), _vm._m(22)])])])]), _vm._v(" "), _c('footer-main')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-container"
  }, [_c('video', {
    staticClass: "header-video",
    attrs: {
      "src": "static/img/about-us/falcon.mp4",
      "autoplay": "",
      "loop": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "src": "/static/img/awards/Leader_of_Intelligent_Development.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "/static/img/awards/Polish-German_Economic_Award.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "src": "/static/img/awards/Pomeranian_Economic_Griffin_Award.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "/static/img/awards/Eagle_of_Innovation.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "/static/img/awards/Polish_Product_of_the_Future.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "/static/img/awards/Rzeczpospolita_Green_Eagle.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Tech Tour Photonics")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "/static/img/media/photonics.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide-mobile"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/media/top50.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "show-mobile"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/media/top50.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide-mobile"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/media/pozytywny.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "show-mobile"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/media/pozytywny.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("2018 IEEE N3XT® STAR.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "/static/img/media/iee_resized.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide-mobile"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/media/eu50_resized.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("EUtop50")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "show-mobile"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/media/eu50_resized.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("“Pomorskie Sztormy”")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "/static/img/media/sztormy.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide-mobile"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/media/lider-ppnt.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "show-mobile"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/media/lider-ppnt.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "/static/img/media/grandprix.jpg"
    }
  })])
}]}

/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product bps",
    class: {
      contrasted: _vm.isPageContrasted, fontBigger: _vm.isFontBigger
    }
  }, [_c('header', {
    staticClass: "page-header",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.lang === 'pl') ? _c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("System ochrony ptaków na Farmy Wiatrowe")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Bird Protection System for Wind Farms")]) : _vm._e(), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-left",
      "data-aos-delay": "150"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-hover"
  }, [_c('router-link', {
    staticClass: "btn orange",
    attrs: {
      "to": "/products/farms/presentation",
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('component.watchPresentation'))), _c('span')])], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-hover",
    on: {
      "click": function($event) {
        _vm.$modal.show('video-static')
      }
    }
  }, [_c('div', {
    staticClass: "btn orange",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_vm._v(_vm._s(_vm.$t('component.watchVideo'))), _c('span')])])])]), _vm._v(" "), _c('div', {
    staticClass: "why-us-solution",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "elements"
  }, [_c('div', {
    staticClass: "element bps clearfix"
  }, [_c('div', {
    staticClass: "text-box"
  }, [(_vm.lang === 'pl') ? _c('ul', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('ul', [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                  Celem projektu jest stworzenie systemu, który w niezawodny sposób będzie wykrywał ptaki na farmach wiatrowych. Będzie on oparty na najnowszych technologiach, wykorzystywał stereoskopię i edge computing, a testy terenowe będziemy wykonywać na farmach wiatrowych, które należą do naszego partnera strategicznego PGE EO SA. Realizacja projektu trwa 3 lata i skończy się w 2021 r.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Tytuł projektu:"), _c('br'), _vm._v("\nRealizacja prac B+R, prowadzących do wdrożenia nowego rozwiązania - MULTIREJESTRATOR PLUS dla monitorowania i kontroli systemu elektroenergetycznego pod kątem efektywności eksploatacji, wydłużenia czasu życia i optymalizacji oddziaływania na otoczenie farm wiatrowych.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                  Cel projektu:"), _c('br'), _vm._v("\nCelem projektu jest przeprowadzenie prac B+R prowadzących do opracowania prototypu systemu radiowo wizyjnego, który pozwoli podnieść sprawność i wydajność pracy turbin wiatrowych.\n                "), _c('br'), _c('br'), _c('br'), _vm._v("\n                Wartosć projektu:"), _c('br'), _vm._v("\n                4 109 660,41PLN\n                  "), _c('br'), _c('br'), _vm._v("\n                  Dofinansowanie projektu z UE:"), _c('br'), _vm._v("\n                3 021 687.62PLN\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                The aim of the project is to create a system that will reliably detect birds on wind farms. It will be based on the latest technologies, using stereoscopy and edge computing. We will perform field tests on wind farms that belong to our strategic partner PGE EO SA. The project will be implemented for 3 years and will end in 2021.\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Project title:"), _c('br'), _vm._v("\nRealization of R&D works leading to the implementation of a new solution - MULTIREJESTRATOR PLUS for monitoring and control of the power system in terms of operational efficiency, the life span extending and optimizing the impact on the surrounding wind farms.\n  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "dot"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("\n                 The aim of the project is to carry out R&D works leading to the development of a radio and video prototype system that will improve the efficiency and performance of wind turbines, which will affect the growth of innovation in the national electricity sector. The project will be implemented by a qualified project team in 4 research tasks, the aim of which will be to design a complete vision system that allows the prediction of bird traffic near wind farms. The project will end with the creation of technical documentation enabling the implementation of MULTIREJESTRATOR PLUS technology on the market. It is planned to cover the results of R&D works with patent protection on the Polish, British and then European markets.\nMULTIREJESTRATOR PLUS will ensure uninterrupted or rarely interrupted work of wind farms, through the active protection of valuable bird species.\n                  "), _c('br'), _c('br'), _c('br'), _vm._v("\n                Project value:"), _c('br'), _vm._v("\n                4 109 660,41PLN\n                  "), _c('br'), _c('br'), _vm._v("\n                 Amount of founding from UE:"), _c('br'), _vm._v("\n                3 021 687.62PLN\n                ")])])
}]}

/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scroll-top",
    class: {
      'visible': _vm.visible
    },
    attrs: {
      "data-scroll-offset": "0"
    },
    on: {
      "click": _vm.smoothScroll
    }
  }, [_c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "text",
    staticStyle: {
      "visibility": "hidden"
    }
  }, [_vm._v(_vm._s(_vm.$t('go_up')))])])
},staticRenderFns: []}

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'home-anim-active': _vm.isHomeAnimActive
    },
    attrs: {
      "id": "home"
    }
  }, [_c('div', {
    staticClass: "page-shadow"
  }, [_c('v-touch', {
    ref: "tapper",
    on: {
      "swiperight": _vm.prevGround,
      "swipeleft": _vm.nextGround
    }
  }, [_c('div', {
    staticClass: "home"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "container clearfix home-container"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('transition', {
    attrs: {
      "name": "headerText"
    }
  }, [(!_vm.isHomeAnimActive || _vm.isHomeAnimActive && _vm.mounted) ? _c('h2', [_vm._v(_vm._s(_vm.$t('home.headingTopText')))]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "firstText"
    }
  }, [(!_vm.isHomeAnimActive || _vm.isHomeAnimActive && _vm.mounted) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.headingSubText'))
    }
  }) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "secondText"
    }
  }, [(!_vm.isHomeAnimActive || _vm.isHomeAnimActive && _vm.mounted) ? _c('span', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.headingBottomText'))
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mobile-height",
    class: {
      'anim-height': _vm.animFinished || !_vm.isHomeAnimActive
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "boxes"
    }
  }, [(!_vm.isHomeAnimActive || _vm.isHomeAnimActive && _vm.mounted) ? _c('div', {
    staticClass: "boxes"
  }, [_c('div', {
    staticClass: "arrows"
  }, [_c('div', {
    staticClass: "arrow arrow-prev",
    on: {
      "click": _vm.prevGround
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arrow arrow-next",
    on: {
      "click": _vm.nextGround
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "box-1"
    }
  }, [_c('router-link', {
    staticClass: "box farm-box",
    class: {
      current: _vm.grounds[_vm.mobileOption] === 'farm', next: _vm.mobileOption < 0, prev: _vm.mobileOption > 0
    },
    attrs: {
      "to": "/products/farms/presentation",
      "id": "farmGround"
    }
  }, [_c('div', {
    on: {
      "mouseover": _vm.farmHover,
      "mouseleave": _vm.farmLeave
    }
  }, [_c('div', {
    staticClass: "area"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(235),
      "alt": "wind-farm"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "big"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.farms'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_c('p', [_vm._v("\n                        Bioseco BIRD PROTECTION SYSTEM (BPS)\n                      ")])])])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "box-2"
    }
  }, [_c('router-link', {
    staticClass: "box big airport-box",
    class: {
      current: _vm.grounds[_vm.mobileOption] === 'airport', next: _vm.mobileOption < 1, prev: _vm.mobileOption > 1
    },
    attrs: {
      "to": "/products/airport/presentation",
      "id": "airportGround"
    }
  }, [_c('div', {
    on: {
      "mouseover": _vm.airportHover,
      "mouseleave": _vm.airportLeave
    }
  }, [_c('div', {
    staticClass: "area"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(70),
      "alt": "airport"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "big"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.airports'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_c('p', [_vm._v("\n                        Bioseco AIRPORT FAUNA MONITORING SYSTEM (AFMS)\n                      ")])])])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "box-3"
    }
  }, [_c('router-link', {
    staticClass: "box area-box",
    class: {
      current: _vm.grounds[_vm.mobileOption] === 'area', next: _vm.mobileOption < 2, prev: _vm.mobileOption > 2
    },
    attrs: {
      "to": "/products/area/presentation",
      "id": "forestGround"
    }
  }, [_c('div', {
    on: {
      "mouseover": _vm.forestHover,
      "mouseleave": _vm.forestLeave
    }
  }, [_c('div', {
    staticClass: "area"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(71),
      "alt": "area"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "big"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.area'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_c('p', [_vm._v("\n                        Bioseco BIRD PROTECTION SYSTEM (BPS)\n                      ")])])])])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "scroll"
    }
  }, [(!_vm.isHomeAnimActive || _vm.isHomeAnimActive && _vm.mounted) ? _c('a', {
    staticClass: "more-about-us",
    attrs: {
      "href": "#aboutUs",
      "data-scroll-offset": "60"
    },
    on: {
      "click": function (e) {
        _vm.smoothScroll(e);
        this$1.animFinished = true;
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('moreAboutUs')))])]) : _vm._e()])], 1)])])]), _vm._v(" "), _c('FooterOrange', {
    attrs: {
      "isAnim": _vm.isHomeAnimActive
    }
  })], 1), _vm._v(" "), _c('AboutUs', {
    attrs: {
      "isHome": true
    }
  })], 1)
},staticRenderFns: []}

/***/ })
],[150]);


// WEBPACK FOOTER //
// static/js/app.edc7a8082adc05b975c4.js